var mi = Object.defineProperty, Oi = Object.defineProperties;
var zi = Object.getOwnPropertyDescriptors;
var So = Object.getOwnPropertySymbols;
var Ci = Object.prototype.hasOwnProperty, Li = Object.prototype.propertyIsEnumerable;
var bo = (e, t, n) => t in e ? mi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, oe = (e, t) => {
  for (var n in t || (t = {}))
    Ci.call(t, n) && bo(e, n, t[n]);
  if (So)
    for (var n of So(t))
      Li.call(t, n) && bo(e, n, t[n]);
  return e;
}, ie = (e, t) => Oi(e, zi(t));
var Le = (e, t, n) => new Promise((o, r) => {
  var a = (l) => {
    try {
      s(n.next(l));
    } catch (u) {
      r(u);
    }
  }, c = (l) => {
    try {
      s(n.throw(l));
    } catch (u) {
      r(u);
    }
  }, s = (l) => l.done ? o(l.value) : Promise.resolve(l.value).then(a, c);
  s((n = n.apply(e, t)).next());
});
import { computed as V, unref as i, provide as pn, inject as io, ref as te, defineComponent as $, openBlock as I, createElementBlock as S, normalizeClass as x, createCommentVNode as ee, toDisplayString as Z, toRefs as le, createBlock as _, resolveDynamicComponent as Dr, mergeProps as pr, withCtx as ye, createElementVNode as C, renderSlot as Ie, Fragment as Ae, renderList as we, createTextVNode as fe, normalizeStyle as $e, useSlots as Ir, useAttrs as vi, watch as mt, onMounted as Ve, Teleport as It, onUnmounted as In, nextTick as fr, withDirectives as Ue, createVNode as ce, vModelText as jr, withKeys as hr, withModifiers as ao, Transition as wr, vShow as ki, pushScopeId as Si, popScopeId as bi, h as Er, render as qn, useSSRContext as Qi, onServerPrefetch as Ui, isRef as Bi } from "vue";
import Yi from "js-cookie";
import { LogReport as Ri } from "@bilibili-intl/log-report";
import { useFetchInstance as Gi, slimImg as Tr, browserEnv as Pi } from "@bilibili-intl/utils";
import { throttle as Fi, debounce as fn } from "throttle-debounce";
import { VideoCard as xr } from "@bilibili-intl/video-card";
const Hi = "data:image/svg+xml;base64,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", Vi = "data:image/svg+xml;base64,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", Zi = {
  apiUrl: "//uat-api.bilibili.tv",
  studioUrl: "http://uat-studio.bilibili.tv",
  loginUrl: "//uat-passport.bilibili.tv",
  domain: "http://uat-www.bilibili.tv"
}, Wi = {
  apiUrl: "//uat-api.bilibili.tv",
  studioUrl: "http://uat-studio.bilibili.tv",
  loginUrl: "//uat-passport.bilibili.tv",
  domain: "http://uat-www.bilibili.tv"
}, Ji = {
  apiUrl: "//pre-api.bilibili.tv",
  studioUrl: "http://pre-studio.bilibili.tv",
  loginUrl: "//pre-passport.bilibili.tv",
  domain: "http://pre-www.bilibili.tv"
}, mr = {
  apiUrl: "//api.bilibili.tv",
  studioUrl: "https://studio.bilibili.tv",
  loginUrl: "//passport.bilibili.tv",
  domain: "https://www.bilibili.tv"
}, Ki = /* @__PURE__ */ new Map([
  ["dev", Zi],
  ["uat", Wi],
  ["pre", Ji],
  ["prod", mr]
]), jn = (e) => {
  var t;
  return (t = Ki.get(e)) != null ? t : mr;
}, qi = /* @__PURE__ */ new Map([
  ["en", {
    searchPlaceholder: "Search",
    searchHistory: "Search History",
    login: "Log in",
    logout: "Log Out",
    openApp: "Open App",
    myProfile: "My Profile",
    creatorCenter: "Creator Center",
    account: "Account",
    choose: "Select your language",
    chooseLang: "Choose your language",
    language: "Language",
    loading: "Loading...",
    noResult: "No relevant results were found",
    upload: "Upload",
    syncHistory: "Sign in to sync History",
    syncMyList: "Sign in to sync My List",
    nothing: "There is nothing here",
    viewAll: "View All",
    viewMore: "View More",
    history: "History",
    fav: "My List",
    premium: "Premium",
    historyMove: "History has been moved here.",
    favMove: "History and My List have been moved here.",
    gotIt: "Got It",
    loginEnjoy: "Log in and enjoy the followings:",
    freeVideo: "Free HD videos",
    syncBrowsing: "Synchronize browsing records of all ends",
    sendComment: "Send comments",
    watch: "Watch exclusive contents",
    tapHereTo: "Tap here to ",
    createAccount: "create an account",
    loginNow: "Log in Now",
    create: "Create",
    uploadVideo: "Upload Video",
    myVideos: "My Videos",
    dataAnalysis: "Data Analysis",
    manageInteractions: "Manage Interactions",
    sendFeedback: "Send Feedback",
    message: "System Message",
    app: "App",
    downTitle: "Download the App to enjoy more features",
    downDesc1: "Higher video quality",
    downDesc2: "Smoother experience",
    downDesc3: "Download videos and watch offline",
    QRDesc: "Scan the QR code or copy the link to your phone to download the App.",
    QRDescLink: "copy the link",
    copySuccess: "Link copied"
  }],
  ["th", {
    searchPlaceholder: "ค้นหา",
    searchHistory: "ประวัติการค้นหา",
    login: "เข้าสู่ระบบทันที",
    logout: "ออกจากระบบ",
    openApp: "เปิดแอป",
    myProfile: "โปรไฟล์ของฉัน",
    creatorCenter: "ครีเอเตอร์เซนเตอร์",
    account: "บัญชี",
    choose: "เลือกภาษา",
    chooseLang: "เลือกภาษา",
    language: "ภาษา",
    loading: "กำลังประมวลผล ...",
    noResult: "ขออภัย, ไม่พบรายการอนิเมะจากการค้นหา",
    upload: "อัพโหลด",
    syncHistory: "เข้าสู่ระบบเพื่อซิงค์ประวัติ",
    syncMyList: "เข้าสู่ระบบเพื่อซิงค์รายการโปรด",
    nothing: "ไม่พบอะไรเลย",
    viewAll: "ดูทั้งหมด",
    history: "ประวัติ",
    fav: "รายการโปรด",
    premium: "Premium",
    historyMove: "ประวัติย้ายมาที่นี่แล้ว",
    favMove: "ประวัติและรายการโปรดย้ายมาที่นี่แล้ว",
    gotIt: "เข้าใจ",
    loginEnjoy: "หลังจากเข้าสู่ระบบคุณสามารถเพลิดเพลินกับ :",
    freeVideo: "รับชมวิดีโอ HD ฟรี",
    syncBrowsing: "การซิงก์บันทึกการรับชมจากหลากหลายอุปกรณ์",
    sendComment: "ส่ง comment",
    watch: "รับชมเนื้อหาลิขสิทธิ์พิเศษ",
    tapHereTo: "การใช้ครั้งแรก คลิกที่นี่เพื่อ",
    createAccount: "ลงทะเบียน",
    loginNow: "เข้าสู่ระบบทันที",
    create: "สร้างสรรค์",
    uploadVideo: "อัปโหลดวิดีโอ",
    myVideos: "วิดีโอของฉัน",
    dataAnalysis: "การวิเคราะห์ข้อมูล",
    manageInteractions: "การจัดการการโต้ตอบ",
    sendFeedback: "ส่งข้อเสนอแนะ",
    app: "แอป",
    downTitle: "ดาวน์โหลดแอป สัมผัสประสบการณ์ที่ยอดเยี่ยมมากขึ้น",
    downDesc1: "คุณภาพวิดีโอที่สูงขึ้น",
    downDesc2: "ลื่นไหลมากขึ้น ไม่มีสะดุด",
    downDesc3: "ดาวน์โหลดเพื่อรับชมออฟไลน์ได้ตลอดเวลา",
    QRDesc: "สแกนรหัส QR ด้านล่างหรือคัดลอกลิงก์แล้วส่งไปยังโทรศัพท์มือถือเพื่อดาวน์โหลดแอป",
    QRDescLink: "คัดลอกลิงก์",
    copySuccess: "คัดลอกสำเร็จ",
    viewMore: "ดูเพิ่มเติม",
    message: "แจ้งเตือนจากระบบ"
  }],
  ["id", {
    searchPlaceholder: "Cari",
    searchHistory: "Sejarah pencarian",
    login: "Login",
    logout: "Logout",
    openApp: "Buka Aplikasi",
    myProfile: "Profil saya",
    creatorCenter: "Pusat Kreator",
    account: "Info akun",
    choose: "Pilih bahasa",
    chooseLang: "Pilih bahasa",
    language: "Bahasa",
    loading: "Memuat lainnya...",
    noResult: "Tidak ada hasil relevan yang ditemukan",
    upload: "Unggah",
    syncHistory: "Login untuk sinkronisasi riwayat",
    syncMyList: "Login untuk sinkronisasi Favorit Saya",
    nothing: "Tidak ada apapun di sini",
    viewAll: "Lihat semua",
    history: "Sejarah",
    fav: "Favorit Saya",
    premium: "Premium",
    historyMove: "Anda dapat melihat riwayat di sini",
    favMove: "Riwayat dan Favorit Saya ada di sini",
    gotIt: "Mengerti",
    loginEnjoy: "Setelah login, Anda dapat menikmati:",
    freeVideo: "Tonton video HD secara gratis",
    syncBrowsing: "Sinkronisasi riwayat penelusuran multi-perangkat",
    sendComment: "Kirimkan komentar comment",
    watch: "Tonton konten hak cipta khusus",
    tapHereTo: "Untuk pertama kalinya, ",
    createAccount: "klik untuk mendaftar",
    loginNow: "Segera Login",
    create: "Buat",
    uploadVideo: "Unggah Video",
    myVideos: "Video Saya",
    dataAnalysis: "Analisis Data",
    manageInteractions: "Kelola Interaksi",
    sendFeedback: "Pengiriman Feedback",
    app: "Aplikasi",
    downTitle: "Unduh aplikasi, nikmati pengalaman yang lebih menarik",
    downDesc1: "Kualitas video terbaik",
    downDesc2: "Lebih lancar tanpa buffering",
    downDesc3: "Unduh kapan pun dan tonton offline",
    QRDesc: "Pindai kode QR atau salin tautan dan unduh dari ponsel",
    QRDescLink: "salin tautan",
    copySuccess: "Berhasil disalin",
    viewMore: "Lihat lebih banyak",
    message: "Pemberitahuan Sistem"
  }],
  ["vi", {
    searchPlaceholder: "Tìm kiếm",
    searchHistory: "Lịch sử tìm kiếm",
    login: "Đăng nhập",
    logout: "Thoát ra",
    openApp: "Mở App",
    myProfile: "Trung tâm cá nhân",
    creatorCenter: "Trung tâm sáng tạo",
    account: "Tài khoản",
    choose: "Chọn ngôn ngữ",
    chooseLang: "Lựa chọn ngôn ngữ",
    language: "Ngôn ngữ",
    loading: "Đang tải...",
    noResult: "Xin lỗi. Không tìm thấy kết quả nào phù hợp",
    upload: "Tải lên",
    syncHistory: "Đăng nhập để đồng bộ Lịch sử",
    syncMyList: "Đăng nhập để đồng bộ Mục yêu thích",
    nothing: "Không thấy gì đâu",
    viewAll: "Xem tất cả",
    history: "Lịch sử",
    fav: "Yêu thích",
    premium: "Premium",
    historyMove: "Xem Lịch sử ở đây",
    favMove: "Xem Lịch sử và Mục yêu thích ở đây",
    gotIt: "Đã biết",
    loginEnjoy: "Đăng nhập để hưởng các quyền lợi:",
    freeVideo: "Xem video chất lượng HD miễn phí",
    syncBrowsing: "Đồng bộ lịch sử lướt xem ở các thiết bị khác nhau",
    sendComment: "Gửi comment",
    watch: "Xem nội dung độc quyền",
    tapHereTo: "Lần đầu đăng nhập, nhấn để ",
    createAccount: "đăng ký tài khoản",
    loginNow: "Đăng nhập ngay",
    create: "Sáng tạo",
    uploadVideo: "Đăng video",
    myVideos: "Quản lý video",
    dataAnalysis: "Phân tích dữ liệu",
    manageInteractions: "Quản lý tương tác",
    sendFeedback: "Gửi phản hồi",
    app: "App",
    downTitle: "Tải App, trải nghiệm nhiều đặc sắc",
    downDesc1: "Hình ảnh sắc nét",
    downDesc2: "Thao tác mượt mà, không ngắt đoạn",
    downDesc3: "Tải mọi lúc, xem ngoại tuyến",
    QRDesc: "Quét mã QR bên dưới hoặc sao chép liên kết và gửi đến điện thoại di động của bạn để tải phiên bản App.",
    QRDescLink: "sao chép liên kết",
    copySuccess: "Đã sao chép thành công",
    viewMore: "Xem thêm",
    message: "Thông báo hệ thống"
  }],
  ["ms", {
    searchPlaceholder: "Cari",
    searchHistory: "Sejarah carian",
    login: "Log masuk",
    logout: "Log keluar",
    openApp: "Buka Aplikasi",
    myProfile: "Profil saya",
    creatorCenter: "Pusat pencipta",
    account: "Akaun",
    choose: "Pilih bahasa",
    chooseLang: "Pilih bahasa",
    language: "Bahasa",
    loading: "Memuatkan lagi...",
    noResult: "Tiada hasil yang berkaitan ditemui",
    upload: "Muat naik",
    syncHistory: "Log in untuk segerakkan sejarah anda",
    syncMyList: "Log in untuk segerakkan senarai anda",
    nothing: "Tiada apa-apa di sini",
    viewAll: "Lihat semua",
    history: "Sejarah",
    fav: "Senarai saya",
    premium: "Premium",
    historyMove: "Sejarah telah dipindahkan ke sini",
    favMove: "Sejarah dan senarai saya telah dipindahkan ke sini",
    gotIt: "Maklum",
    loginEnjoy: "Selepas log masuk, anda boleh nikmati faedah berikut:",
    freeVideo: "Tonton video HD secara percuma",
    syncBrowsing: "Segerakan sejarah tontonan pada multi-peranti",
    sendComment: "Siarkan komen dan komen",
    watch: "Tonton video hak cipta khas",
    tapHereTo: "Pertama kali guna, klik untuk ",
    createAccount: "mendaftar",
    loginNow: "Log masuk sekarang",
    create: "Cipta",
    uploadVideo: "Muat Naik Video",
    myVideos: "Video Saya",
    dataAnalysis: "Analisis Data",
    manageInteractions: "Pengurusan Interaksi",
    sendFeedback: "Penghantaran maklum balas",
    app: "Aplikasi",
    downTitle: "Muat turun aplikasi untuk menikmati lebih banyak fungsi",
    downDesc1: "Resolusi video terbaik",
    downDesc2: "Pengalaman yang lebih lancar, elakkan rangkaian lag",
    downDesc3: "Muat turun bila-bila masa, tonton di luar rangkaian",
    QRDesc: "Mengimbas kod QR atau salin pautan ke telefon anda untuk muat turun aplikasi",
    QRDescLink: "salin pautan",
    copySuccess: "Berjaya disalin",
    viewMore: "Lihat lebih banyak",
    message: "Peringatan Sistem"
  }]
]), ft = [
  { label: "English", value: "en" },
  { label: "ภาษาไทย", value: "th" },
  { label: "Tiếng Việt", value: "vi" },
  { label: "Bahasa Indonesia", value: "id" },
  { label: "Bahasa Melayu", value: "ms" }
], Qo = /* @__PURE__ */ new Map([
  ["en", "en_US"],
  ["th", "th_TH"],
  ["vi", "vi_VN"],
  ["id", "id_ID"],
  ["ms", "ms_MY"]
]), Or = Symbol("headerContext"), Xi = (e) => {
  const t = ie(oe({}, e), {
    config: V(() => jn(i(e.env))),
    lang: V(() => qi.get(i(e.locale)))
  });
  pn(Or, t);
}, re = () => {
  const e = io(Or);
  if (!e)
    throw new Error("inject must use after provider");
  return e;
}, _i = () => {
  const e = typeof window != "undefined" ? Ri({ logId: { pv: "", click: "000017", expose: "" } }) : null;
  return { sendEvent: (n, o) => {
    e && e.sendClick({ event: n, value: o != null ? o : {} });
  } };
}, Te = _i(), Uo = "bstar_from";
var zr = /* @__PURE__ */ ((e) => (e.historyCard = "bstar-web.header.history.all", e))(zr || {});
const De = {
  clickBilibili: () => {
    Te.sendEvent(
      "header_bilibili_click"
      /* clickBilibili */
    );
  },
  clickSearchHistory: (e) => {
    Te.sendEvent("search_history_click", e);
  },
  clickSearchHotKeyword: (e) => {
    Te.sendEvent("search_hotKeyword_click", e);
  },
  clickSearchSug: (e) => {
    Te.sendEvent("search_sug_click", e);
  },
  clickLangSetting: () => {
    Te.sendEvent(
      "header_lang_setting_click"
      /* clickLangSetting */
    );
  },
  clickUpload: () => {
    Te.sendEvent(
      "header_upload_click"
      /* clickUpload */
    );
  },
  clickSearch: () => {
    Te.sendEvent(
      "header_search_click"
      /* clickSearch */
    );
  },
  clickFav: () => {
    Te.sendEvent(
      "fav_click"
      /* clickFav */
    );
  },
  clickFavHoverCards: (e) => {
    Te.sendEvent("fav_hover_cards_click", e);
  },
  showFavHoverCards: (e, t) => ({ id: "fav_hover_cards_show", key: e, data: t }),
  clickHistory: () => {
    Te.sendEvent(
      "history_click"
      /* clickHistory */
    );
  },
  clickPremium: () => {
    Te.sendEvent(
      "premium_click"
      /* clickPremium */
    );
  },
  clickHistoryHoverCards: (e) => {
    Te.sendEvent("history_hover_cards_click", e);
  },
  showHistoryHoverCards: (e, t) => ({ id: "history_hover_cards_show", key: e, data: t }),
  clickLogout: () => {
    Te.sendEvent(
      "logout_click"
      /* clickLogout */
    );
  },
  clickLoginPanelLogin: () => {
    Te.sendEvent(
      "guide_login_popup_click"
      /* clickLoginPanelLogin */
    );
  },
  clickLoginPanelRegister: () => {
    Te.sendEvent(
      "guide_register_popup_click"
      /* clickLoginPanelRegister */
    );
  },
  exposeLoginPanel: () => ({
    id: "guide_login_popup_show"
    /* exposeLoginPanel */
  }),
  clickCreate: () => {
    Te.sendEvent(
      "create_click"
      /* clickCreate */
    );
  },
  clickCreateHoverCards: (e) => {
    Te.sendEvent("create_hover_cards_click", { pos: e });
  },
  showCreateHoverCards: () => ({
    id: "create_hover_cards_show"
    /* showCreateHoverCards */
  })
}, $i = () => {
  const { env: e, locale: t } = re(), { apiUrl: n } = jn(e.value), o = Gi({ baseURL: `${n}/x/v1/web/msgfeed` });
  return {
    // 系统消息列表
    getSystemNotify: (r) => o.get(
      "notify",
      // @ts-ignore
      ie(oe({}, r), { sLocale: i(t), platform: "web" })
    ),
    // 获取未读消息列表
    getUnreadSystem: () => o.get("tab", {
      sLocale: i(t),
      platform: "web"
    })
  };
}, ea = 3, Fn = te(0), on = te(), Hn = te(!0), St = te([]), rn = te(!1), Ot = (e) => {
  const { isLoad: t } = e || {}, n = $i();
  function o() {
    return Le(this, null, function* () {
      const { tabs: s } = yield n.getUnreadSystem(), l = s.find((u) => u.id === ea);
      l ? Fn.value = l != null && l.count ? Number(l == null ? void 0 : l.count) : 0 : Fn.value = 0;
    });
  }
  function r() {
    return Le(this, null, function* () {
      rn.value = !0;
      try {
        const { cursor: s, has_more: l, list: u } = yield n.getSystemNotify(on.value ? { cursor: on.value } : {});
        Hn.value = l, on.value = s, St.value = St.value.concat(u);
      } catch (s) {
        console.log(s);
      }
      rn.value = !1;
    });
  }
  const a = V(() => {
    const s = Fn.value;
    return s > 99 ? "99+" : s;
  }), c = () => Le(void 0, null, function* () {
    on.value = void 0, St.value = [], Hn.value = !0;
  });
  return t && o(), {
    unreadCount: a,
    getUnreadSystem: o,
    getNextSystemNotify: r,
    refresh: c,
    messages: St,
    isMore: Hn,
    isLoading: rn,
    showLoading: V(() => rn.value && St.value.length === 0)
  };
}, ta = {
  key: 0,
  src: Hi,
  alt: "bilibili-icon"
}, na = {
  key: 1,
  src: Vi,
  alt: "bilibili-icon"
}, oa = {
  name: "Left"
}, hn = /* @__PURE__ */ $(ie(oe({}, oa), {
  props: {
    showMenu: { type: Boolean, default: !1 },
    showBack: { type: Boolean, default: !1 },
    title: null,
    isBstation: { type: Boolean, default: !1 }
  },
  emits: ["menuClick", "backClick"],
  setup(e, { emit: t }) {
    const { unreadCount: n } = Ot(), { classPrefix: o, isMobile: r, locale: a } = re(), c = `${o}__left`, s = V(() => [c, { [`${c}--mobile`]: i(r) }]), l = `/${i(a)}`, u = () => {
      De.clickBilibili();
    }, M = () => {
      t("menuClick");
    }, N = () => {
      t("backClick");
    };
    return (d, g) => (I(), S("div", {
      class: x(i(s))
    }, [
      e.showMenu && i(r) ? (I(), S("button", {
        key: 0,
        class: x([`${c}-menu`, { [`${c}-reddot`]: i(n) }]),
        onTouchstart: M
      }, null, 34)) : ee("", !0),
      e.showMenu && !i(r) ? (I(), S("button", {
        key: 1,
        class: x(`${c}-menu`),
        onClick: M
      }, null, 2)) : ee("", !0),
      e.showBack ? (I(), S("button", {
        key: 2,
        class: x(`${c}-back`),
        onTouchstart: N
      }, null, 34)) : ee("", !0),
      e.title ? (I(), S("h2", {
        key: 3,
        class: x(`${c}-title`)
      }, Z(e.title), 3)) : (I(), S("a", {
        key: 4,
        href: l,
        class: x(`${c}-logo`),
        onClick: u
      }, [
        e.isBstation ? (I(), S("img", ta)) : (I(), S("img", na))
      ], 2))
    ], 2));
  }
}));
const ra = {
  name: "ListItem"
}, Xe = /* @__PURE__ */ $(ie(oe({}, ra), {
  props: {
    icon: null,
    url: null,
    prefix: { type: Boolean },
    suffix: { type: Boolean },
    isButton: { type: Boolean },
    large: { type: Boolean },
    newWindow: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, { url: o, icon: r, prefix: a, suffix: c, large: s, isButton: l, newWindow: u } = le(n), { classPrefix: M } = re(), N = V(() => {
      const g = {
        class: [
          `${M}__list-item`,
          { prefix: i(a), suffix: i(c), large: i(s) },
          i(r)
        ]
      };
      return i(l) ? g : ie(oe({}, g), { href: i(o), target: i(u) ? "_blank" : "_self" });
    }), d = () => {
      t("click");
    };
    return (g, y) => (I(), _(Dr(i(l) ? "button" : "a"), pr(i(N), { onClick: d }), {
      default: ye(() => [
        C("span", null, [
          Ie(g.$slots, "default")
        ])
      ]),
      _: 3
    }, 16));
  }
}));
const ia = {
  name: "LangSelect"
}, aa = /* @__PURE__ */ $(ie(oe({}, ia), {
  setup(e) {
    const { locale: t, onLangChange: n } = re(), o = V(() => {
      var c;
      return (c = ft.find((s) => s.value === i(t))) == null ? void 0 : c.label;
    }), r = V(() => ft.map((c) => ie(oe({}, c), { selected: i(o) === c.label }))), a = (c) => {
      c !== i(t) && n(c);
    };
    return (c, s) => (I(!0), S(Ae, null, we(i(r), (l) => (I(), _(Xe, {
      key: l.value,
      suffix: "",
      icon: l.selected ? "selected" : "",
      "is-button": "",
      onClick: (u) => a(l.value)
    }, {
      default: ye(() => [
        fe(Z(l.label), 1)
      ]),
      _: 2
    }, 1032, ["icon", "onClick"]))), 128));
  }
})), sa = ["src", "alt"], ca = {
  name: "UserAvatar"
}, Rt = /* @__PURE__ */ $(ie(oe({}, ca), {
  props: {
    avatar: null,
    name: null,
    width: null,
    avatarBorder: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { avatar: n, width: o } = le(t), { classPrefix: r } = re(), a = V(() => Tr(i(n), 64, 64, !0)), c = V(() => ({ width: `${i(o)}px`, height: `${i(o)}px` }));
    return (s, l) => (I(), S("span", {
      class: x([`${i(r)}-avatar`, { [`${i(r)}-avatar__border`]: i(e.avatarBorder) }]),
      style: $e(i(c))
    }, [
      C("img", {
        src: i(a),
        alt: e.name
      }, null, 8, sa)
    ], 6));
  }
}));
const la = (e) => /^(https?|bstar):\/\//.test(e), Ke = () => {
  const { config: e, locale: t } = re(), n = (r, a) => V(() => `${i(e).domain}/${i(t)}/${r}${a ? `?${a}` : ""}`);
  return { resolve: n, toUrl: (r, a, c) => {
    let s = "";
    la(r) ? s = r : s = i(n(r, a)), c ? window.open(s, "_blank") : window.location.href = s;
  } };
}, ua = { class: "message-button_content" }, Ma = {
  key: 0,
  class: "message-reddot"
}, ga = { class: "message-button__text" }, ya = {
  key: 0,
  class: "message-reddot"
}, da = /* @__PURE__ */ $({
  __name: "user-entry",
  props: {
    isMobile: { type: Boolean },
    visiable: { type: Boolean }
  },
  setup(e) {
    const t = e, { lang: n } = re(), { unreadCount: o, getUnreadSystem: r } = Ot(), { isMobile: a } = le(t), c = () => {
      i(o) && setTimeout(() => {
        r();
      }, 1e3);
    };
    return (s, l) => {
      var u;
      return i(a) ? (I(), S("button", {
        key: 1,
        class: x("message-button"),
        onClick: c
      }, [
        C("span", ga, Z((u = i(n)) == null ? void 0 : u.message), 1),
        i(o) ? (I(), S("span", ya, Z(i(o)), 1)) : ee("", !0)
      ])) : (I(), _(Xe, {
        key: 0,
        icon: "message",
        prefix: "",
        suffix: "",
        "is-button": "",
        onClick: c
      }, {
        default: ye(() => {
          var M;
          return [
            C("span", ua, [
              fe(Z((M = i(n)) == null ? void 0 : M.message) + " ", 1),
              i(o) ? (I(), S("span", Ma, Z(i(o)), 1)) : ee("", !0)
            ])
          ];
        }),
        _: 1
      }));
    };
  }
});
const wn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, Cr = /* @__PURE__ */ wn(da, [["__scopeId", "data-v-cd5278d3"]]), Bo = /* @__PURE__ */ $({
  __name: "user-structure",
  props: {
    title: null
  },
  emits: ["back"],
  setup(e, { emit: t }) {
    const { classPrefix: n } = re(), o = `${n}-user-content`, r = () => {
      t("back");
    };
    return (a, c) => (I(), S("div", {
      class: x(o)
    }, [
      C("div", {
        class: x([`${o}__head`, `${o}__head--back`])
      }, [
        C("button", {
          class: x(`${o}__back`),
          onClick: r
        }, null, 2),
        C("p", {
          class: x(`${o}__name`)
        }, Z(e.title), 3)
      ], 2),
      C("div", {
        class: x(`${o}__list`)
      }, [
        Ie(a.$slots, "content")
      ], 2)
    ]));
  }
});
const Na = ["href"], Nn = /* @__PURE__ */ $({
  __name: "text-joining",
  props: {
    texts: null
  },
  setup(e) {
    const { classPrefix: t } = re(), n = `${t}-message-card-text`;
    return (o, r) => (I(), S("span", {
      class: x(n)
    }, [
      (I(!0), S(Ae, null, we(e.texts, (a) => (I(), S(Ae, null, [
        a.uri ? (I(), S("a", {
          key: 0,
          class: x([a.style.split(","), "link"]),
          href: a.uri,
          target: "_blank"
        }, Z(a.text), 11, Na)) : (I(), S("span", {
          key: 1,
          class: x(["", a.style.split(",")])
        }, Z(a.text), 3))
      ], 64))), 256))
    ]));
  }
});
var ve = "top", Re = "bottom", Ge = "right", ke = "left", so = "auto", Vt = [ve, Re, Ge, ke], jt = "start", Gt = "end", Aa = "clippingParents", Lr = "viewport", bt = "popper", Da = "reference", Yo = /* @__PURE__ */ Vt.reduce(function(e, t) {
  return e.concat([t + "-" + jt, t + "-" + Gt]);
}, []), vr = /* @__PURE__ */ [].concat(Vt, [so]).reduce(function(e, t) {
  return e.concat([t, t + "-" + jt, t + "-" + Gt]);
}, []), pa = "beforeRead", Ia = "read", fa = "afterRead", ja = "beforeMain", ha = "main", wa = "afterMain", Ea = "beforeWrite", Ta = "write", xa = "afterWrite", ma = [pa, Ia, fa, ja, ha, wa, Ea, Ta, xa];
function Je(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Pe(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function dt(e) {
  var t = Pe(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ye(e) {
  var t = Pe(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function co(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var t = Pe(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Oa(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, r = t.attributes[n] || {}, a = t.elements[n];
    !Ye(a) || !Je(a) || (Object.assign(a.style, o), Object.keys(r).forEach(function(c) {
      var s = r[c];
      s === !1 ? a.removeAttribute(c) : a.setAttribute(c, s === !0 ? "" : s);
    }));
  });
}
function za(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var r = t.elements[o], a = t.attributes[o] || {}, c = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), s = c.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Ye(r) || !Je(r) || (Object.assign(r.style, s), Object.keys(a).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const Ca = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Oa,
  effect: za,
  requires: ["computeStyles"]
};
function We(e) {
  return e.split("-")[0];
}
var yt = Math.max, An = Math.min, ht = Math.round;
function Xn() {
  var e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function kr() {
  return !/^((?!chrome|android).)*safari/i.test(Xn());
}
function wt(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var o = e.getBoundingClientRect(), r = 1, a = 1;
  t && Ye(e) && (r = e.offsetWidth > 0 && ht(o.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && ht(o.height) / e.offsetHeight || 1);
  var c = dt(e) ? Pe(e) : window, s = c.visualViewport, l = !kr() && n, u = (o.left + (l && s ? s.offsetLeft : 0)) / r, M = (o.top + (l && s ? s.offsetTop : 0)) / a, N = o.width / r, d = o.height / a;
  return {
    width: N,
    height: d,
    top: M,
    right: u + N,
    bottom: M + d,
    left: u,
    x: u,
    y: M
  };
}
function lo(e) {
  var t = wt(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
function Sr(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && co(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function et(e) {
  return Pe(e).getComputedStyle(e);
}
function La(e) {
  return ["table", "td", "th"].indexOf(Je(e)) >= 0;
}
function ut(e) {
  return ((dt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function En(e) {
  return Je(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (co(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ut(e)
  );
}
function Ro(e) {
  return !Ye(e) || // https://github.com/popperjs/popper-core/issues/837
  et(e).position === "fixed" ? null : e.offsetParent;
}
function va(e) {
  var t = /firefox/i.test(Xn()), n = /Trident/i.test(Xn());
  if (n && Ye(e)) {
    var o = et(e);
    if (o.position === "fixed")
      return null;
  }
  var r = En(e);
  for (co(r) && (r = r.host); Ye(r) && ["html", "body"].indexOf(Je(r)) < 0; ) {
    var a = et(r);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Zt(e) {
  for (var t = Pe(e), n = Ro(e); n && La(n) && et(n).position === "static"; )
    n = Ro(n);
  return n && (Je(n) === "html" || Je(n) === "body" && et(n).position === "static") ? t : n || va(e) || t;
}
function uo(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Bt(e, t, n) {
  return yt(e, An(t, n));
}
function ka(e, t, n) {
  var o = Bt(e, t, n);
  return o > n ? n : o;
}
function br() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Qr(e) {
  return Object.assign({}, br(), e);
}
function Ur(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
var Sa = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Qr(typeof t != "number" ? t : Ur(t, Vt));
};
function ba(e) {
  var t, n = e.state, o = e.name, r = e.options, a = n.elements.arrow, c = n.modifiersData.popperOffsets, s = We(n.placement), l = uo(s), u = [ke, Ge].indexOf(s) >= 0, M = u ? "height" : "width";
  if (!(!a || !c)) {
    var N = Sa(r.padding, n), d = lo(a), g = l === "y" ? ve : ke, y = l === "y" ? Re : Ge, D = n.rects.reference[M] + n.rects.reference[l] - c[l] - n.rects.popper[M], p = c[l] - n.rects.reference[l], j = Zt(a), A = j ? l === "y" ? j.clientHeight || 0 : j.clientWidth || 0 : 0, w = D / 2 - p / 2, h = N[g], f = A - d[M] - N[y], E = A / 2 - d[M] / 2 + w, Y = Bt(h, E, f), R = l;
    n.modifiersData[o] = (t = {}, t[R] = Y, t.centerOffset = Y - E, t);
  }
}
function Qa(e) {
  var t = e.state, n = e.options, o = n.element, r = o === void 0 ? "[data-popper-arrow]" : o;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Sr(t.elements.popper, r) && (t.elements.arrow = r));
}
const Ua = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ba,
  effect: Qa,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Et(e) {
  return e.split("-")[1];
}
var Ba = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ya(e) {
  var t = e.x, n = e.y, o = window, r = o.devicePixelRatio || 1;
  return {
    x: ht(t * r) / r || 0,
    y: ht(n * r) / r || 0
  };
}
function Go(e) {
  var t, n = e.popper, o = e.popperRect, r = e.placement, a = e.variation, c = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, M = e.roundOffsets, N = e.isFixed, d = c.x, g = d === void 0 ? 0 : d, y = c.y, D = y === void 0 ? 0 : y, p = typeof M == "function" ? M({
    x: g,
    y: D
  }) : {
    x: g,
    y: D
  };
  g = p.x, D = p.y;
  var j = c.hasOwnProperty("x"), A = c.hasOwnProperty("y"), w = ke, h = ve, f = window;
  if (u) {
    var E = Zt(n), Y = "clientHeight", R = "clientWidth";
    if (E === Pe(n) && (E = ut(n), et(E).position !== "static" && s === "absolute" && (Y = "scrollHeight", R = "scrollWidth")), E = E, r === ve || (r === ke || r === Ge) && a === Gt) {
      h = Re;
      var U = N && E === f && f.visualViewport ? f.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        E[Y]
      );
      D -= U - o.height, D *= l ? 1 : -1;
    }
    if (r === ke || (r === ve || r === Re) && a === Gt) {
      w = Ge;
      var k = N && E === f && f.visualViewport ? f.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        E[R]
      );
      g -= k - o.width, g *= l ? 1 : -1;
    }
  }
  var q = Object.assign({
    position: s
  }, u && Ba), se = M === !0 ? Ya({
    x: g,
    y: D
  }) : {
    x: g,
    y: D
  };
  if (g = se.x, D = se.y, l) {
    var b;
    return Object.assign({}, q, (b = {}, b[h] = A ? "0" : "", b[w] = j ? "0" : "", b.transform = (f.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + D + "px)" : "translate3d(" + g + "px, " + D + "px, 0)", b));
  }
  return Object.assign({}, q, (t = {}, t[h] = A ? D + "px" : "", t[w] = j ? g + "px" : "", t.transform = "", t));
}
function Ra(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, r = o === void 0 ? !0 : o, a = n.adaptive, c = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: We(t.placement),
    variation: Et(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Go(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: c,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Go(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Ga = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ra,
  data: {}
};
var an = {
  passive: !0
};
function Pa(e) {
  var t = e.state, n = e.instance, o = e.options, r = o.scroll, a = r === void 0 ? !0 : r, c = o.resize, s = c === void 0 ? !0 : c, l = Pe(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && u.forEach(function(M) {
    M.addEventListener("scroll", n.update, an);
  }), s && l.addEventListener("resize", n.update, an), function() {
    a && u.forEach(function(M) {
      M.removeEventListener("scroll", n.update, an);
    }), s && l.removeEventListener("resize", n.update, an);
  };
}
const Fa = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Pa,
  data: {}
};
var Ha = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function cn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Ha[t];
  });
}
var Va = {
  start: "end",
  end: "start"
};
function Po(e) {
  return e.replace(/start|end/g, function(t) {
    return Va[t];
  });
}
function Mo(e) {
  var t = Pe(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
function go(e) {
  return wt(ut(e)).left + Mo(e).scrollLeft;
}
function Za(e, t) {
  var n = Pe(e), o = ut(e), r = n.visualViewport, a = o.clientWidth, c = o.clientHeight, s = 0, l = 0;
  if (r) {
    a = r.width, c = r.height;
    var u = kr();
    (u || !u && t === "fixed") && (s = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: a,
    height: c,
    x: s + go(e),
    y: l
  };
}
function Wa(e) {
  var t, n = ut(e), o = Mo(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, a = yt(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), c = yt(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), s = -o.scrollLeft + go(e), l = -o.scrollTop;
  return et(r || n).direction === "rtl" && (s += yt(n.clientWidth, r ? r.clientWidth : 0) - a), {
    width: a,
    height: c,
    x: s,
    y: l
  };
}
function yo(e) {
  var t = et(e), n = t.overflow, o = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + o);
}
function Br(e) {
  return ["html", "body", "#document"].indexOf(Je(e)) >= 0 ? e.ownerDocument.body : Ye(e) && yo(e) ? e : Br(En(e));
}
function Yt(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = Br(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), a = Pe(o), c = r ? [a].concat(a.visualViewport || [], yo(o) ? o : []) : o, s = t.concat(c);
  return r ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Yt(En(c)))
  );
}
function _n(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Ja(e, t) {
  var n = wt(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function Fo(e, t, n) {
  return t === Lr ? _n(Za(e, n)) : dt(t) ? Ja(t, n) : _n(Wa(ut(e)));
}
function Ka(e) {
  var t = Yt(En(e)), n = ["absolute", "fixed"].indexOf(et(e).position) >= 0, o = n && Ye(e) ? Zt(e) : e;
  return dt(o) ? t.filter(function(r) {
    return dt(r) && Sr(r, o) && Je(r) !== "body";
  }) : [];
}
function qa(e, t, n, o) {
  var r = t === "clippingParents" ? Ka(e) : [].concat(t), a = [].concat(r, [n]), c = a[0], s = a.reduce(function(l, u) {
    var M = Fo(e, u, o);
    return l.top = yt(M.top, l.top), l.right = An(M.right, l.right), l.bottom = An(M.bottom, l.bottom), l.left = yt(M.left, l.left), l;
  }, Fo(e, c, o));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Yr(e) {
  var t = e.reference, n = e.element, o = e.placement, r = o ? We(o) : null, a = o ? Et(o) : null, c = t.x + t.width / 2 - n.width / 2, s = t.y + t.height / 2 - n.height / 2, l;
  switch (r) {
    case ve:
      l = {
        x: c,
        y: t.y - n.height
      };
      break;
    case Re:
      l = {
        x: c,
        y: t.y + t.height
      };
      break;
    case Ge:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case ke:
      l = {
        x: t.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = r ? uo(r) : null;
  if (u != null) {
    var M = u === "y" ? "height" : "width";
    switch (a) {
      case jt:
        l[u] = l[u] - (t[M] / 2 - n[M] / 2);
        break;
      case Gt:
        l[u] = l[u] + (t[M] / 2 - n[M] / 2);
        break;
    }
  }
  return l;
}
function Pt(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = o === void 0 ? e.placement : o, a = n.strategy, c = a === void 0 ? e.strategy : a, s = n.boundary, l = s === void 0 ? Aa : s, u = n.rootBoundary, M = u === void 0 ? Lr : u, N = n.elementContext, d = N === void 0 ? bt : N, g = n.altBoundary, y = g === void 0 ? !1 : g, D = n.padding, p = D === void 0 ? 0 : D, j = Qr(typeof p != "number" ? p : Ur(p, Vt)), A = d === bt ? Da : bt, w = e.rects.popper, h = e.elements[y ? A : d], f = qa(dt(h) ? h : h.contextElement || ut(e.elements.popper), l, M, c), E = wt(e.elements.reference), Y = Yr({
    reference: E,
    element: w,
    strategy: "absolute",
    placement: r
  }), R = _n(Object.assign({}, w, Y)), U = d === bt ? R : E, k = {
    top: f.top - U.top + j.top,
    bottom: U.bottom - f.bottom + j.bottom,
    left: f.left - U.left + j.left,
    right: U.right - f.right + j.right
  }, q = e.modifiersData.offset;
  if (d === bt && q) {
    var se = q[r];
    Object.keys(k).forEach(function(b) {
      var L = [Ge, Re].indexOf(b) >= 0 ? 1 : -1, O = [ve, Re].indexOf(b) >= 0 ? "y" : "x";
      k[b] += se[O] * L;
    });
  }
  return k;
}
function Xa(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = n.boundary, a = n.rootBoundary, c = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? vr : l, M = Et(o), N = M ? s ? Yo : Yo.filter(function(y) {
    return Et(y) === M;
  }) : Vt, d = N.filter(function(y) {
    return u.indexOf(y) >= 0;
  });
  d.length === 0 && (d = N);
  var g = d.reduce(function(y, D) {
    return y[D] = Pt(e, {
      placement: D,
      boundary: r,
      rootBoundary: a,
      padding: c
    })[We(D)], y;
  }, {});
  return Object.keys(g).sort(function(y, D) {
    return g[y] - g[D];
  });
}
function _a(e) {
  if (We(e) === so)
    return [];
  var t = cn(e);
  return [Po(e), t, Po(t)];
}
function $a(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var r = n.mainAxis, a = r === void 0 ? !0 : r, c = n.altAxis, s = c === void 0 ? !0 : c, l = n.fallbackPlacements, u = n.padding, M = n.boundary, N = n.rootBoundary, d = n.altBoundary, g = n.flipVariations, y = g === void 0 ? !0 : g, D = n.allowedAutoPlacements, p = t.options.placement, j = We(p), A = j === p, w = l || (A || !y ? [cn(p)] : _a(p)), h = [p].concat(w).reduce(function(B, W) {
      return B.concat(We(W) === so ? Xa(t, {
        placement: W,
        boundary: M,
        rootBoundary: N,
        padding: u,
        flipVariations: y,
        allowedAutoPlacements: D
      }) : W);
    }, []), f = t.rects.reference, E = t.rects.popper, Y = /* @__PURE__ */ new Map(), R = !0, U = h[0], k = 0; k < h.length; k++) {
      var q = h[k], se = We(q), b = Et(q) === jt, L = [ve, Re].indexOf(se) >= 0, O = L ? "width" : "height", G = Pt(t, {
        placement: q,
        boundary: M,
        rootBoundary: N,
        altBoundary: d,
        padding: u
      }), v = L ? b ? Ge : ke : b ? Re : ve;
      f[O] > E[O] && (v = cn(v));
      var F = cn(v), z = [];
      if (a && z.push(G[se] <= 0), s && z.push(G[v] <= 0, G[F] <= 0), z.every(function(B) {
        return B;
      })) {
        U = q, R = !1;
        break;
      }
      Y.set(q, z);
    }
    if (R)
      for (var J = y ? 3 : 1, ne = function(W) {
        var K = h.find(function(X) {
          var ue = Y.get(X);
          if (ue)
            return ue.slice(0, W).every(function(Me) {
              return Me;
            });
        });
        if (K)
          return U = K, "break";
      }, H = J; H > 0; H--) {
        var P = ne(H);
        if (P === "break")
          break;
      }
    t.placement !== U && (t.modifiersData[o]._skip = !0, t.placement = U, t.reset = !0);
  }
}
const es = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: $a,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ho(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Vo(e) {
  return [ve, Ge, Re, ke].some(function(t) {
    return e[t] >= 0;
  });
}
function ts(e) {
  var t = e.state, n = e.name, o = t.rects.reference, r = t.rects.popper, a = t.modifiersData.preventOverflow, c = Pt(t, {
    elementContext: "reference"
  }), s = Pt(t, {
    altBoundary: !0
  }), l = Ho(c, o), u = Ho(s, r, a), M = Vo(l), N = Vo(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: M,
    hasPopperEscaped: N
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": M,
    "data-popper-escaped": N
  });
}
const ns = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: ts
};
function os(e, t, n) {
  var o = We(e), r = [ke, ve].indexOf(o) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, c = a[0], s = a[1];
  return c = c || 0, s = (s || 0) * r, [ke, Ge].indexOf(o) >= 0 ? {
    x: s,
    y: c
  } : {
    x: c,
    y: s
  };
}
function rs(e) {
  var t = e.state, n = e.options, o = e.name, r = n.offset, a = r === void 0 ? [0, 0] : r, c = vr.reduce(function(M, N) {
    return M[N] = os(N, t.rects, a), M;
  }, {}), s = c[t.placement], l = s.x, u = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[o] = c;
}
const is = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: rs
};
function as(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Yr({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const ss = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: as,
  data: {}
};
function cs(e) {
  return e === "x" ? "y" : "x";
}
function ls(e) {
  var t = e.state, n = e.options, o = e.name, r = n.mainAxis, a = r === void 0 ? !0 : r, c = n.altAxis, s = c === void 0 ? !1 : c, l = n.boundary, u = n.rootBoundary, M = n.altBoundary, N = n.padding, d = n.tether, g = d === void 0 ? !0 : d, y = n.tetherOffset, D = y === void 0 ? 0 : y, p = Pt(t, {
    boundary: l,
    rootBoundary: u,
    padding: N,
    altBoundary: M
  }), j = We(t.placement), A = Et(t.placement), w = !A, h = uo(j), f = cs(h), E = t.modifiersData.popperOffsets, Y = t.rects.reference, R = t.rects.popper, U = typeof D == "function" ? D(Object.assign({}, t.rects, {
    placement: t.placement
  })) : D, k = typeof U == "number" ? {
    mainAxis: U,
    altAxis: U
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, U), q = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, se = {
    x: 0,
    y: 0
  };
  if (E) {
    if (a) {
      var b, L = h === "y" ? ve : ke, O = h === "y" ? Re : Ge, G = h === "y" ? "height" : "width", v = E[h], F = v + p[L], z = v - p[O], J = g ? -R[G] / 2 : 0, ne = A === jt ? Y[G] : R[G], H = A === jt ? -R[G] : -Y[G], P = t.elements.arrow, B = g && P ? lo(P) : {
        width: 0,
        height: 0
      }, W = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : br(), K = W[L], X = W[O], ue = Bt(0, Y[G], B[G]), Me = w ? Y[G] / 2 - J - ue - K - k.mainAxis : ne - ue - K - k.mainAxis, xe = w ? -Y[G] / 2 + J + ue + X + k.mainAxis : H + ue + X + k.mainAxis, Se = t.elements.arrow && Zt(t.elements.arrow), Be = Se ? h === "y" ? Se.clientTop || 0 : Se.clientLeft || 0 : 0, be = (b = q == null ? void 0 : q[h]) != null ? b : 0, Nt = v + Me - be - Be, Ct = v + xe - be, Ce = Bt(g ? An(F, Nt) : F, v, g ? yt(z, Ct) : z);
      E[h] = Ce, se[h] = Ce - v;
    }
    if (s) {
      var ze, kn = h === "x" ? ve : ke, Kt = h === "x" ? Re : Ge, qe = E[f], At = f === "y" ? "height" : "width", qt = qe + p[kn], Xt = qe - p[Kt], Lt = [ve, ke].indexOf(j) !== -1, _t = (ze = q == null ? void 0 : q[f]) != null ? ze : 0, vt = Lt ? qt : qe - Y[At] - R[At] - _t + k.altAxis, $t = Lt ? qe + Y[At] + R[At] - _t - k.altAxis : Xt, ot = g && Lt ? ka(vt, qe, $t) : Bt(g ? vt : qt, qe, g ? $t : Xt);
      E[f] = ot, se[f] = ot - qe;
    }
    t.modifiersData[o] = se;
  }
}
const us = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: ls,
  requiresIfExists: ["offset"]
};
function Ms(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function gs(e) {
  return e === Pe(e) || !Ye(e) ? Mo(e) : Ms(e);
}
function ys(e) {
  var t = e.getBoundingClientRect(), n = ht(t.width) / e.offsetWidth || 1, o = ht(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function ds(e, t, n) {
  n === void 0 && (n = !1);
  var o = Ye(t), r = Ye(t) && ys(t), a = ut(t), c = wt(e, r, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((Je(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  yo(a)) && (s = gs(t)), Ye(t) ? (l = wt(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = go(a))), {
    x: c.left + s.scrollLeft - l.x,
    y: c.top + s.scrollTop - l.y,
    width: c.width,
    height: c.height
  };
}
function Ns(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function r(a) {
    n.add(a.name);
    var c = [].concat(a.requires || [], a.requiresIfExists || []);
    c.forEach(function(s) {
      if (!n.has(s)) {
        var l = t.get(s);
        l && r(l);
      }
    }), o.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || r(a);
  }), o;
}
function As(e) {
  var t = Ns(e);
  return ma.reduce(function(n, o) {
    return n.concat(t.filter(function(r) {
      return r.phase === o;
    }));
  }, []);
}
function Ds(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function ps(e) {
  var t = e.reduce(function(n, o) {
    var r = n[o.name];
    return n[o.name] = r ? Object.assign({}, r, o, {
      options: Object.assign({}, r.options, o.options),
      data: Object.assign({}, r.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Zo = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Wo() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function Is(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, r = t.defaultOptions, a = r === void 0 ? Zo : r;
  return function(s, l, u) {
    u === void 0 && (u = a);
    var M = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Zo, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, N = [], d = !1, g = {
      state: M,
      setOptions: function(j) {
        var A = typeof j == "function" ? j(M.options) : j;
        D(), M.options = Object.assign({}, a, M.options, A), M.scrollParents = {
          reference: dt(s) ? Yt(s) : s.contextElement ? Yt(s.contextElement) : [],
          popper: Yt(l)
        };
        var w = As(ps([].concat(o, M.options.modifiers)));
        return M.orderedModifiers = w.filter(function(h) {
          return h.enabled;
        }), y(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var j = M.elements, A = j.reference, w = j.popper;
          if (Wo(A, w)) {
            M.rects = {
              reference: ds(A, Zt(w), M.options.strategy === "fixed"),
              popper: lo(w)
            }, M.reset = !1, M.placement = M.options.placement, M.orderedModifiers.forEach(function(k) {
              return M.modifiersData[k.name] = Object.assign({}, k.data);
            });
            for (var h = 0; h < M.orderedModifiers.length; h++) {
              if (M.reset === !0) {
                M.reset = !1, h = -1;
                continue;
              }
              var f = M.orderedModifiers[h], E = f.fn, Y = f.options, R = Y === void 0 ? {} : Y, U = f.name;
              typeof E == "function" && (M = E({
                state: M,
                options: R,
                name: U,
                instance: g
              }) || M);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Ds(function() {
        return new Promise(function(p) {
          g.forceUpdate(), p(M);
        });
      }),
      destroy: function() {
        D(), d = !0;
      }
    };
    if (!Wo(s, l))
      return g;
    g.setOptions(u).then(function(p) {
      !d && u.onFirstUpdate && u.onFirstUpdate(p);
    });
    function y() {
      M.orderedModifiers.forEach(function(p) {
        var j = p.name, A = p.options, w = A === void 0 ? {} : A, h = p.effect;
        if (typeof h == "function") {
          var f = h({
            state: M,
            name: j,
            instance: g,
            options: w
          }), E = function() {
          };
          N.push(f || E);
        }
      });
    }
    function D() {
      N.forEach(function(p) {
        return p();
      }), N = [];
    }
    return g;
  };
}
var fs = [Fa, ss, Ga, Ca, is, es, us, Ua, ns], Rr = /* @__PURE__ */ Is({
  defaultModifiers: fs
}), js = Object.defineProperty, hs = Object.defineProperties, ws = Object.getOwnPropertyDescriptors, Jo = Object.getOwnPropertySymbols, Es = Object.prototype.hasOwnProperty, Ts = Object.prototype.propertyIsEnumerable, Ko = (e, t, n) => t in e ? js(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, je = (e, t) => {
  for (var n in t || (t = {}))
    Es.call(t, n) && Ko(e, n, t[n]);
  if (Jo)
    for (var n of Jo(t))
      Ts.call(t, n) && Ko(e, n, t[n]);
  return e;
}, he = (e, t) => hs(e, ws(t));
const Fe = (e, t) => {
  if (e.install = (n) => {
    for (const o of [e, ...Object.values(t != null ? t : {})])
      n.component(o.name, o);
  }, t)
    for (const [n, o] of Object.entries(t))
      e[n] = o;
  return e;
}, xs = ["disabled"], ms = {
  name: "BButton"
}, ln = /* @__PURE__ */ $(he(je({}, ms), {
  props: {
    size: { default: "default" },
    type: { default: "default" },
    primary: { type: Boolean },
    cancel: { type: Boolean },
    hollow: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    block: { type: Boolean },
    bold: { type: Boolean },
    largeSpace: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, { size: o, type: r, disabled: a, loading: c, block: s, bold: l, largeSpace: u, hollow: M } = le(n), N = "bstar-button", d = `${N}--loading-icon`, g = V(
      () => [
        N,
        `${N}--${o.value}`,
        `${N}--color-${r != null && r.value ? r.value : "default"}`,
        {
          [`${N}--hollow`]: M == null ? void 0 : M.value,
          [`${N}--disabled`]: a == null ? void 0 : a.value,
          [`${N}--block`]: s == null ? void 0 : s.value,
          [`${N}--bold`]: l == null ? void 0 : l.value,
          [`${N}--loading`]: c == null ? void 0 : c.value,
          [`${N}--large-space`]: u == null ? void 0 : u.value
        }
      ]
    ), y = (D) => {
      if (a != null && a.value || c != null && c.value)
        return !1;
      t("click", D);
    };
    return (D, p) => (I(), S("button", {
      type: "button",
      class: x(i(g)),
      disabled: i(a) || i(c),
      onClick: y
    }, [
      i(c) ? (I(), S("i", {
        key: 0,
        class: x(d)
      })) : ee("", !0),
      Ie(D.$slots, "default")
    ], 10, xs));
  }
}));
Fe(ln);
const un = typeof window != "undefined", Gr = () => un ? {
  inBrowser: un,
  isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)
} : { inBrowser: un }, Os = { class: "dialog__header-title" }, zs = {
  key: 0,
  class: "dialog__footer"
}, Cs = {
  name: "BDialog"
}, Ls = /* @__PURE__ */ $(he(je({}, Cs), {
  props: {
    visible: { type: Boolean },
    size: { default: "medium" },
    title: null,
    titleAlign: { default: "left" },
    type: { default: "default" },
    cancelButtonText: { default: void 0 },
    buttonText: { default: void 0 },
    fullscreen: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    showBack: { type: Boolean, default: !1 },
    showClose: { type: Boolean, default: !0 },
    zIndex: { default: 9700 },
    dark: { type: Boolean, default: !1 },
    to: { default: "body" }
  },
  emits: ["back", "close", "submit", "cancel", "show", "hide"],
  setup(e, { emit: t }) {
    const n = e, { visible: o, size: r, titleAlign: a, fullscreen: c, showBack: s, showClose: l, cancelButtonText: u, buttonText: M, zIndex: N } = le(n), d = Ir(), g = vi(), { isMobile: y } = Gr(), D = te(!1), p = te(!1), j = te(!1), A = te(0), w = V(() => [
      "dialog__wrap",
      {
        "dialog__wrap--show": i(p),
        "dialog__wrap--show-bg": i(D)
      }
    ]), h = V(() => ({ "z-index": i(N) })), f = V(() => {
      const z = "dialog__container";
      return [
        z,
        `${z}--${r.value}`,
        `${z}--${g.class}`,
        { [`${z}--fullscreen`]: c.value },
        { [`${z}--show`]: j.value }
      ];
    }), E = V(() => [
      "dialog__body",
      { "dialog__body--empty": i(F) }
    ]), Y = V(() => a.value === "center" || (s == null ? void 0 : s.value)), R = V(() => {
      const z = "dialog__header";
      return [
        z,
        { [`${z}--center`]: Y.value },
        { [`${z}--no-button`]: !(s != null && s.value) && !l.value }
      ];
    }), U = V(() => i(u) || i(M) || d.footer), k = V(() => ({ "--height": `${i(A)}px` })), q = () => {
      t("back");
    }, se = () => {
      t("close");
    }, b = () => {
      t("cancel");
    }, L = () => {
      t("submit");
    }, O = () => {
      A.value = window.innerHeight;
    }, G = () => {
      p.value = !0, O(), window.addEventListener("resize", O), setTimeout(() => {
        D.value = !0, j.value = !0, t("show");
      }, 100);
    }, v = () => {
      j.value = !1, D.value = !1, setTimeout(() => {
        p.value = !1, window.removeEventListener("resize", O), t("hide");
      }, 400);
    };
    mt(o, (z) => {
      un && (document.body.style.overflow = z ? "hidden" : "", z ? G() : v());
    });
    const F = V(() => {
      var z;
      return (((z = d.default) == null ? void 0 : z.call(d)) || []).every((J) => !J.children);
    });
    return Ve(() => {
      i(o) && (document.body.style.overflow = "hidden", G());
    }), (z, J) => (I(), _(It, { to: e.to }, [
      C("div", {
        class: x([
          "dialog",
          z.$attrs.class,
          { ["dialog--mobile"]: i(y), ["dialog--dark"]: e.dark }
        ])
      }, [
        C("div", {
          class: x(i(w)),
          style: $e(i(h))
        }, [
          C("div", {
            class: x(i(f)),
            style: $e(i(k))
          }, [
            C("div", {
              class: x(i(R))
            }, [
              i(s) ? (I(), S("button", {
                key: 0,
                class: "dialog__back",
                onClick: q
              })) : ee("", !0),
              Ie(z.$slots, "header", {}, () => [
                C("span", Os, Z(e.title), 1)
              ], !0),
              i(l) ? (I(), S("button", {
                key: 1,
                class: "dialog__close",
                onClick: se
              })) : ee("", !0)
            ], 2),
            C("div", {
              class: x(i(E))
            }, [
              Ie(z.$slots, "default", {}, void 0, !0)
            ], 2),
            i(U) ? (I(), S("div", zs, [
              Ie(z.$slots, "footer", {}, () => [
                i(u) ? (I(), _(ln, {
                  key: 0,
                  size: "large",
                  type: e.type,
                  hollow: "",
                  bold: "",
                  class: "dialog__cancel",
                  onClick: b
                }, {
                  default: ye(() => [
                    fe(Z(i(u)), 1)
                  ]),
                  _: 1
                }, 8, ["type"])) : ee("", !0),
                i(M) ? (I(), _(ln, {
                  key: 1,
                  type: e.type,
                  size: "large",
                  bold: "",
                  disabled: e.disabled,
                  loading: e.loading,
                  onClick: L
                }, {
                  default: ye(() => [
                    fe(Z(i(M)), 1)
                  ]),
                  _: 1
                }, 8, ["type", "disabled", "loading"])) : ee("", !0),
                i(u) ? (I(), _(ln, {
                  key: 2,
                  type: "white",
                  size: "large",
                  bold: "",
                  class: "dialog__cancel-min",
                  onClick: b
                }, {
                  default: ye(() => [
                    fe(Z(i(u)), 1)
                  ]),
                  _: 1
                })) : ee("", !0)
              ], !0)
            ])) : ee("", !0)
          ], 6)
        ], 6)
      ], 2)
    ], 8, ["to"]));
  }
})), tt = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, vs = /* @__PURE__ */ tt(Ls, [["__scopeId", "data-v-a9eea325"]]);
Fe(vs);
var ks = Object.create, Pr = Object.defineProperty, Ss = Object.getOwnPropertyDescriptor, bs = Object.getOwnPropertyNames, Qs = Object.getPrototypeOf, Us = Object.prototype.hasOwnProperty, Oe = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Bs = (e, t, n, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let r of bs(t))
      !Us.call(e, r) && r !== n && Pr(e, r, { get: () => t[r], enumerable: !(o = Ss(t, r)) || o.enumerable });
  return e;
}, Ys = (e, t, n) => (n = e != null ? ks(Qs(e)) : {}, Bs(t || !e || !e.__esModule ? Pr(n, "default", { value: e, enumerable: !0 }) : n, e)), Rs = Oe((e, t) => {
  t.exports = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var n = {}, o = Symbol("test"), r = Object(o);
    if (typeof o == "string" || Object.prototype.toString.call(o) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var a = 42;
    n[o] = a;
    for (o in n)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(n).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(n).length !== 0)
      return !1;
    var c = Object.getOwnPropertySymbols(n);
    if (c.length !== 1 || c[0] !== o || !Object.prototype.propertyIsEnumerable.call(n, o))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var s = Object.getOwnPropertyDescriptor(n, o);
      if (s.value !== a || s.enumerable !== !0)
        return !1;
    }
    return !0;
  };
}), Gs = Oe((e, t) => {
  var n = typeof Symbol != "undefined" && Symbol, o = Rs();
  t.exports = function() {
    return typeof n != "function" || typeof Symbol != "function" || typeof n("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : o();
  };
}), Ps = Oe((e, t) => {
  var n = "Function.prototype.bind called on incompatible ", o = Array.prototype.slice, r = Object.prototype.toString, a = "[object Function]";
  t.exports = function(c) {
    var s = this;
    if (typeof s != "function" || r.call(s) !== a)
      throw new TypeError(n + s);
    for (var l = o.call(arguments, 1), u, M = function() {
      if (this instanceof u) {
        var D = s.apply(this, l.concat(o.call(arguments)));
        return Object(D) === D ? D : this;
      } else
        return s.apply(c, l.concat(o.call(arguments)));
    }, N = Math.max(0, s.length - l.length), d = [], g = 0; g < N; g++)
      d.push("$" + g);
    if (u = Function("binder", "return function (" + d.join(",") + "){ return binder.apply(this,arguments); }")(M), s.prototype) {
      var y = function() {
      };
      y.prototype = s.prototype, u.prototype = new y(), y.prototype = null;
    }
    return u;
  };
}), No = Oe((e, t) => {
  var n = Ps();
  t.exports = Function.prototype.bind || n;
}), Fs = Oe((e, t) => {
  var n = No();
  t.exports = n.call(Function.call, Object.prototype.hasOwnProperty);
}), Ao = Oe((e, t) => {
  var n, o = SyntaxError, r = Function, a = TypeError, c = function(b) {
    try {
      return r('"use strict"; return (' + b + ").constructor;")();
    } catch (L) {
    }
  }, s = Object.getOwnPropertyDescriptor;
  if (s)
    try {
      s({}, "");
    } catch (b) {
      s = null;
    }
  var l = function() {
    throw new a();
  }, u = s ? function() {
    try {
      return arguments.callee, l;
    } catch (b) {
      try {
        return s(arguments, "callee").get;
      } catch (L) {
        return l;
      }
    }
  }() : l, M = Gs()(), N = Object.getPrototypeOf || function(b) {
    return b.__proto__;
  }, d = {}, g = typeof Uint8Array == "undefined" ? n : N(Uint8Array), y = { "%AggregateError%": typeof AggregateError == "undefined" ? n : AggregateError, "%Array%": Array, "%ArrayBuffer%": typeof ArrayBuffer == "undefined" ? n : ArrayBuffer, "%ArrayIteratorPrototype%": M ? N([][Symbol.iterator]()) : n, "%AsyncFromSyncIteratorPrototype%": n, "%AsyncFunction%": d, "%AsyncGenerator%": d, "%AsyncGeneratorFunction%": d, "%AsyncIteratorPrototype%": d, "%Atomics%": typeof Atomics == "undefined" ? n : Atomics, "%BigInt%": typeof BigInt == "undefined" ? n : BigInt, "%BigInt64Array%": typeof BigInt64Array == "undefined" ? n : BigInt64Array, "%BigUint64Array%": typeof BigUint64Array == "undefined" ? n : BigUint64Array, "%Boolean%": Boolean, "%DataView%": typeof DataView == "undefined" ? n : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": Error, "%eval%": eval, "%EvalError%": EvalError, "%Float32Array%": typeof Float32Array == "undefined" ? n : Float32Array, "%Float64Array%": typeof Float64Array == "undefined" ? n : Float64Array, "%FinalizationRegistry%": typeof FinalizationRegistry == "undefined" ? n : FinalizationRegistry, "%Function%": r, "%GeneratorFunction%": d, "%Int8Array%": typeof Int8Array == "undefined" ? n : Int8Array, "%Int16Array%": typeof Int16Array == "undefined" ? n : Int16Array, "%Int32Array%": typeof Int32Array == "undefined" ? n : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": M ? N(N([][Symbol.iterator]())) : n, "%JSON%": typeof JSON == "object" ? JSON : n, "%Map%": typeof Map == "undefined" ? n : Map, "%MapIteratorPrototype%": typeof Map == "undefined" || !M ? n : N((/* @__PURE__ */ new Map())[Symbol.iterator]()), "%Math%": Math, "%Number%": Number, "%Object%": Object, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": typeof Promise == "undefined" ? n : Promise, "%Proxy%": typeof Proxy == "undefined" ? n : Proxy, "%RangeError%": RangeError, "%ReferenceError%": ReferenceError, "%Reflect%": typeof Reflect == "undefined" ? n : Reflect, "%RegExp%": RegExp, "%Set%": typeof Set == "undefined" ? n : Set, "%SetIteratorPrototype%": typeof Set == "undefined" || !M ? n : N((/* @__PURE__ */ new Set())[Symbol.iterator]()), "%SharedArrayBuffer%": typeof SharedArrayBuffer == "undefined" ? n : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": M ? N(""[Symbol.iterator]()) : n, "%Symbol%": M ? Symbol : n, "%SyntaxError%": o, "%ThrowTypeError%": u, "%TypedArray%": g, "%TypeError%": a, "%Uint8Array%": typeof Uint8Array == "undefined" ? n : Uint8Array, "%Uint8ClampedArray%": typeof Uint8ClampedArray == "undefined" ? n : Uint8ClampedArray, "%Uint16Array%": typeof Uint16Array == "undefined" ? n : Uint16Array, "%Uint32Array%": typeof Uint32Array == "undefined" ? n : Uint32Array, "%URIError%": URIError, "%WeakMap%": typeof WeakMap == "undefined" ? n : WeakMap, "%WeakRef%": typeof WeakRef == "undefined" ? n : WeakRef, "%WeakSet%": typeof WeakSet == "undefined" ? n : WeakSet };
  try {
    null.error;
  } catch (b) {
    D = N(N(b)), y["%Error.prototype%"] = D;
  }
  var D, p = function b(L) {
    var O;
    if (L === "%AsyncFunction%")
      O = c("async function () {}");
    else if (L === "%GeneratorFunction%")
      O = c("function* () {}");
    else if (L === "%AsyncGeneratorFunction%")
      O = c("async function* () {}");
    else if (L === "%AsyncGenerator%") {
      var G = b("%AsyncGeneratorFunction%");
      G && (O = G.prototype);
    } else if (L === "%AsyncIteratorPrototype%") {
      var v = b("%AsyncGenerator%");
      v && (O = N(v.prototype));
    }
    return y[L] = O, O;
  }, j = { "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, A = No(), w = Fs(), h = A.call(Function.call, Array.prototype.concat), f = A.call(Function.apply, Array.prototype.splice), E = A.call(Function.call, String.prototype.replace), Y = A.call(Function.call, String.prototype.slice), R = A.call(Function.call, RegExp.prototype.exec), U = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, k = /\\(\\)?/g, q = function(b) {
    var L = Y(b, 0, 1), O = Y(b, -1);
    if (L === "%" && O !== "%")
      throw new o("invalid intrinsic syntax, expected closing `%`");
    if (O === "%" && L !== "%")
      throw new o("invalid intrinsic syntax, expected opening `%`");
    var G = [];
    return E(b, U, function(v, F, z, J) {
      G[G.length] = z ? E(J, k, "$1") : F || v;
    }), G;
  }, se = function(b, L) {
    var O = b, G;
    if (w(j, O) && (G = j[O], O = "%" + G[0] + "%"), w(y, O)) {
      var v = y[O];
      if (v === d && (v = p(O)), typeof v == "undefined" && !L)
        throw new a("intrinsic " + b + " exists, but is not available. Please file an issue!");
      return { alias: G, name: O, value: v };
    }
    throw new o("intrinsic " + b + " does not exist!");
  };
  t.exports = function(b, L) {
    if (typeof b != "string" || b.length === 0)
      throw new a("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof L != "boolean")
      throw new a('"allowMissing" argument must be a boolean');
    if (R(/^%?[^%]*%?$/, b) === null)
      throw new o("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var O = q(b), G = O.length > 0 ? O[0] : "", v = se("%" + G + "%", L), F = v.name, z = v.value, J = !1, ne = v.alias;
    ne && (G = ne[0], f(O, h([0, 1], ne)));
    for (var H = 1, P = !0; H < O.length; H += 1) {
      var B = O[H], W = Y(B, 0, 1), K = Y(B, -1);
      if ((W === '"' || W === "'" || W === "`" || K === '"' || K === "'" || K === "`") && W !== K)
        throw new o("property names with quotes must have matching quotes");
      if ((B === "constructor" || !P) && (J = !0), G += "." + B, F = "%" + G + "%", w(y, F))
        z = y[F];
      else if (z != null) {
        if (!(B in z)) {
          if (!L)
            throw new a("base intrinsic for " + b + " exists, but the property is not available.");
          return;
        }
        if (s && H + 1 >= O.length) {
          var X = s(z, B);
          P = !!X, P && "get" in X && !("originalValue" in X.get) ? z = X.get : z = z[B];
        } else
          P = w(z, B), z = z[B];
        P && !J && (y[F] = z);
      }
    }
    return z;
  };
}), Hs = Oe((e, t) => {
  var n = No(), o = Ao(), r = o("%Function.prototype.apply%"), a = o("%Function.prototype.call%"), c = o("%Reflect.apply%", !0) || n.call(a, r), s = o("%Object.getOwnPropertyDescriptor%", !0), l = o("%Object.defineProperty%", !0), u = o("%Math.max%");
  if (l)
    try {
      l({}, "a", { value: 1 });
    } catch (N) {
      l = null;
    }
  t.exports = function(N) {
    var d = c(n, a, arguments);
    if (s && l) {
      var g = s(d, "length");
      g.configurable && l(d, "length", { value: 1 + u(0, N.length - (arguments.length - 1)) });
    }
    return d;
  };
  var M = function() {
    return c(n, r, arguments);
  };
  l ? l(t.exports, "apply", { value: M }) : t.exports.apply = M;
}), Vs = Oe((e, t) => {
  var n = Ao(), o = Hs(), r = o(n("String.prototype.indexOf"));
  t.exports = function(a, c) {
    var s = n(a, !!c);
    return typeof s == "function" && r(a, ".prototype.") > -1 ? o(s) : s;
  };
}), Zs = Oe(() => {
}), Ws = Oe((e, t) => {
  var n = typeof Map == "function" && Map.prototype, o = Object.getOwnPropertyDescriptor && n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = n && o && typeof o.get == "function" ? o.get : null, a = n && Map.prototype.forEach, c = typeof Set == "function" && Set.prototype, s = Object.getOwnPropertyDescriptor && c ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, l = c && s && typeof s.get == "function" ? s.get : null, u = c && Set.prototype.forEach, M = typeof WeakMap == "function" && WeakMap.prototype, N = M ? WeakMap.prototype.has : null, d = typeof WeakSet == "function" && WeakSet.prototype, g = d ? WeakSet.prototype.has : null, y = typeof WeakRef == "function" && WeakRef.prototype, D = y ? WeakRef.prototype.deref : null, p = Boolean.prototype.valueOf, j = Object.prototype.toString, A = Function.prototype.toString, w = String.prototype.match, h = String.prototype.slice, f = String.prototype.replace, E = String.prototype.toUpperCase, Y = String.prototype.toLowerCase, R = RegExp.prototype.test, U = Array.prototype.concat, k = Array.prototype.join, q = Array.prototype.slice, se = Math.floor, b = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, L = Object.getOwnPropertySymbols, O = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, G = typeof Symbol == "function" && typeof Symbol.iterator == "object", v = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === G || "symbol") ? Symbol.toStringTag : null, F = Object.prototype.propertyIsEnumerable, z = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(T) {
    return T.__proto__;
  } : null);
  function J(T, m) {
    if (T === 1 / 0 || T === -1 / 0 || T !== T || T && T > -1e3 && T < 1e3 || R.call(/e/, m))
      return m;
    var ge = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof T == "number") {
      var Ne = T < 0 ? -se(-T) : se(T);
      if (Ne !== T) {
        var pe = String(Ne), ae = h.call(m, pe.length + 1);
        return f.call(pe, ge, "$&_") + "." + f.call(f.call(ae, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return f.call(m, ge, "$&_");
  }
  var ne = Zs(), H = ne.custom, P = be(H) ? H : null;
  t.exports = function T(m, ge, Ne, pe) {
    var ae = ge || {};
    if (Ce(ae, "quoteStyle") && ae.quoteStyle !== "single" && ae.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (Ce(ae, "maxStringLength") && (typeof ae.maxStringLength == "number" ? ae.maxStringLength < 0 && ae.maxStringLength !== 1 / 0 : ae.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var rt = Ce(ae, "customInspect") ? ae.customInspect : !0;
    if (typeof rt != "boolean" && rt !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (Ce(ae, "indent") && ae.indent !== null && ae.indent !== "	" && !(parseInt(ae.indent, 10) === ae.indent && ae.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (Ce(ae, "numericSeparator") && typeof ae.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var Mt = ae.numericSeparator;
    if (typeof m == "undefined")
      return "undefined";
    if (m === null)
      return "null";
    if (typeof m == "boolean")
      return m ? "true" : "false";
    if (typeof m == "string")
      return vt(m, ae);
    if (typeof m == "number") {
      if (m === 0)
        return 1 / 0 / m > 0 ? "0" : "-0";
      var Qe = String(m);
      return Mt ? J(m, Qe) : Qe;
    }
    if (typeof m == "bigint") {
      var it = String(m) + "n";
      return Mt ? J(m, it) : it;
    }
    var Qn = typeof ae.depth == "undefined" ? 5 : ae.depth;
    if (typeof Ne == "undefined" && (Ne = 0), Ne >= Qn && Qn > 0 && typeof m == "object")
      return K(m) ? "[Array]" : "[Object]";
    var Dt = Ei(ae, Ne);
    if (typeof pe == "undefined")
      pe = [];
    else if (Kt(pe, m) >= 0)
      return "[Circular]";
    function He(pt, nn, xi) {
      if (nn && (pe = q.call(pe), pe.push(nn)), xi) {
        var ko = { depth: ae.depth };
        return Ce(ae, "quoteStyle") && (ko.quoteStyle = ae.quoteStyle), T(pt, ko, Ne + 1, pe);
      }
      return T(pt, ae, Ne + 1, pe);
    }
    if (typeof m == "function" && !ue(m)) {
      var xo = kn(m), mo = en(m, He);
      return "[Function" + (xo ? ": " + xo : " (anonymous)") + "]" + (mo.length > 0 ? " { " + k.call(mo, ", ") + " }" : "");
    }
    if (be(m)) {
      var Oo = G ? f.call(String(m), /^(Symbol\(.*\))_[^)]*$/, "$1") : O.call(m);
      return typeof m == "object" && !G ? ot(Oo) : Oo;
    }
    if (_t(m)) {
      for (var kt = "<" + Y.call(String(m.nodeName)), Un = m.attributes || [], tn = 0; tn < Un.length; tn++)
        kt += " " + Un[tn].name + "=" + B(W(Un[tn].value), "double", ae);
      return kt += ">", m.childNodes && m.childNodes.length && (kt += "..."), kt += "</" + Y.call(String(m.nodeName)) + ">", kt;
    }
    if (K(m)) {
      if (m.length === 0)
        return "[]";
      var Bn = en(m, He);
      return Dt && !wi(Bn) ? "[" + bn(Bn, Dt) + "]" : "[ " + k.call(Bn, ", ") + " ]";
    }
    if (Me(m)) {
      var Yn = en(m, He);
      return !("cause" in Error.prototype) && "cause" in m && !F.call(m, "cause") ? "{ [" + String(m) + "] " + k.call(U.call("[cause]: " + He(m.cause), Yn), ", ") + " }" : Yn.length === 0 ? "[" + String(m) + "]" : "{ [" + String(m) + "] " + k.call(Yn, ", ") + " }";
    }
    if (typeof m == "object" && rt) {
      if (P && typeof m[P] == "function" && ne)
        return ne(m, { depth: Qn - Ne });
      if (rt !== "symbol" && typeof m.inspect == "function")
        return m.inspect();
    }
    if (qe(m)) {
      var zo = [];
      return a && a.call(m, function(pt, nn) {
        zo.push(He(nn, m, !0) + " => " + He(pt, m));
      }), To("Map", r.call(m), zo, Dt);
    }
    if (Xt(m)) {
      var Co = [];
      return u && u.call(m, function(pt) {
        Co.push(He(pt, m));
      }), To("Set", l.call(m), Co, Dt);
    }
    if (At(m))
      return Sn("WeakMap");
    if (Lt(m))
      return Sn("WeakSet");
    if (qt(m))
      return Sn("WeakRef");
    if (Se(m))
      return ot(He(Number(m)));
    if (Nt(m))
      return ot(He(b.call(m)));
    if (Be(m))
      return ot(p.call(m));
    if (xe(m))
      return ot(He(String(m)));
    if (!X(m) && !ue(m)) {
      var Rn = en(m, He), Lo = z ? z(m) === Object.prototype : m instanceof Object || m.constructor === Object, Gn = m instanceof Object ? "" : "null prototype", vo = !Lo && v && Object(m) === m && v in m ? h.call(ze(m), 8, -1) : Gn ? "Object" : "", Ti = Lo || typeof m.constructor != "function" ? "" : m.constructor.name ? m.constructor.name + " " : "", Pn = Ti + (vo || Gn ? "[" + k.call(U.call([], vo || [], Gn || []), ": ") + "] " : "");
      return Rn.length === 0 ? Pn + "{}" : Dt ? Pn + "{" + bn(Rn, Dt) + "}" : Pn + "{ " + k.call(Rn, ", ") + " }";
    }
    return String(m);
  };
  function B(T, m, ge) {
    var Ne = (ge.quoteStyle || m) === "double" ? '"' : "'";
    return Ne + T + Ne;
  }
  function W(T) {
    return f.call(String(T), /"/g, "&quot;");
  }
  function K(T) {
    return ze(T) === "[object Array]" && (!v || !(typeof T == "object" && v in T));
  }
  function X(T) {
    return ze(T) === "[object Date]" && (!v || !(typeof T == "object" && v in T));
  }
  function ue(T) {
    return ze(T) === "[object RegExp]" && (!v || !(typeof T == "object" && v in T));
  }
  function Me(T) {
    return ze(T) === "[object Error]" && (!v || !(typeof T == "object" && v in T));
  }
  function xe(T) {
    return ze(T) === "[object String]" && (!v || !(typeof T == "object" && v in T));
  }
  function Se(T) {
    return ze(T) === "[object Number]" && (!v || !(typeof T == "object" && v in T));
  }
  function Be(T) {
    return ze(T) === "[object Boolean]" && (!v || !(typeof T == "object" && v in T));
  }
  function be(T) {
    if (G)
      return T && typeof T == "object" && T instanceof Symbol;
    if (typeof T == "symbol")
      return !0;
    if (!T || typeof T != "object" || !O)
      return !1;
    try {
      return O.call(T), !0;
    } catch (m) {
    }
    return !1;
  }
  function Nt(T) {
    if (!T || typeof T != "object" || !b)
      return !1;
    try {
      return b.call(T), !0;
    } catch (m) {
    }
    return !1;
  }
  var Ct = Object.prototype.hasOwnProperty || function(T) {
    return T in this;
  };
  function Ce(T, m) {
    return Ct.call(T, m);
  }
  function ze(T) {
    return j.call(T);
  }
  function kn(T) {
    if (T.name)
      return T.name;
    var m = w.call(A.call(T), /^function\s*([\w$]+)/);
    return m ? m[1] : null;
  }
  function Kt(T, m) {
    if (T.indexOf)
      return T.indexOf(m);
    for (var ge = 0, Ne = T.length; ge < Ne; ge++)
      if (T[ge] === m)
        return ge;
    return -1;
  }
  function qe(T) {
    if (!r || !T || typeof T != "object")
      return !1;
    try {
      r.call(T);
      try {
        l.call(T);
      } catch (m) {
        return !0;
      }
      return T instanceof Map;
    } catch (m) {
    }
    return !1;
  }
  function At(T) {
    if (!N || !T || typeof T != "object")
      return !1;
    try {
      N.call(T, N);
      try {
        g.call(T, g);
      } catch (m) {
        return !0;
      }
      return T instanceof WeakMap;
    } catch (m) {
    }
    return !1;
  }
  function qt(T) {
    if (!D || !T || typeof T != "object")
      return !1;
    try {
      return D.call(T), !0;
    } catch (m) {
    }
    return !1;
  }
  function Xt(T) {
    if (!l || !T || typeof T != "object")
      return !1;
    try {
      l.call(T);
      try {
        r.call(T);
      } catch (m) {
        return !0;
      }
      return T instanceof Set;
    } catch (m) {
    }
    return !1;
  }
  function Lt(T) {
    if (!g || !T || typeof T != "object")
      return !1;
    try {
      g.call(T, g);
      try {
        N.call(T, N);
      } catch (m) {
        return !0;
      }
      return T instanceof WeakSet;
    } catch (m) {
    }
    return !1;
  }
  function _t(T) {
    return !T || typeof T != "object" ? !1 : typeof HTMLElement != "undefined" && T instanceof HTMLElement ? !0 : typeof T.nodeName == "string" && typeof T.getAttribute == "function";
  }
  function vt(T, m) {
    if (T.length > m.maxStringLength) {
      var ge = T.length - m.maxStringLength, Ne = "... " + ge + " more character" + (ge > 1 ? "s" : "");
      return vt(h.call(T, 0, m.maxStringLength), m) + Ne;
    }
    var pe = f.call(f.call(T, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $t);
    return B(pe, "single", m);
  }
  function $t(T) {
    var m = T.charCodeAt(0), ge = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[m];
    return ge ? "\\" + ge : "\\x" + (m < 16 ? "0" : "") + E.call(m.toString(16));
  }
  function ot(T) {
    return "Object(" + T + ")";
  }
  function Sn(T) {
    return T + " { ? }";
  }
  function To(T, m, ge, Ne) {
    var pe = Ne ? bn(ge, Ne) : k.call(ge, ", ");
    return T + " (" + m + ") {" + pe + "}";
  }
  function wi(T) {
    for (var m = 0; m < T.length; m++)
      if (Kt(T[m], `
`) >= 0)
        return !1;
    return !0;
  }
  function Ei(T, m) {
    var ge;
    if (T.indent === "	")
      ge = "	";
    else if (typeof T.indent == "number" && T.indent > 0)
      ge = k.call(Array(T.indent + 1), " ");
    else
      return null;
    return { base: ge, prev: k.call(Array(m + 1), ge) };
  }
  function bn(T, m) {
    if (T.length === 0)
      return "";
    var ge = `
` + m.prev + m.base;
    return ge + k.call(T, "," + ge) + `
` + m.prev;
  }
  function en(T, m) {
    var ge = K(T), Ne = [];
    if (ge) {
      Ne.length = T.length;
      for (var pe = 0; pe < T.length; pe++)
        Ne[pe] = Ce(T, pe) ? m(T[pe], T) : "";
    }
    var ae = typeof L == "function" ? L(T) : [], rt;
    if (G) {
      rt = {};
      for (var Mt = 0; Mt < ae.length; Mt++)
        rt["$" + ae[Mt]] = ae[Mt];
    }
    for (var Qe in T)
      !Ce(T, Qe) || ge && String(Number(Qe)) === Qe && Qe < T.length || G && rt["$" + Qe] instanceof Symbol || (R.call(/[^\w$]/, Qe) ? Ne.push(m(Qe, T) + ": " + m(T[Qe], T)) : Ne.push(Qe + ": " + m(T[Qe], T)));
    if (typeof L == "function")
      for (var it = 0; it < ae.length; it++)
        F.call(T, ae[it]) && Ne.push("[" + m(ae[it]) + "]: " + m(T[ae[it]], T));
    return Ne;
  }
}), Js = Oe((e, t) => {
  var n = Ao(), o = Vs(), r = Ws(), a = n("%TypeError%"), c = n("%WeakMap%", !0), s = n("%Map%", !0), l = o("WeakMap.prototype.get", !0), u = o("WeakMap.prototype.set", !0), M = o("WeakMap.prototype.has", !0), N = o("Map.prototype.get", !0), d = o("Map.prototype.set", !0), g = o("Map.prototype.has", !0), y = function(A, w) {
    for (var h = A, f; (f = h.next) !== null; h = f)
      if (f.key === w)
        return h.next = f.next, f.next = A.next, A.next = f, f;
  }, D = function(A, w) {
    var h = y(A, w);
    return h && h.value;
  }, p = function(A, w, h) {
    var f = y(A, w);
    f ? f.value = h : A.next = { key: w, next: A.next, value: h };
  }, j = function(A, w) {
    return !!y(A, w);
  };
  t.exports = function() {
    var A, w, h, f = { assert: function(E) {
      if (!f.has(E))
        throw new a("Side channel does not contain " + r(E));
    }, get: function(E) {
      if (c && E && (typeof E == "object" || typeof E == "function")) {
        if (A)
          return l(A, E);
      } else if (s) {
        if (w)
          return N(w, E);
      } else if (h)
        return D(h, E);
    }, has: function(E) {
      if (c && E && (typeof E == "object" || typeof E == "function")) {
        if (A)
          return M(A, E);
      } else if (s) {
        if (w)
          return g(w, E);
      } else if (h)
        return j(h, E);
      return !1;
    }, set: function(E, Y) {
      c && E && (typeof E == "object" || typeof E == "function") ? (A || (A = new c()), u(A, E, Y)) : s ? (w || (w = new s()), d(w, E, Y)) : (h || (h = { key: {}, next: null }), p(h, E, Y));
    } };
    return f;
  };
}), Do = Oe((e, t) => {
  var n = String.prototype.replace, o = /%20/g, r = { RFC1738: "RFC1738", RFC3986: "RFC3986" };
  t.exports = { default: r.RFC3986, formatters: { RFC1738: function(a) {
    return n.call(a, o, "+");
  }, RFC3986: function(a) {
    return String(a);
  } }, RFC1738: r.RFC1738, RFC3986: r.RFC3986 };
}), Fr = Oe((e, t) => {
  var n = Do(), o = Object.prototype.hasOwnProperty, r = Array.isArray, a = function() {
    for (var j = [], A = 0; A < 256; ++A)
      j.push("%" + ((A < 16 ? "0" : "") + A.toString(16)).toUpperCase());
    return j;
  }(), c = function(j) {
    for (; j.length > 1; ) {
      var A = j.pop(), w = A.obj[A.prop];
      if (r(w)) {
        for (var h = [], f = 0; f < w.length; ++f)
          typeof w[f] != "undefined" && h.push(w[f]);
        A.obj[A.prop] = h;
      }
    }
  }, s = function(j, A) {
    for (var w = A && A.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, h = 0; h < j.length; ++h)
      typeof j[h] != "undefined" && (w[h] = j[h]);
    return w;
  }, l = function j(A, w, h) {
    if (!w)
      return A;
    if (typeof w != "object") {
      if (r(A))
        A.push(w);
      else if (A && typeof A == "object")
        (h && (h.plainObjects || h.allowPrototypes) || !o.call(Object.prototype, w)) && (A[w] = !0);
      else
        return [A, w];
      return A;
    }
    if (!A || typeof A != "object")
      return [A].concat(w);
    var f = A;
    return r(A) && !r(w) && (f = s(A, h)), r(A) && r(w) ? (w.forEach(function(E, Y) {
      if (o.call(A, Y)) {
        var R = A[Y];
        R && typeof R == "object" && E && typeof E == "object" ? A[Y] = j(R, E, h) : A.push(E);
      } else
        A[Y] = E;
    }), A) : Object.keys(w).reduce(function(E, Y) {
      var R = w[Y];
      return o.call(E, Y) ? E[Y] = j(E[Y], R, h) : E[Y] = R, E;
    }, f);
  }, u = function(j, A) {
    return Object.keys(A).reduce(function(w, h) {
      return w[h] = A[h], w;
    }, j);
  }, M = function(j, A, w) {
    var h = j.replace(/\+/g, " ");
    if (w === "iso-8859-1")
      return h.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(h);
    } catch (f) {
      return h;
    }
  }, N = function(j, A, w, h, f) {
    if (j.length === 0)
      return j;
    var E = j;
    if (typeof j == "symbol" ? E = Symbol.prototype.toString.call(j) : typeof j != "string" && (E = String(j)), w === "iso-8859-1")
      return escape(E).replace(/%u[0-9a-f]{4}/gi, function(k) {
        return "%26%23" + parseInt(k.slice(2), 16) + "%3B";
      });
    for (var Y = "", R = 0; R < E.length; ++R) {
      var U = E.charCodeAt(R);
      if (U === 45 || U === 46 || U === 95 || U === 126 || U >= 48 && U <= 57 || U >= 65 && U <= 90 || U >= 97 && U <= 122 || f === n.RFC1738 && (U === 40 || U === 41)) {
        Y += E.charAt(R);
        continue;
      }
      if (U < 128) {
        Y = Y + a[U];
        continue;
      }
      if (U < 2048) {
        Y = Y + (a[192 | U >> 6] + a[128 | U & 63]);
        continue;
      }
      if (U < 55296 || U >= 57344) {
        Y = Y + (a[224 | U >> 12] + a[128 | U >> 6 & 63] + a[128 | U & 63]);
        continue;
      }
      R += 1, U = 65536 + ((U & 1023) << 10 | E.charCodeAt(R) & 1023), Y += a[240 | U >> 18] + a[128 | U >> 12 & 63] + a[128 | U >> 6 & 63] + a[128 | U & 63];
    }
    return Y;
  }, d = function(j) {
    for (var A = [{ obj: { o: j }, prop: "o" }], w = [], h = 0; h < A.length; ++h)
      for (var f = A[h], E = f.obj[f.prop], Y = Object.keys(E), R = 0; R < Y.length; ++R) {
        var U = Y[R], k = E[U];
        typeof k == "object" && k !== null && w.indexOf(k) === -1 && (A.push({ obj: E, prop: U }), w.push(k));
      }
    return c(A), j;
  }, g = function(j) {
    return Object.prototype.toString.call(j) === "[object RegExp]";
  }, y = function(j) {
    return !j || typeof j != "object" ? !1 : !!(j.constructor && j.constructor.isBuffer && j.constructor.isBuffer(j));
  }, D = function(j, A) {
    return [].concat(j, A);
  }, p = function(j, A) {
    if (r(j)) {
      for (var w = [], h = 0; h < j.length; h += 1)
        w.push(A(j[h]));
      return w;
    }
    return A(j);
  };
  t.exports = { arrayToObject: s, assign: u, combine: D, compact: d, decode: M, encode: N, isBuffer: y, isRegExp: g, maybeMap: p, merge: l };
}), Ks = Oe((e, t) => {
  var n = Js(), o = Fr(), r = Do(), a = Object.prototype.hasOwnProperty, c = { brackets: function(A) {
    return A + "[]";
  }, comma: "comma", indices: function(A, w) {
    return A + "[" + w + "]";
  }, repeat: function(A) {
    return A;
  } }, s = Array.isArray, l = String.prototype.split, u = Array.prototype.push, M = function(A, w) {
    u.apply(A, s(w) ? w : [w]);
  }, N = Date.prototype.toISOString, d = r.default, g = { addQueryPrefix: !1, allowDots: !1, charset: "utf-8", charsetSentinel: !1, delimiter: "&", encode: !0, encoder: o.encode, encodeValuesOnly: !1, format: d, formatter: r.formatters[d], indices: !1, serializeDate: function(A) {
    return N.call(A);
  }, skipNulls: !1, strictNullHandling: !1 }, y = function(A) {
    return typeof A == "string" || typeof A == "number" || typeof A == "boolean" || typeof A == "symbol" || typeof A == "bigint";
  }, D = {}, p = function A(w, h, f, E, Y, R, U, k, q, se, b, L, O, G, v, F) {
    for (var z = w, J = F, ne = 0, H = !1; (J = J.get(D)) !== void 0 && !H; ) {
      var P = J.get(w);
      if (ne += 1, typeof P != "undefined") {
        if (P === ne)
          throw new RangeError("Cyclic object value");
        H = !0;
      }
      typeof J.get(D) == "undefined" && (ne = 0);
    }
    if (typeof k == "function" ? z = k(h, z) : z instanceof Date ? z = b(z) : f === "comma" && s(z) && (z = o.maybeMap(z, function(ze) {
      return ze instanceof Date ? b(ze) : ze;
    })), z === null) {
      if (Y)
        return U && !G ? U(h, g.encoder, v, "key", L) : h;
      z = "";
    }
    if (y(z) || o.isBuffer(z)) {
      if (U) {
        var B = G ? h : U(h, g.encoder, v, "key", L);
        if (f === "comma" && G) {
          for (var W = l.call(String(z), ","), K = "", X = 0; X < W.length; ++X)
            K += (X === 0 ? "" : ",") + O(U(W[X], g.encoder, v, "value", L));
          return [O(B) + (E && s(z) && W.length === 1 ? "[]" : "") + "=" + K];
        }
        return [O(B) + "=" + O(U(z, g.encoder, v, "value", L))];
      }
      return [O(h) + "=" + O(String(z))];
    }
    var ue = [];
    if (typeof z == "undefined")
      return ue;
    var Me;
    if (f === "comma" && s(z))
      Me = [{ value: z.length > 0 ? z.join(",") || null : void 0 }];
    else if (s(k))
      Me = k;
    else {
      var xe = Object.keys(z);
      Me = q ? xe.sort(q) : xe;
    }
    for (var Se = E && s(z) && z.length === 1 ? h + "[]" : h, Be = 0; Be < Me.length; ++Be) {
      var be = Me[Be], Nt = typeof be == "object" && typeof be.value != "undefined" ? be.value : z[be];
      if (!(R && Nt === null)) {
        var Ct = s(z) ? typeof f == "function" ? f(Se, be) : Se : Se + (se ? "." + be : "[" + be + "]");
        F.set(w, ne);
        var Ce = n();
        Ce.set(D, F), M(ue, A(Nt, Ct, f, E, Y, R, U, k, q, se, b, L, O, G, v, Ce));
      }
    }
    return ue;
  }, j = function(A) {
    if (!A)
      return g;
    if (A.encoder !== null && typeof A.encoder != "undefined" && typeof A.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var w = A.charset || g.charset;
    if (typeof A.charset != "undefined" && A.charset !== "utf-8" && A.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var h = r.default;
    if (typeof A.format != "undefined") {
      if (!a.call(r.formatters, A.format))
        throw new TypeError("Unknown format option provided.");
      h = A.format;
    }
    var f = r.formatters[h], E = g.filter;
    return (typeof A.filter == "function" || s(A.filter)) && (E = A.filter), { addQueryPrefix: typeof A.addQueryPrefix == "boolean" ? A.addQueryPrefix : g.addQueryPrefix, allowDots: typeof A.allowDots == "undefined" ? g.allowDots : !!A.allowDots, charset: w, charsetSentinel: typeof A.charsetSentinel == "boolean" ? A.charsetSentinel : g.charsetSentinel, delimiter: typeof A.delimiter == "undefined" ? g.delimiter : A.delimiter, encode: typeof A.encode == "boolean" ? A.encode : g.encode, encoder: typeof A.encoder == "function" ? A.encoder : g.encoder, encodeValuesOnly: typeof A.encodeValuesOnly == "boolean" ? A.encodeValuesOnly : g.encodeValuesOnly, filter: E, format: h, formatter: f, serializeDate: typeof A.serializeDate == "function" ? A.serializeDate : g.serializeDate, skipNulls: typeof A.skipNulls == "boolean" ? A.skipNulls : g.skipNulls, sort: typeof A.sort == "function" ? A.sort : null, strictNullHandling: typeof A.strictNullHandling == "boolean" ? A.strictNullHandling : g.strictNullHandling };
  };
  t.exports = function(A, w) {
    var h = A, f = j(w), E, Y;
    typeof f.filter == "function" ? (Y = f.filter, h = Y("", h)) : s(f.filter) && (Y = f.filter, E = Y);
    var R = [];
    if (typeof h != "object" || h === null)
      return "";
    var U;
    w && w.arrayFormat in c ? U = w.arrayFormat : w && "indices" in w ? U = w.indices ? "indices" : "repeat" : U = "indices";
    var k = c[U];
    if (w && "commaRoundTrip" in w && typeof w.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var q = k === "comma" && w && w.commaRoundTrip;
    E || (E = Object.keys(h)), f.sort && E.sort(f.sort);
    for (var se = n(), b = 0; b < E.length; ++b) {
      var L = E[b];
      f.skipNulls && h[L] === null || M(R, p(h[L], L, k, q, f.strictNullHandling, f.skipNulls, f.encode ? f.encoder : null, f.filter, f.sort, f.allowDots, f.serializeDate, f.format, f.formatter, f.encodeValuesOnly, f.charset, se));
    }
    var O = R.join(f.delimiter), G = f.addQueryPrefix === !0 ? "?" : "";
    return f.charsetSentinel && (f.charset === "iso-8859-1" ? G += "utf8=%26%2310003%3B&" : G += "utf8=%E2%9C%93&"), O.length > 0 ? G + O : "";
  };
}), qs = Oe((e, t) => {
  var n = Fr(), o = Object.prototype.hasOwnProperty, r = Array.isArray, a = { allowDots: !1, allowPrototypes: !1, allowSparse: !1, arrayLimit: 20, charset: "utf-8", charsetSentinel: !1, comma: !1, decoder: n.decode, delimiter: "&", depth: 5, ignoreQueryPrefix: !1, interpretNumericEntities: !1, parameterLimit: 1e3, parseArrays: !0, plainObjects: !1, strictNullHandling: !1 }, c = function(y) {
    return y.replace(/&#(\d+);/g, function(D, p) {
      return String.fromCharCode(parseInt(p, 10));
    });
  }, s = function(y, D) {
    return y && typeof y == "string" && D.comma && y.indexOf(",") > -1 ? y.split(",") : y;
  }, l = "utf8=%26%2310003%3B", u = "utf8=%E2%9C%93", M = function(y, D) {
    var p = {}, j = D.ignoreQueryPrefix ? y.replace(/^\?/, "") : y, A = D.parameterLimit === 1 / 0 ? void 0 : D.parameterLimit, w = j.split(D.delimiter, A), h = -1, f, E = D.charset;
    if (D.charsetSentinel)
      for (f = 0; f < w.length; ++f)
        w[f].indexOf("utf8=") === 0 && (w[f] === u ? E = "utf-8" : w[f] === l && (E = "iso-8859-1"), h = f, f = w.length);
    for (f = 0; f < w.length; ++f)
      if (f !== h) {
        var Y = w[f], R = Y.indexOf("]="), U = R === -1 ? Y.indexOf("=") : R + 1, k, q;
        U === -1 ? (k = D.decoder(Y, a.decoder, E, "key"), q = D.strictNullHandling ? null : "") : (k = D.decoder(Y.slice(0, U), a.decoder, E, "key"), q = n.maybeMap(s(Y.slice(U + 1), D), function(se) {
          return D.decoder(se, a.decoder, E, "value");
        })), q && D.interpretNumericEntities && E === "iso-8859-1" && (q = c(q)), Y.indexOf("[]=") > -1 && (q = r(q) ? [q] : q), o.call(p, k) ? p[k] = n.combine(p[k], q) : p[k] = q;
      }
    return p;
  }, N = function(y, D, p, j) {
    for (var A = j ? D : s(D, p), w = y.length - 1; w >= 0; --w) {
      var h, f = y[w];
      if (f === "[]" && p.parseArrays)
        h = [].concat(A);
      else {
        h = p.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var E = f.charAt(0) === "[" && f.charAt(f.length - 1) === "]" ? f.slice(1, -1) : f, Y = parseInt(E, 10);
        !p.parseArrays && E === "" ? h = { 0: A } : !isNaN(Y) && f !== E && String(Y) === E && Y >= 0 && p.parseArrays && Y <= p.arrayLimit ? (h = [], h[Y] = A) : E !== "__proto__" && (h[E] = A);
      }
      A = h;
    }
    return A;
  }, d = function(y, D, p, j) {
    if (y) {
      var A = p.allowDots ? y.replace(/\.([^.[]+)/g, "[$1]") : y, w = /(\[[^[\]]*])/, h = /(\[[^[\]]*])/g, f = p.depth > 0 && w.exec(A), E = f ? A.slice(0, f.index) : A, Y = [];
      if (E) {
        if (!p.plainObjects && o.call(Object.prototype, E) && !p.allowPrototypes)
          return;
        Y.push(E);
      }
      for (var R = 0; p.depth > 0 && (f = h.exec(A)) !== null && R < p.depth; ) {
        if (R += 1, !p.plainObjects && o.call(Object.prototype, f[1].slice(1, -1)) && !p.allowPrototypes)
          return;
        Y.push(f[1]);
      }
      return f && Y.push("[" + A.slice(f.index) + "]"), N(Y, D, p, j);
    }
  }, g = function(y) {
    if (!y)
      return a;
    if (y.decoder !== null && y.decoder !== void 0 && typeof y.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof y.charset != "undefined" && y.charset !== "utf-8" && y.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var D = typeof y.charset == "undefined" ? a.charset : y.charset;
    return { allowDots: typeof y.allowDots == "undefined" ? a.allowDots : !!y.allowDots, allowPrototypes: typeof y.allowPrototypes == "boolean" ? y.allowPrototypes : a.allowPrototypes, allowSparse: typeof y.allowSparse == "boolean" ? y.allowSparse : a.allowSparse, arrayLimit: typeof y.arrayLimit == "number" ? y.arrayLimit : a.arrayLimit, charset: D, charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : a.charsetSentinel, comma: typeof y.comma == "boolean" ? y.comma : a.comma, decoder: typeof y.decoder == "function" ? y.decoder : a.decoder, delimiter: typeof y.delimiter == "string" || n.isRegExp(y.delimiter) ? y.delimiter : a.delimiter, depth: typeof y.depth == "number" || y.depth === !1 ? +y.depth : a.depth, ignoreQueryPrefix: y.ignoreQueryPrefix === !0, interpretNumericEntities: typeof y.interpretNumericEntities == "boolean" ? y.interpretNumericEntities : a.interpretNumericEntities, parameterLimit: typeof y.parameterLimit == "number" ? y.parameterLimit : a.parameterLimit, parseArrays: y.parseArrays !== !1, plainObjects: typeof y.plainObjects == "boolean" ? y.plainObjects : a.plainObjects, strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : a.strictNullHandling };
  };
  t.exports = function(y, D) {
    var p = g(D);
    if (y === "" || y === null || typeof y == "undefined")
      return p.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var j = typeof y == "string" ? M(y, p) : y, A = p.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, w = Object.keys(j), h = 0; h < w.length; ++h) {
      var f = w[h], E = d(f, j[f], p, typeof y == "string");
      A = n.merge(A, E, p);
    }
    return p.allowSparse === !0 ? A : n.compact(A);
  };
}), Xs = Oe((e, t) => {
  var n = Ks(), o = qs(), r = Do();
  t.exports = { formats: r, parse: o, stringify: n };
}), _s = (e) => {
  var t, n, o, r, a, c;
  let s = typeof window != "undefined";
  if (!e && !s)
    return { inBrowser: s };
  let l = e != null ? e : window.navigator.userAgent;
  return { inBrowser: s, isAndroid: l.includes("Android") || l.includes("Adr"), androidVersion: (n = (t = l.match(/Android\s*([\d|\\.]+)/)) == null ? void 0 : t[1]) != null ? n : "0", iosVersion: ((r = (o = l.match(/\s*OS\s*([\d|\\_]+)/)) == null ? void 0 : o[1]) != null ? r : "0").replace(/_/g, "."), isiOS: /iPad|iPhone|iPod/.test(l), isSafari: l.includes("Safari") && !l.includes("Chrome"), isOpera: !!window.opr && !!window.opr.addons || !!window.opera || l.includes("OPR/"), isChrome: l.includes("Chrome"), isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(l), isInApp: /bstar_[a|i]/i.test(l), safariVersion: (c = (a = l.match(/[v|V]ersion\/([\w|.]+)/)) == null ? void 0 : a[1]) != null ? c : "0" };
}, qo = _s();
function Hr(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
var { toString: Vr } = Object.prototype, { getPrototypeOf: po } = Object, Io = ((e) => (t) => {
  let n = Vr.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), nt = (e) => (e = e.toLowerCase(), (t) => Io(t) === e), Tn = (e) => (t) => typeof t === e, { isArray: zt } = Array, Ft = Tn("undefined");
function $s(e) {
  return e !== null && !Ft(e) && e.constructor !== null && !Ft(e.constructor) && lt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var Zr = nt("ArrayBuffer");
function ec(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Zr(e.buffer), t;
}
var tc = Tn("string"), lt = Tn("function"), Wr = Tn("number"), fo = (e) => e !== null && typeof e == "object", nc = (e) => e === !0 || e === !1, Mn = (e) => {
  if (Io(e) !== "object")
    return !1;
  let t = po(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, oc = nt("Date"), rc = nt("File"), ic = nt("Blob"), ac = nt("FileList"), sc = (e) => fo(e) && lt(e.pipe), cc = (e) => {
  let t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || Vr.call(e) === t || lt(e.toString) && e.toString() === t);
}, lc = nt("URLSearchParams"), uc = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Wt(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let o, r;
  if (typeof e != "object" && (e = [e]), zt(e))
    for (o = 0, r = e.length; o < r; o++)
      t.call(null, e[o], o, e);
  else {
    let a = n ? Object.getOwnPropertyNames(e) : Object.keys(e), c = a.length, s;
    for (o = 0; o < c; o++)
      s = a[o], t.call(null, e[s], s, e);
  }
}
function Jr(e, t) {
  t = t.toLowerCase();
  let n = Object.keys(e), o = n.length, r;
  for (; o-- > 0; )
    if (r = n[o], t === r.toLowerCase())
      return r;
  return null;
}
var Kr = (() => typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global)(), qr = (e) => !Ft(e) && e !== Kr;
function $n() {
  let { caseless: e } = qr(this) && this || {}, t = {}, n = (o, r) => {
    let a = e && Jr(t, r) || r;
    Mn(t[a]) && Mn(o) ? t[a] = $n(t[a], o) : Mn(o) ? t[a] = $n({}, o) : zt(o) ? t[a] = o.slice() : t[a] = o;
  };
  for (let o = 0, r = arguments.length; o < r; o++)
    arguments[o] && Wt(arguments[o], n);
  return t;
}
var Mc = (e, t, n, { allOwnKeys: o } = {}) => (Wt(t, (r, a) => {
  n && lt(r) ? e[a] = Hr(r, n) : e[a] = r;
}, { allOwnKeys: o }), e), gc = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), yc = (e, t, n, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", { value: t.prototype }), n && Object.assign(e.prototype, n);
}, dc = (e, t, n, o) => {
  let r, a, c, s = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (r = Object.getOwnPropertyNames(e), a = r.length; a-- > 0; )
      c = r[a], (!o || o(c, e, t)) && !s[c] && (t[c] = e[c], s[c] = !0);
    e = n !== !1 && po(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Nc = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  let o = e.indexOf(t, n);
  return o !== -1 && o === n;
}, Ac = (e) => {
  if (!e)
    return null;
  if (zt(e))
    return e;
  let t = e.length;
  if (!Wr(t))
    return null;
  let n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Dc = ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && po(Uint8Array)), pc = (e, t) => {
  let n = (e && e[Symbol.iterator]).call(e), o;
  for (; (o = n.next()) && !o.done; ) {
    let r = o.value;
    t.call(e, r[0], r[1]);
  }
}, Ic = (e, t) => {
  let n, o = [];
  for (; (n = e.exec(t)) !== null; )
    o.push(n);
  return o;
}, fc = nt("HTMLFormElement"), jc = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(t, n, o) {
  return n.toUpperCase() + o;
}), Xo = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), hc = nt("RegExp"), Xr = (e, t) => {
  let n = Object.getOwnPropertyDescriptors(e), o = {};
  Wt(n, (r, a) => {
    t(r, a, e) !== !1 && (o[a] = r);
  }), Object.defineProperties(e, o);
}, wc = (e) => {
  Xr(e, (t, n) => {
    if (lt(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    let o = e[n];
    if (lt(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Ec = (e, t) => {
  let n = {}, o = (r) => {
    r.forEach((a) => {
      n[a] = !0;
    });
  };
  return zt(e) ? o(e) : o(String(e).split(t)), n;
}, Tc = () => {
}, xc = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Vn = "abcdefghijklmnopqrstuvwxyz", _o = "0123456789", _r = { DIGIT: _o, ALPHA: Vn, ALPHA_DIGIT: Vn + Vn.toUpperCase() + _o }, mc = (e = 16, t = _r.ALPHA_DIGIT) => {
  let n = "", { length: o } = t;
  for (; e--; )
    n += t[Math.random() * o | 0];
  return n;
};
function Oc(e) {
  return !!(e && lt(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
var zc = (e) => {
  let t = new Array(10), n = (o, r) => {
    if (fo(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (!("toJSON" in o)) {
        t[r] = o;
        let a = zt(o) ? [] : {};
        return Wt(o, (c, s) => {
          let l = n(c, r + 1);
          !Ft(l) && (a[s] = l);
        }), t[r] = void 0, a;
      }
    }
    return o;
  };
  return n(e, 0);
}, Q = { isArray: zt, isArrayBuffer: Zr, isBuffer: $s, isFormData: cc, isArrayBufferView: ec, isString: tc, isNumber: Wr, isBoolean: nc, isObject: fo, isPlainObject: Mn, isUndefined: Ft, isDate: oc, isFile: rc, isBlob: ic, isRegExp: hc, isFunction: lt, isStream: sc, isURLSearchParams: lc, isTypedArray: Dc, isFileList: ac, forEach: Wt, merge: $n, extend: Mc, trim: uc, stripBOM: gc, inherits: yc, toFlatObject: dc, kindOf: Io, kindOfTest: nt, endsWith: Nc, toArray: Ac, forEachEntry: pc, matchAll: Ic, isHTMLForm: fc, hasOwnProperty: Xo, hasOwnProp: Xo, reduceDescriptors: Xr, freezeMethods: wc, toObjectSet: Ec, toCamelCase: jc, noop: Tc, toFiniteNumber: xc, findKey: Jr, global: Kr, isContextDefined: qr, ALPHABET: _r, generateString: mc, isSpecCompliantForm: Oc, toJSONObject: zc };
function Tt(e, t, n, o, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), r && (this.response = r);
}
Q.inherits(Tt, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: Q.toJSONObject(this.config), code: this.code, status: this.response && this.response.status ? this.response.status : null };
} });
var $r = Tt.prototype, ei = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((e) => {
  ei[e] = { value: e };
});
Object.defineProperties(Tt, ei);
Object.defineProperty($r, "isAxiosError", { value: !0 });
Tt.from = (e, t, n, o, r, a) => {
  let c = Object.create($r);
  return Q.toFlatObject(e, c, function(s) {
    return s !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Tt.call(c, e.message, t, n, o, r), c.cause = e, c.name = e.name, a && Object.assign(c, a), c;
};
var de = Tt, Cc = null;
function eo(e) {
  return Q.isPlainObject(e) || Q.isArray(e);
}
function ti(e) {
  return Q.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function $o(e, t, n) {
  return e ? e.concat(t).map(function(o, r) {
    return o = ti(o), !n && r ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function Lc(e) {
  return Q.isArray(e) && !e.some(eo);
}
var vc = Q.toFlatObject(Q, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function kc(e, t, n) {
  if (!Q.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = Q.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(g, y) {
    return !Q.isUndefined(y[g]);
  });
  let o = n.metaTokens, r = n.visitor || u, a = n.dots, c = n.indexes, s = (n.Blob || typeof Blob != "undefined" && Blob) && Q.isSpecCompliantForm(t);
  if (!Q.isFunction(r))
    throw new TypeError("visitor must be a function");
  function l(g) {
    if (g === null)
      return "";
    if (Q.isDate(g))
      return g.toISOString();
    if (!s && Q.isBlob(g))
      throw new de("Blob is not supported. Use a Buffer instead.");
    return Q.isArrayBuffer(g) || Q.isTypedArray(g) ? s && typeof Blob == "function" ? new Blob([g]) : Buffer.from(g) : g;
  }
  function u(g, y, D) {
    let p = g;
    if (g && !D && typeof g == "object") {
      if (Q.endsWith(y, "{}"))
        y = o ? y : y.slice(0, -2), g = JSON.stringify(g);
      else if (Q.isArray(g) && Lc(g) || (Q.isFileList(g) || Q.endsWith(y, "[]")) && (p = Q.toArray(g)))
        return y = ti(y), p.forEach(function(j, A) {
          !(Q.isUndefined(j) || j === null) && t.append(c === !0 ? $o([y], A, a) : c === null ? y : y + "[]", l(j));
        }), !1;
    }
    return eo(g) ? !0 : (t.append($o(D, y, a), l(g)), !1);
  }
  let M = [], N = Object.assign(vc, { defaultVisitor: u, convertValue: l, isVisitable: eo });
  function d(g, y) {
    if (!Q.isUndefined(g)) {
      if (M.indexOf(g) !== -1)
        throw Error("Circular reference detected in " + y.join("."));
      M.push(g), Q.forEach(g, function(D, p) {
        (!(Q.isUndefined(D) || D === null) && r.call(t, D, Q.isString(p) ? p.trim() : p, y, N)) === !0 && d(D, y ? y.concat(p) : [p]);
      }), M.pop();
    }
  }
  if (!Q.isObject(e))
    throw new TypeError("data must be an object");
  return d(e), t;
}
var xn = kc;
function er(e) {
  let t = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function ni(e, t) {
  this._pairs = [], e && xn(e, this, t);
}
var oi = ni.prototype;
oi.append = function(e, t) {
  this._pairs.push([e, t]);
};
oi.toString = function(e) {
  let t = e ? function(n) {
    return e.call(this, n, er);
  } : er;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
var ri = ni;
function Sc(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function ii(e, t, n) {
  if (!t)
    return e;
  let o = n && n.encode || Sc, r = n && n.serialize, a;
  if (r ? a = r(t, n) : a = Q.isURLSearchParams(t) ? t.toString() : new ri(t, n).toString(o), a) {
    let c = e.indexOf("#");
    c !== -1 && (e = e.slice(0, c)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
var bc = class {
  constructor() {
    this.handlers = [];
  }
  use(e, t, n) {
    return this.handlers.push({ fulfilled: e, rejected: t, synchronous: n ? n.synchronous : !1, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(e) {
    Q.forEach(this.handlers, function(t) {
      t !== null && e(t);
    });
  }
}, tr = bc, ai = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Qc = typeof URLSearchParams != "undefined" ? URLSearchParams : ri, Uc = typeof FormData != "undefined" ? FormData : null, Bc = typeof Blob != "undefined" ? Blob : null, Yc = (() => {
  let e;
  return typeof navigator != "undefined" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window != "undefined" && typeof document != "undefined";
})(), Rc = (() => typeof WorkerGlobalScope != "undefined" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Ze = { isBrowser: !0, classes: { URLSearchParams: Qc, FormData: Uc, Blob: Bc }, isStandardBrowserEnv: Yc, isStandardBrowserWebWorkerEnv: Rc, protocols: ["http", "https", "file", "blob", "url", "data"] };
function Gc(e, t) {
  return xn(e, new Ze.classes.URLSearchParams(), Object.assign({ visitor: function(n, o, r, a) {
    return Ze.isNode && Q.isBuffer(n) ? (this.append(o, n.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
  } }, t));
}
function Pc(e) {
  return Q.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Fc(e) {
  let t = {}, n = Object.keys(e), o, r = n.length, a;
  for (o = 0; o < r; o++)
    a = n[o], t[a] = e[a];
  return t;
}
function Hc(e) {
  function t(n, o, r, a) {
    let c = n[a++], s = Number.isFinite(+c), l = a >= n.length;
    return c = !c && Q.isArray(r) ? r.length : c, l ? (Q.hasOwnProp(r, c) ? r[c] = [r[c], o] : r[c] = o, !s) : ((!r[c] || !Q.isObject(r[c])) && (r[c] = []), t(n, o, r[c], a) && Q.isArray(r[c]) && (r[c] = Fc(r[c])), !s);
  }
  if (Q.isFormData(e) && Q.isFunction(e.entries)) {
    let n = {};
    return Q.forEachEntry(e, (o, r) => {
      t(Pc(o), r, n, 0);
    }), n;
  }
  return null;
}
var si = Hc, Vc = { "Content-Type": void 0 };
function Zc(e, t, n) {
  if (Q.isString(e))
    try {
      return (t || JSON.parse)(e), Q.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
var mn = { transitional: ai, adapter: ["xhr", "http"], transformRequest: [function(e, t) {
  let n = t.getContentType() || "", o = n.indexOf("application/json") > -1, r = Q.isObject(e);
  if (r && Q.isHTMLForm(e) && (e = new FormData(e)), Q.isFormData(e))
    return o && o ? JSON.stringify(si(e)) : e;
  if (Q.isArrayBuffer(e) || Q.isBuffer(e) || Q.isStream(e) || Q.isFile(e) || Q.isBlob(e))
    return e;
  if (Q.isArrayBufferView(e))
    return e.buffer;
  if (Q.isURLSearchParams(e))
    return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
  let a;
  if (r) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1)
      return Gc(e, this.formSerializer).toString();
    if ((a = Q.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
      let c = this.env && this.env.FormData;
      return xn(a ? { "files[]": e } : e, c && new c(), this.formSerializer);
    }
  }
  return r || o ? (t.setContentType("application/json", !1), Zc(e)) : e;
}], transformResponse: [function(e) {
  let t = this.transitional || mn.transitional, n = t && t.forcedJSONParsing, o = this.responseType === "json";
  if (e && Q.isString(e) && (n && !this.responseType || o)) {
    let r = !(t && t.silentJSONParsing) && o;
    try {
      return JSON.parse(e);
    } catch (a) {
      if (r)
        throw a.name === "SyntaxError" ? de.from(a, de.ERR_BAD_RESPONSE, this, null, this.response) : a;
    }
  }
  return e;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Ze.classes.FormData, Blob: Ze.classes.Blob }, validateStatus: function(e) {
  return e >= 200 && e < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*" } } };
Q.forEach(["delete", "get", "head"], function(e) {
  mn.headers[e] = {};
});
Q.forEach(["post", "put", "patch"], function(e) {
  mn.headers[e] = Q.merge(Vc);
});
var jo = mn, Wc = Q.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Jc = (e) => {
  let t = {}, n, o, r;
  return e && e.split(`
`).forEach(function(a) {
    r = a.indexOf(":"), n = a.substring(0, r).trim().toLowerCase(), o = a.substring(r + 1).trim(), !(!n || t[n] && Wc[n]) && (n === "set-cookie" ? t[n] ? t[n].push(o) : t[n] = [o] : t[n] = t[n] ? t[n] + ", " + o : o);
  }), t;
}, nr = Symbol("internals");
function Qt(e) {
  return e && String(e).trim().toLowerCase();
}
function gn(e) {
  return e === !1 || e == null ? e : Q.isArray(e) ? e.map(gn) : String(e);
}
function Kc(e) {
  let t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, o;
  for (; o = n.exec(e); )
    t[o[1]] = o[2];
  return t;
}
function qc(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function Zn(e, t, n, o, r) {
  if (Q.isFunction(o))
    return o.call(this, t, n);
  if (r && (t = n), !!Q.isString(t)) {
    if (Q.isString(o))
      return t.indexOf(o) !== -1;
    if (Q.isRegExp(o))
      return o.test(t);
  }
}
function Xc(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, o) => n.toUpperCase() + o);
}
function _c(e, t) {
  let n = Q.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + n, { value: function(r, a, c) {
      return this[o].call(this, t, r, a, c);
    }, configurable: !0 });
  });
}
var On = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, n) {
    let o = this;
    function r(c, s, l) {
      let u = Qt(s);
      if (!u)
        throw new Error("header name must be a non-empty string");
      let M = Q.findKey(o, u);
      (!M || o[M] === void 0 || l === !0 || l === void 0 && o[M] !== !1) && (o[M || s] = gn(c));
    }
    let a = (c, s) => Q.forEach(c, (l, u) => r(l, u, s));
    return Q.isPlainObject(e) || e instanceof this.constructor ? a(e, t) : Q.isString(e) && (e = e.trim()) && !qc(e) ? a(Jc(e), t) : e != null && r(t, e, n), this;
  }
  get(e, t) {
    if (e = Qt(e), e) {
      let n = Q.findKey(this, e);
      if (n) {
        let o = this[n];
        if (!t)
          return o;
        if (t === !0)
          return Kc(o);
        if (Q.isFunction(t))
          return t.call(this, o, n);
        if (Q.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = Qt(e), e) {
      let n = Q.findKey(this, e);
      return !!(n && this[n] !== void 0 && (!t || Zn(this, this[n], n, t)));
    }
    return !1;
  }
  delete(e, t) {
    let n = this, o = !1;
    function r(a) {
      if (a = Qt(a), a) {
        let c = Q.findKey(n, a);
        c && (!t || Zn(n, n[c], c, t)) && (delete n[c], o = !0);
      }
    }
    return Q.isArray(e) ? e.forEach(r) : r(e), o;
  }
  clear(e) {
    let t = Object.keys(this), n = t.length, o = !1;
    for (; n--; ) {
      let r = t[n];
      (!e || Zn(this, this[r], r, e, !0)) && (delete this[r], o = !0);
    }
    return o;
  }
  normalize(e) {
    let t = this, n = {};
    return Q.forEach(this, (o, r) => {
      let a = Q.findKey(n, r);
      if (a) {
        t[a] = gn(o), delete t[r];
        return;
      }
      let c = e ? Xc(r) : String(r).trim();
      c !== r && delete t[r], t[c] = gn(o), n[c] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    let t = /* @__PURE__ */ Object.create(null);
    return Q.forEach(this, (n, o) => {
      n != null && n !== !1 && (t[o] = e && Q.isArray(n) ? n.join(", ") : n);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    let n = new this(e);
    return t.forEach((o) => n.set(o)), n;
  }
  static accessor(e) {
    let t = (this[nr] = this[nr] = { accessors: {} }).accessors, n = this.prototype;
    function o(r) {
      let a = Qt(r);
      t[a] || (_c(n, r), t[a] = !0);
    }
    return Q.isArray(e) ? e.forEach(o) : o(e), this;
  }
};
On.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
Q.freezeMethods(On.prototype);
Q.freezeMethods(On);
var _e = On;
function Wn(e, t) {
  let n = this || jo, o = t || n, r = _e.from(o.headers), a = o.data;
  return Q.forEach(e, function(c) {
    a = c.call(n, a, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), a;
}
function ci(e) {
  return !!(e && e.__CANCEL__);
}
function li(e, t, n) {
  de.call(this, e == null ? "canceled" : e, de.ERR_CANCELED, t, n), this.name = "CanceledError";
}
Q.inherits(li, de, { __CANCEL__: !0 });
var zn = li;
function $c(e, t, n) {
  let o = n.config.validateStatus;
  !n.status || !o || o(n.status) ? e(n) : t(new de("Request failed with status code " + n.status, [de.ERR_BAD_REQUEST, de.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n));
}
var el = Ze.isStandardBrowserEnv ? function() {
  return { write: function(e, t, n, o, r, a) {
    let c = [];
    c.push(e + "=" + encodeURIComponent(t)), Q.isNumber(n) && c.push("expires=" + new Date(n).toGMTString()), Q.isString(o) && c.push("path=" + o), Q.isString(r) && c.push("domain=" + r), a === !0 && c.push("secure"), document.cookie = c.join("; ");
  }, read: function(e) {
    let t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
    return t ? decodeURIComponent(t[3]) : null;
  }, remove: function(e) {
    this.write(e, "", Date.now() - 864e5);
  } };
}() : function() {
  return { write: function() {
  }, read: function() {
    return null;
  }, remove: function() {
  } };
}();
function tl(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function nl(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function ui(e, t) {
  return e && !tl(t) ? nl(e, t) : t;
}
var ol = Ze.isStandardBrowserEnv ? function() {
  let e = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a"), n;
  function o(r) {
    let a = r;
    return e && (t.setAttribute("href", a), a = t.href), t.setAttribute("href", a), { href: t.href, protocol: t.protocol ? t.protocol.replace(/:$/, "") : "", host: t.host, search: t.search ? t.search.replace(/^\?/, "") : "", hash: t.hash ? t.hash.replace(/^#/, "") : "", hostname: t.hostname, port: t.port, pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname };
  }
  return n = o(window.location.href), function(r) {
    let a = Q.isString(r) ? o(r) : r;
    return a.protocol === n.protocol && a.host === n.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function rl(e) {
  let t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function il(e, t) {
  e = e || 10;
  let n = new Array(e), o = new Array(e), r = 0, a = 0, c;
  return t = t !== void 0 ? t : 1e3, function(s) {
    let l = Date.now(), u = o[a];
    c || (c = l), n[r] = s, o[r] = l;
    let M = a, N = 0;
    for (; M !== r; )
      N += n[M++], M = M % e;
    if (r = (r + 1) % e, r === a && (a = (a + 1) % e), l - c < t)
      return;
    let d = u && l - u;
    return d ? Math.round(N * 1e3 / d) : void 0;
  };
}
var al = il;
function or(e, t) {
  let n = 0, o = al(50, 250);
  return (r) => {
    let a = r.loaded, c = r.lengthComputable ? r.total : void 0, s = a - n, l = o(s), u = a <= c;
    n = a;
    let M = { loaded: a, total: c, progress: c ? a / c : void 0, bytes: s, rate: l || void 0, estimated: l && c && u ? (c - a) / l : void 0, event: r };
    M[t ? "download" : "upload"] = !0, e(M);
  };
}
var sl = typeof XMLHttpRequest != "undefined", cl = sl && function(e) {
  return new Promise(function(t, n) {
    let o = e.data, r = _e.from(e.headers).normalize(), a = e.responseType, c;
    function s() {
      e.cancelToken && e.cancelToken.unsubscribe(c), e.signal && e.signal.removeEventListener("abort", c);
    }
    Q.isFormData(o) && (Ze.isStandardBrowserEnv || Ze.isStandardBrowserWebWorkerEnv) && r.setContentType(!1);
    let l = new XMLHttpRequest();
    if (e.auth) {
      let d = e.auth.username || "", g = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      r.set("Authorization", "Basic " + btoa(d + ":" + g));
    }
    let u = ui(e.baseURL, e.url);
    l.open(e.method.toUpperCase(), ii(u, e.params, e.paramsSerializer), !0), l.timeout = e.timeout;
    function M() {
      if (!l)
        return;
      let d = _e.from("getAllResponseHeaders" in l && l.getAllResponseHeaders()), g = { data: !a || a === "text" || a === "json" ? l.responseText : l.response, status: l.status, statusText: l.statusText, headers: d, config: e, request: l };
      $c(function(y) {
        t(y), s();
      }, function(y) {
        n(y), s();
      }, g), l = null;
    }
    if ("onloadend" in l ? l.onloadend = M : l.onreadystatechange = function() {
      !l || l.readyState !== 4 || l.status === 0 && !(l.responseURL && l.responseURL.indexOf("file:") === 0) || setTimeout(M);
    }, l.onabort = function() {
      !l || (n(new de("Request aborted", de.ECONNABORTED, e, l)), l = null);
    }, l.onerror = function() {
      n(new de("Network Error", de.ERR_NETWORK, e, l)), l = null;
    }, l.ontimeout = function() {
      let d = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded", g = e.transitional || ai;
      e.timeoutErrorMessage && (d = e.timeoutErrorMessage), n(new de(d, g.clarifyTimeoutError ? de.ETIMEDOUT : de.ECONNABORTED, e, l)), l = null;
    }, Ze.isStandardBrowserEnv) {
      let d = (e.withCredentials || ol(u)) && e.xsrfCookieName && el.read(e.xsrfCookieName);
      d && r.set(e.xsrfHeaderName, d);
    }
    o === void 0 && r.setContentType(null), "setRequestHeader" in l && Q.forEach(r.toJSON(), function(d, g) {
      l.setRequestHeader(g, d);
    }), Q.isUndefined(e.withCredentials) || (l.withCredentials = !!e.withCredentials), a && a !== "json" && (l.responseType = e.responseType), typeof e.onDownloadProgress == "function" && l.addEventListener("progress", or(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && l.upload && l.upload.addEventListener("progress", or(e.onUploadProgress)), (e.cancelToken || e.signal) && (c = (d) => {
      !l || (n(!d || d.type ? new zn(null, e, l) : d), l.abort(), l = null);
    }, e.cancelToken && e.cancelToken.subscribe(c), e.signal && (e.signal.aborted ? c() : e.signal.addEventListener("abort", c)));
    let N = rl(u);
    if (N && Ze.protocols.indexOf(N) === -1) {
      n(new de("Unsupported protocol " + N + ":", de.ERR_BAD_REQUEST, e));
      return;
    }
    l.send(o || null);
  });
}, yn = { http: Cc, xhr: cl };
Q.forEach(yn, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (n) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
var ll = { getAdapter: (e) => {
  e = Q.isArray(e) ? e : [e];
  let { length: t } = e, n, o;
  for (let r = 0; r < t && (n = e[r], !(o = Q.isString(n) ? yn[n.toLowerCase()] : n)); r++)
    ;
  if (!o)
    throw o === !1 ? new de(`Adapter ${n} is not supported by the environment`, "ERR_NOT_SUPPORT") : new Error(Q.hasOwnProp(yn, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`);
  if (!Q.isFunction(o))
    throw new TypeError("adapter is not a function");
  return o;
}, adapters: yn };
function Jn(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new zn(null, e);
}
function rr(e) {
  return Jn(e), e.headers = _e.from(e.headers), e.data = Wn.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), ll.getAdapter(e.adapter || jo.adapter)(e).then(function(t) {
    return Jn(e), t.data = Wn.call(e, e.transformResponse, t), t.headers = _e.from(t.headers), t;
  }, function(t) {
    return ci(t) || (Jn(e), t && t.response && (t.response.data = Wn.call(e, e.transformResponse, t.response), t.response.headers = _e.from(t.response.headers))), Promise.reject(t);
  });
}
var ir = (e) => e instanceof _e ? e.toJSON() : e;
function xt(e, t) {
  t = t || {};
  let n = {};
  function o(u, M, N) {
    return Q.isPlainObject(u) && Q.isPlainObject(M) ? Q.merge.call({ caseless: N }, u, M) : Q.isPlainObject(M) ? Q.merge({}, M) : Q.isArray(M) ? M.slice() : M;
  }
  function r(u, M, N) {
    if (Q.isUndefined(M)) {
      if (!Q.isUndefined(u))
        return o(void 0, u, N);
    } else
      return o(u, M, N);
  }
  function a(u, M) {
    if (!Q.isUndefined(M))
      return o(void 0, M);
  }
  function c(u, M) {
    if (Q.isUndefined(M)) {
      if (!Q.isUndefined(u))
        return o(void 0, u);
    } else
      return o(void 0, M);
  }
  function s(u, M, N) {
    if (N in t)
      return o(u, M);
    if (N in e)
      return o(void 0, u);
  }
  let l = { url: a, method: a, data: a, baseURL: c, transformRequest: c, transformResponse: c, paramsSerializer: c, timeout: c, timeoutMessage: c, withCredentials: c, adapter: c, responseType: c, xsrfCookieName: c, xsrfHeaderName: c, onUploadProgress: c, onDownloadProgress: c, decompress: c, maxContentLength: c, maxBodyLength: c, beforeRedirect: c, transport: c, httpAgent: c, httpsAgent: c, cancelToken: c, socketPath: c, responseEncoding: c, validateStatus: s, headers: (u, M) => r(ir(u), ir(M), !0) };
  return Q.forEach(Object.keys(e).concat(Object.keys(t)), function(u) {
    let M = l[u] || r, N = M(e[u], t[u], u);
    Q.isUndefined(N) && M !== s || (n[u] = N);
  }), n;
}
var Mi = "1.3.4", ho = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ho[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var ar = {};
ho.transitional = function(e, t, n) {
  function o(r, a) {
    return "[Axios v" + Mi + "] Transitional option '" + r + "'" + a + (n ? ". " + n : "");
  }
  return (r, a, c) => {
    if (e === !1)
      throw new de(o(a, " has been removed" + (t ? " in " + t : "")), de.ERR_DEPRECATED);
    return t && !ar[a] && (ar[a] = !0, console.warn(o(a, " has been deprecated since v" + t + " and will be removed in the near future"))), e ? e(r, a, c) : !0;
  };
};
function ul(e, t, n) {
  if (typeof e != "object")
    throw new de("options must be an object", de.ERR_BAD_OPTION_VALUE);
  let o = Object.keys(e), r = o.length;
  for (; r-- > 0; ) {
    let a = o[r], c = t[a];
    if (c) {
      let s = e[a], l = s === void 0 || c(s, a, e);
      if (l !== !0)
        throw new de("option " + a + " must be " + l, de.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new de("Unknown option " + a, de.ERR_BAD_OPTION);
  }
}
var to = { assertOptions: ul, validators: ho }, at = to.validators, Dn = class {
  constructor(e) {
    this.defaults = e, this.interceptors = { request: new tr(), response: new tr() };
  }
  request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = xt(this.defaults, t);
    let { transitional: n, paramsSerializer: o, headers: r } = t;
    n !== void 0 && to.assertOptions(n, { silentJSONParsing: at.transitional(at.boolean), forcedJSONParsing: at.transitional(at.boolean), clarifyTimeoutError: at.transitional(at.boolean) }, !1), o !== void 0 && to.assertOptions(o, { encode: at.function, serialize: at.function }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let a;
    a = r && Q.merge(r.common, r[t.method]), a && Q.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (g) => {
      delete r[g];
    }), t.headers = _e.concat(a, r);
    let c = [], s = !0;
    this.interceptors.request.forEach(function(g) {
      typeof g.runWhen == "function" && g.runWhen(t) === !1 || (s = s && g.synchronous, c.unshift(g.fulfilled, g.rejected));
    });
    let l = [];
    this.interceptors.response.forEach(function(g) {
      l.push(g.fulfilled, g.rejected);
    });
    let u, M = 0, N;
    if (!s) {
      let g = [rr.bind(this), void 0];
      for (g.unshift.apply(g, c), g.push.apply(g, l), N = g.length, u = Promise.resolve(t); M < N; )
        u = u.then(g[M++], g[M++]);
      return u;
    }
    N = c.length;
    let d = t;
    for (M = 0; M < N; ) {
      let g = c[M++], y = c[M++];
      try {
        d = g(d);
      } catch (D) {
        y.call(this, D);
        break;
      }
    }
    try {
      u = rr.call(this, d);
    } catch (g) {
      return Promise.reject(g);
    }
    for (M = 0, N = l.length; M < N; )
      u = u.then(l[M++], l[M++]);
    return u;
  }
  getUri(e) {
    e = xt(this.defaults, e);
    let t = ui(e.baseURL, e.url);
    return ii(t, e.params, e.paramsSerializer);
  }
};
Q.forEach(["delete", "get", "head", "options"], function(e) {
  Dn.prototype[e] = function(t, n) {
    return this.request(xt(n || {}, { method: e, url: t, data: (n || {}).data }));
  };
});
Q.forEach(["post", "put", "patch"], function(e) {
  function t(n) {
    return function(o, r, a) {
      return this.request(xt(a || {}, { method: e, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: o, data: r }));
    };
  }
  Dn.prototype[e] = t(), Dn.prototype[e + "Form"] = t(!0);
});
var dn = Dn, gi = class {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    let n = this;
    this.promise.then((o) => {
      if (!n._listeners)
        return;
      let r = n._listeners.length;
      for (; r-- > 0; )
        n._listeners[r](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let r, a = new Promise((c) => {
        n.subscribe(c), r = c;
      }).then(o);
      return a.cancel = function() {
        n.unsubscribe(r);
      }, a;
    }, e(function(o, r, a) {
      n.reason || (n.reason = new zn(o, r, a), t(n.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners)
      return;
    let t = this._listeners.indexOf(e);
    t !== -1 && this._listeners.splice(t, 1);
  }
  static source() {
    let e;
    return { token: new gi(function(t) {
      e = t;
    }), cancel: e };
  }
}, Ml = gi;
function gl(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function yl(e) {
  return Q.isObject(e) && e.isAxiosError === !0;
}
var no = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511 };
Object.entries(no).forEach(([e, t]) => {
  no[t] = e;
});
var dl = no;
function yi(e) {
  let t = new dn(e), n = Hr(dn.prototype.request, t);
  return Q.extend(n, dn.prototype, t, { allOwnKeys: !0 }), Q.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return yi(xt(e, o));
  }, n;
}
var Ee = yi(jo);
Ee.Axios = dn;
Ee.CanceledError = zn;
Ee.CancelToken = Ml;
Ee.isCancel = ci;
Ee.VERSION = Mi;
Ee.toFormData = xn;
Ee.AxiosError = de;
Ee.Cancel = Ee.CanceledError;
Ee.all = function(e) {
  return Promise.all(e);
};
Ee.spread = gl;
Ee.isAxiosError = yl;
Ee.mergeConfig = xt;
Ee.AxiosHeaders = _e;
Ee.formToJSON = (e) => si(Q.isHTMLForm(e) ? new FormData(e) : e);
Ee.HttpStatusCode = dl;
Ee.default = Ee;
Ys(Xs());
var Nl = ((e) => (e[e.OK = 0] = "OK", e[e.ErrForbidden = -403] = "ErrForbidden", e[e.ErrNotFound = -404] = "ErrNotFound", e[e.ErrUserNotExist = -626] = "ErrUserNotExist", e[e.ErrRegionLimit = 10004001] = "ErrRegionLimit", e[e.ErrArchive = 10004002] = "ErrArchive", e[e.ErrEpisode = 10004003] = "ErrEpisode", e[e.ErrNeedPremium = 10004004] = "ErrNeedPremium", e[e.ErrNeedLogin = 10004005] = "ErrNeedLogin", e[e.ErrNeedBuvid = 10023006] = "ErrNeedBuvid", e[e.ErrSubmitFail = 10023007] = "ErrSubmitFail", e[e.ErrCommentClose = 10023008] = "ErrCommentClose", e[e.ErrAccountOrPassword = -629] = "ErrAccountOrPassword", e[e.ErrCaptcha = -105] = "ErrCaptcha", e[e.DecryptError = 86e3] = "DecryptError", e[e.NeedCaptcha = 86001] = "NeedCaptcha", e[e.EmptyArea = 86003] = "EmptyArea", e[e.EmptyPhone = 86004] = "EmptyPhone", e[e.ErrorPhone = 86005] = "ErrorPhone", e[e.BanPhone = 86015] = "BanPhone", e[e.FrequentSend = 86200] = "FrequentSend", e[e.ErrorSmsCode = 86202] = "ErrorSmsCode", e[e.LimitSend = 86203] = "LimitSend", e[e.TooManySend = 86204] = "TooManySend", e[e.OverdueSmsCode = 86205] = "OverdueSmsCode", e[e.DiffArea = 86206] = "DiffArea", e[e.DiffPhone = 86207] = "DiffPhone", e[e.UnlegalSend = 86208] = "UnlegalSend", e[e.ErrorPhone2 = 66031] = "ErrorPhone2", e[e.ErrorAccountOrPassword = -629] = "ErrorAccountOrPassword", e[e.ErrorCaptcha = -105] = "ErrorCaptcha", e[e.PhoneLimit = 86071] = "PhoneLimit", e[e.AreaLimit = 10003003] = "AreaLimit", e[e.EmailSendFail = 86250] = "EmailSendFail", e[e.EmailSendInvalid = 86251] = "EmailSendInvalid", e[e.EmailSent = 86252] = "EmailSent", e[e.TooManyEmailSend = 86253] = "TooManyEmailSend", e[e.TooManyEmailSendIp = 86254] = "TooManyEmailSendIp", e[e.OverdueEmail = 86255] = "OverdueEmail", e[e.DiffEmail = 86256] = "DiffEmail", e[e.ErrorEmailCode = 86257] = "ErrorEmailCode", e[e.EmailInvalid = 86258] = "EmailInvalid", e[e.InvalidPassword = 86306] = "InvalidPassword", e[e.OccupyEmail = 86259] = "OccupyEmail", e[e.ResentEmailCode = 86150] = "ResentEmailCode", e[e.QrcodeScanTimeout = 10018100] = "QrcodeScanTimeout", e[e.QrcodeNotScan = 10018101] = "QrcodeNotScan", e[e.QrcodeScaned = 10018102] = "QrcodeScaned", e))(Nl || {}), sr, cr, lr;
!qo.isSafari || Number((lr = (cr = (sr = qo) == null ? void 0 : sr.safariVersion) == null ? void 0 : cr.split(".")) == null ? void 0 : lr[0]) >= 14;
var Al = /\.(\w+)@(\w+)(\.\w+)?$/, Dl = (e, t, n, o = 90) => e ? Al.test(e) ? e.replace(/(\.\w+)$/, "") : `${e}@${t ? `${t}w_` : ""}${n ? `${n}h_` : ""}1e_1c_${o}q` : "";
const pl = { class: "bstar-image" }, Il = ["srcset"], fl = ["srcset"], jl = ["src", "alt", "loading"], hl = {
  name: "BImage"
}, wl = /* @__PURE__ */ $(he(je({}, hl), {
  props: {
    src: null,
    alt: { default: "" },
    width: null,
    height: null,
    loading: { default: "eager" },
    openAvif: { type: Boolean, default: !1 }
  },
  emits: ["load", "error"],
  setup(e, { emit: t }) {
    const n = e, { src: o, width: r, height: a, openAvif: c } = le(n), s = V(() => {
      const d = i(r), g = i(a);
      return i(c) && d && d >= 64 && d <= 4096 && g && g >= 64 && g <= 2304 && /(p\.bstarstatic\.com)|(p-bstarstatic\.akamaized\.net)/.test(i(o));
    }), l = V(() => o.value && !o.value.includes(".gif")), u = V(() => {
      const d = i(o);
      return i(l) ? Dl(d, i(r), i(a)) : d;
    }), M = (d) => {
      t("load", d);
    }, N = (d) => {
      t("error", d);
    };
    return (d, g) => (I(), S("picture", pl, [
      i(l) && i(s) ? (I(), S("source", {
        key: 0,
        srcset: `${i(u)}.avif`,
        type: "image/avif"
      }, null, 8, Il)) : ee("", !0),
      i(l) ? (I(), S("source", {
        key: 1,
        srcset: `${i(u)}.webp`,
        type: "image/webp"
      }, null, 8, fl)) : ee("", !0),
      C("img", {
        class: "bstar-image__img",
        src: i(u),
        alt: e.alt,
        loading: e.loading,
        onLoad: M,
        onError: N
      }, null, 40, jl)
    ]));
  }
})), di = Fe(wl), El = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTQgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+MTRweOWLvjwvdGl0bGU+CiAgICA8ZyBpZD0i5o6n5Lu2IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iaWNvbl9jaGVja2JveF9zZWxlY3RlZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIuMDAwMDAwLCAtMi4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IjE0cHjli74iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIuMDAwMDAwLCAyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IuefqeW9oiIgZmlsbD0iI0NDQ0NDQyIgb3BhY2l0eT0iMCIgeD0iMCIgeT0iMCIgd2lkdGg9IjE0IiBoZWlnaHQ9IjE0Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMywyLjY1Njg1NDI1IEMzLjUxMjgzNTg0LDIuNjU2ODU0MjUgMy45MzU1MDcxNiwzLjA0Mjg5NDQ0IDMuOTkzMjcyMjcsMy41NDAyMzMxMiBMNCwzLjY1Njg1NDI1IEw0LDYuNjU2ODU0MjUgTDExLDYuNjU2ODU0MjUgQzExLjUxMjgzNTgsNi42NTY4NTQyNSAxMS45MzU1MDcyLDcuMDQyODk0NDQgMTEuOTkzMjcyMyw3LjU0MDIzMzEyIEwxMiw3LjY1Njg1NDI1IEMxMiw4LjE2OTY5MDA5IDExLjYxMzk1OTgsOC41OTIzNjE0MSAxMS4xMTY2MjExLDguNjUwMTI2NTIgTDExLDguNjU2ODU0MjUgTDMsOC42NTY4NTQyNSBDMi40ODcxNjQxNiw4LjY1Njg1NDI1IDIuMDY0NDkyODQsOC4yNzA4MTQwNiAyLjAwNjcyNzczLDcuNzczNDc1MzcgTDIsNy42NTY4NTQyNSBMMiwzLjY1Njg1NDI1IEMyLDMuMTA0NTY5NSAyLjQ0NzcxNTI1LDIuNjU2ODU0MjUgMywyLjY1Njg1NDI1IFoiIGlkPSLli74iIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4wMDAwMDAsIDUuNjU2ODU0KSByb3RhdGUoLTQ1LjAwMDAwMCkgdHJhbnNsYXRlKC03LjAwMDAwMCwgLTUuNjU2ODU0KSAiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+", Tl = ["src"], xl = ["disabled", "value", "name", "checked"], ml = { class: "bstar-checkbox__label" }, Ol = {
  name: "BCheckbox"
}, zl = /* @__PURE__ */ $(he(je({}, Ol), {
  props: {
    modelValue: { type: Boolean, default: !1 },
    value: { type: [String, Number, Boolean], default: "" },
    label: { default: "" },
    disabled: { type: Boolean, default: !1 },
    circle: { type: Boolean, default: !1 }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, { value: o, disabled: r, modelValue: a } = le(n), c = io("CheckboxGroup", {}), s = V(() => {
      var N;
      return c != null && c.props ? (N = c.props) == null ? void 0 : N.value.includes(i(o)) : i(a);
    }), l = V(() => {
      var N, d;
      return (d = (N = c == null ? void 0 : c.props) == null ? void 0 : N.itemStyle) != null ? d : {};
    }), u = V(() => {
      var N;
      return i(r) || ((N = c == null ? void 0 : c.props) == null ? void 0 : N.disabled);
    }), M = (N) => {
      const d = N.target;
      c && c.handleChange ? (t("change", !i(s)), t("update:modelValue", !i(s)), c.handleChange(`${i(o)}`, !i(s))) : (t("change", d.checked), t("update:modelValue", d.checked));
    };
    return (N, d) => (I(), S("label", {
      class: x([
        "bstar-checkbox",
        {
          "is-disabled": i(u),
          "is-checked": i(s)
        }
      ]),
      style: $e(i(l))
    }, [
      C("span", {
        class: x(["bstar-checkbox__input", {
          "is-disabled": i(u),
          "is-checked": i(s)
        }])
      }, [
        C("span", {
          class: x([
            "bstar-checkbox__inner",
            { "bstar-checkbox__inner--circle": e.circle }
          ])
        }, [
          C("img", {
            class: "bstar-checkbox__checked-icon",
            src: i(El),
            alt: "checkbox"
          }, null, 8, Tl)
        ], 2),
        C("input", {
          class: "bstar-checkbox__original",
          type: "checkbox",
          disabled: i(u),
          value: i(o),
          name: e.label,
          checked: i(s),
          tabindex: "-1",
          onChange: M
        }, null, 40, xl)
      ], 2),
      Ie(N.$slots, "default", {}, () => [
        C("span", ml, Z(e.label), 1)
      ], !0)
    ], 6));
  }
})), Cl = /* @__PURE__ */ tt(zl, [["__scopeId", "data-v-04cca47e"]]), Ll = {
  class: "bstar-checkbox-group",
  role: "checkbox"
}, vl = {
  name: "BCheckboxGroup"
}, kl = /* @__PURE__ */ $(he(je({}, vl), {
  props: {
    value: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    itemStyle: { default: () => ({}) }
  },
  emits: ["change", "input"],
  setup(e, { emit: t }) {
    const n = e, { value: o } = le(n);
    return pn("CheckboxGroup", {
      name: "BCheckboxGroup",
      props: n,
      handleChange: (r, a) => {
        var c, s;
        const l = a ? [...(c = i(o)) != null ? c : [], r] : ((s = i(o)) != null ? s : []).filter((u) => u !== r);
        t("input", l), t("change", l);
      }
    }), (r, a) => (I(), S("div", Ll, [
      Ie(r.$slots, "default")
    ]));
  }
}));
Fe(Cl);
Fe(kl);
const Sl = typeof window == "undefined", bl = (e) => typeof Element == "undefined" ? !1 : e instanceof Element, st = /* @__PURE__ */ new Map();
let ur;
Sl || (document.addEventListener("mousedown", (e) => ur = e), document.addEventListener("mouseup", (e) => {
  for (const t of st.values())
    for (const { documentHandler: n } of t)
      n(e, ur);
}));
function Mr(e, t) {
  let n = [];
  return Array.isArray(t.arg) ? n = t.arg : bl(t.arg) && n.push(t.arg), function(o, r) {
    const a = t.instance.popperRef, c = o.target, s = r == null ? void 0 : r.target, l = !t || !t.instance, u = !c || !s, M = e.contains(c) || e.contains(s), N = e === c, d = n.length && n.some((y) => y == null ? void 0 : y.contains(c)) || n.length && n.includes(s), g = a && (a.contains(c) || a.contains(s));
    l || u || M || N || d || g || t.value(o, r);
  };
}
const wo = {
  beforeMount(e, t) {
    st.has(e) || st.set(e, []);
    const n = st.get(e);
    n == null || n.push({
      documentHandler: Mr(e, t),
      bindingFn: t.value
    });
  },
  updated(e, t) {
    st.has(e) || st.set(e, []);
    const n = st.get(e), o = n == null ? void 0 : n.findIndex(
      (a) => a.bindingFn === t.oldValue
    ), r = {
      documentHandler: Mr(e, t),
      bindingFn: t.value
    };
    o && o >= 0 ? n == null || n.splice(o, 1, r) : n == null || n.push(r);
  },
  unmounted(e) {
    st.delete(e);
  }
};
function Ni(e) {
  const { placement: t, offset: n, skipping: o } = e;
  return {
    placement: t,
    modifiers: Ql({
      offset: n,
      skipping: o
    })
  };
}
function Ql({
  skipping: e = 0,
  offset: t = 0
} = {}) {
  return [
    {
      name: "offset",
      options: {
        offset: [e, t]
      }
    },
    {
      name: "computeStyles",
      options: {
        gpuAcceleration: !1,
        adaptive: !1
      }
    }
  ];
}
const Ul = { class: "bstar-popper" }, Bl = {
  name: "BPopper"
}, Yl = /* @__PURE__ */ $(he(je({}, Bl), {
  props: {
    visible: { type: Boolean, default: !1 },
    placement: { default: "top-start" },
    offset: { default: 0 },
    skipping: { default: 0 },
    referenceStyle: { default: () => ({}) }
  },
  setup(e, { expose: t }) {
    const n = e, o = te(), r = te(), a = te(), { visible: c, placement: s, offset: l, skipping: u } = le(n), M = () => {
      !o.value || !r.value || (a.value = Rr(
        o.value,
        r.value,
        Ni({
          placement: i(s),
          offset: i(l),
          skipping: i(u)
        })
      ), setTimeout(() => {
        N();
      }, 500));
    };
    Ve(() => {
      M();
    }), In(() => {
      d();
    });
    const N = () => {
      var y;
      (y = i(a)) == null || y.update();
    };
    mt(() => i(c), () => {
      N();
    });
    const d = () => {
      var y;
      (y = i(a)) == null || y.destroy(), a.value = null;
    }, g = V(() => ({
      "bstar-popper__content": !0,
      "bstar-popper__content--slider": !0,
      "bstar-popper__content--active": i(c)
    }));
    return t({
      updateHandler: N
    }), (y, D) => (I(), S("div", Ul, [
      C("div", {
        ref_key: "referenceEl",
        ref: o,
        class: "bstar-popper__reference",
        style: $e(e.referenceStyle)
      }, [
        Ie(y.$slots, "default", {}, void 0, !0)
      ], 4),
      C("div", {
        ref_key: "contentEl",
        ref: r,
        class: x(i(g))
      }, [
        Ie(y.$slots, "content", {}, void 0, !0)
      ], 2)
    ]));
  }
})), Ai = /* @__PURE__ */ tt(Yl, [["__scopeId", "data-v-0ad4c5c9"]]), Rl = (e) => (Si("data-v-0f552eb8"), e = e(), bi(), e), Gl = { class: "select" }, Pl = { class: "select__popper" }, Fl = {
  key: 0,
  class: "select__search"
}, Hl = /* @__PURE__ */ Rl(() => /* @__PURE__ */ C("div", { class: "select__search-icon" }, null, -1)), Vl = ["placeholder"], Zl = {
  name: "BSelect"
}, Wl = /* @__PURE__ */ $(he(je({}, Zl), {
  props: {
    id: { default: "" },
    label: { default: "" },
    filterable: { type: Boolean, default: !1 },
    placeholder: { default: "" }
  },
  emits: ["selectInput", "update:id"],
  setup(e, { emit: t }) {
    const n = e, { id: o, label: r, filterable: a } = le(n), c = te(!1), s = te(""), l = te();
    pn("selectState", {
      id: o,
      changeId: (g) => {
        c.value = !1, t("update:id", i(g));
      }
    });
    const u = () => {
      c.value = !i(c);
    }, M = () => {
      c.value = !1;
    }, N = (g) => {
      const y = g.target;
      t("selectInput", y.value);
    }, d = () => {
      const g = l.value, y = g == null ? void 0 : g.querySelector(".select-option-active");
      y && g && setTimeout(() => {
        const D = g.offsetHeight, p = y.offsetTop - D / 4;
        g.scrollTo(0, p);
      }, 0);
    };
    return mt(c, (g) => {
      g && fr(() => {
        d();
      });
    }), (g, y) => Ue((I(), S("div", Gl, [
      ce(Ai, {
        visible: c.value,
        placement: "bottom-start"
      }, {
        content: ye(() => [
          C("div", Pl, [
            i(a) ? (I(), S("div", Fl, [
              Hl,
              Ue(C("input", {
                "onUpdate:modelValue": y[0] || (y[0] = (D) => s.value = D),
                class: "select__search-input",
                placeholder: e.placeholder,
                onInput: N
              }, null, 40, Vl), [
                [jr, s.value]
              ])
            ])) : ee("", !0),
            C("div", {
              ref_key: "selectWrapper",
              ref: l,
              class: "select__select-option"
            }, [
              Ie(g.$slots, "default", {}, void 0, !0)
            ], 512)
          ])
        ]),
        default: ye(() => [
          C("div", {
            class: "select__content",
            onClick: u
          }, [
            fe(Z(i(r)) + " ", 1),
            C("div", {
              class: x(["select__icon", { "is-focus": c.value }])
            }, null, 2)
          ])
        ]),
        _: 3
      }, 8, ["visible"])
    ])), [
      [i(wo), M]
    ]);
  }
})), Jl = /* @__PURE__ */ tt(Wl, [["__scopeId", "data-v-0f552eb8"]]), Kl = {
  name: "BSelectOption"
}, ql = /* @__PURE__ */ $(he(je({}, Kl), {
  props: {
    value: { default: "" },
    label: { default: "" },
    isActive: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, { value: n } = le(t), o = io("selectState"), r = () => {
      o == null || o.changeId(i(n));
    };
    return (a, c) => (I(), S("div", {
      class: x(["select-option", e.isActive ? "select-option-active" : ""]),
      onClick: r
    }, [
      Ie(a.$slots, "default", {}, () => [
        fe(Z(e.label), 1)
      ], !0)
    ], 2));
  }
})), Xl = /* @__PURE__ */ tt(ql, [["__scopeId", "data-v-2f61209e"]]);
Fe(Jl);
Fe(Xl);
const _l = ["value", "type", "disabled", "readonly", "placeholder", "maxlength", "onKeyup"], $l = ["onClick"], eu = {
  key: 1,
  class: "bstar-input__count"
}, tu = {
  key: 2,
  class: "bstar-input__suffix"
}, nu = {
  name: "BInput"
}, ou = /* @__PURE__ */ $(he(je({}, nu), {
  props: {
    modelValue: null,
    type: { default: "text" },
    placeholder: null,
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean },
    maxlength: { default: void 0 },
    error: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    dark: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur", "input", "change", "enter"],
  setup(e, { emit: t }) {
    const n = e, { modelValue: o, disabled: r, maxlength: a, error: c, clearable: s, dark: l } = le(n), u = Ir(), M = te(!1), N = V(() => u.suffix !== void 0), d = V(() => {
      var R;
      return ((R = a == null ? void 0 : a.value) != null ? R : 0) > 0;
    }), g = V(() => d.value && !r.value), y = V(() => (o.value || "").length), D = V(() => i(y) > 0 && i(s)), p = V(() => {
      const R = "bstar-input";
      return [
        R,
        {
          [`${R}--limit`]: g.value,
          [`${R}--has-suffix`]: N.value,
          [`${R}--disabled`]: r.value,
          [`${R}--error`]: c.value,
          [`${R}--dark`]: l.value
        }
      ];
    }), j = V(() => {
      const R = "bstar-input__inner";
      return [
        R,
        {
          [`${R}--focus`]: M.value
        }
      ];
    }), A = (R) => {
      const U = R.target;
      t("input", U.value), t("update:modelValue", U.value);
    }, w = (R) => {
      const U = R.target;
      t("change", U.value);
    }, h = (R) => {
      M.value = !0, t("focus", R);
    }, f = (R) => {
      M.value = !1, t("blur", R);
    }, E = () => {
      t("update:modelValue", "");
    }, Y = (R) => {
      t("enter", R);
    };
    return (R, U) => (I(), S("div", {
      class: x(i(p))
    }, [
      Ie(R.$slots, "prepend", {}, void 0, !0),
      C("input", {
        class: x(i(j)),
        value: i(o),
        type: e.type,
        disabled: i(r),
        readonly: e.readonly,
        placeholder: e.placeholder,
        maxlength: i(a),
        onInput: A,
        onChange: w,
        onBlur: f,
        onFocus: h,
        onKeyup: hr(Y, ["enter"])
      }, null, 42, _l),
      i(D) ? (I(), S("span", {
        key: 0,
        class: "bstar-input__clear",
        onClick: ao(E, ["stop"])
      }, null, 8, $l)) : ee("", !0),
      i(g) ? (I(), S("span", eu, Z(i(y)) + "/" + Z(i(a)), 1)) : ee("", !0),
      i(u).suffix ? (I(), S("div", tu, [
        Ie(R.$slots, "suffix", {}, void 0, !0)
      ])) : ee("", !0)
    ], 2));
  }
})), oo = /* @__PURE__ */ tt(ou, [["__scopeId", "data-v-e912bc6a"]]);
Fe(oo);
const ru = {
  name: "BConfigProvider"
}, iu = /* @__PURE__ */ $(he(je({}, ru), {
  props: {
    locale: { default: "en" },
    env: { default: "prod" },
    platform: { default: "web" }
  },
  setup(e) {
    const t = e, { locale: n, env: o, platform: r } = le(t);
    return pn("b-config-provider", V(() => ({
      locale: i(n),
      env: i(o),
      platform: i(r)
    }))), (a, c) => Ie(a.$slots, "default");
  }
}));
Fe(iu);
var au = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, Di = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(au, function() {
    var n = 1e3, o = 6e4, r = 36e5, a = "millisecond", c = "second", s = "minute", l = "hour", u = "day", M = "week", N = "month", d = "quarter", g = "year", y = "date", D = "Invalid Date", p = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, j = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, A = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(b) {
      var L = ["th", "st", "nd", "rd"], O = b % 100;
      return "[" + b + (L[(O - 20) % 10] || L[O] || L[0]) + "]";
    } }, w = function(b, L, O) {
      var G = String(b);
      return !G || G.length >= L ? b : "" + Array(L + 1 - G.length).join(O) + b;
    }, h = { s: w, z: function(b) {
      var L = -b.utcOffset(), O = Math.abs(L), G = Math.floor(O / 60), v = O % 60;
      return (L <= 0 ? "+" : "-") + w(G, 2, "0") + ":" + w(v, 2, "0");
    }, m: function b(L, O) {
      if (L.date() < O.date())
        return -b(O, L);
      var G = 12 * (O.year() - L.year()) + (O.month() - L.month()), v = L.clone().add(G, N), F = O - v < 0, z = L.clone().add(G + (F ? -1 : 1), N);
      return +(-(G + (O - v) / (F ? v - z : z - v)) || 0);
    }, a: function(b) {
      return b < 0 ? Math.ceil(b) || 0 : Math.floor(b);
    }, p: function(b) {
      return { M: N, y: g, w: M, d: u, D: y, h: l, m: s, s: c, ms: a, Q: d }[b] || String(b || "").toLowerCase().replace(/s$/, "");
    }, u: function(b) {
      return b === void 0;
    } }, f = "en", E = {};
    E[f] = A;
    var Y = function(b) {
      return b instanceof q;
    }, R = function b(L, O, G) {
      var v;
      if (!L)
        return f;
      if (typeof L == "string") {
        var F = L.toLowerCase();
        E[F] && (v = F), O && (E[F] = O, v = F);
        var z = L.split("-");
        if (!v && z.length > 1)
          return b(z[0]);
      } else {
        var J = L.name;
        E[J] = L, v = J;
      }
      return !G && v && (f = v), v || !G && f;
    }, U = function(b, L) {
      if (Y(b))
        return b.clone();
      var O = typeof L == "object" ? L : {};
      return O.date = b, O.args = arguments, new q(O);
    }, k = h;
    k.l = R, k.i = Y, k.w = function(b, L) {
      return U(b, { locale: L.$L, utc: L.$u, x: L.$x, $offset: L.$offset });
    };
    var q = function() {
      function b(O) {
        this.$L = R(O.locale, null, !0), this.parse(O);
      }
      var L = b.prototype;
      return L.parse = function(O) {
        this.$d = function(G) {
          var v = G.date, F = G.utc;
          if (v === null)
            return new Date(NaN);
          if (k.u(v))
            return new Date();
          if (v instanceof Date)
            return new Date(v);
          if (typeof v == "string" && !/Z$/i.test(v)) {
            var z = v.match(p);
            if (z) {
              var J = z[2] - 1 || 0, ne = (z[7] || "0").substring(0, 3);
              return F ? new Date(Date.UTC(z[1], J, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, ne)) : new Date(z[1], J, z[3] || 1, z[4] || 0, z[5] || 0, z[6] || 0, ne);
            }
          }
          return new Date(v);
        }(O), this.$x = O.x || {}, this.init();
      }, L.init = function() {
        var O = this.$d;
        this.$y = O.getFullYear(), this.$M = O.getMonth(), this.$D = O.getDate(), this.$W = O.getDay(), this.$H = O.getHours(), this.$m = O.getMinutes(), this.$s = O.getSeconds(), this.$ms = O.getMilliseconds();
      }, L.$utils = function() {
        return k;
      }, L.isValid = function() {
        return this.$d.toString() !== D;
      }, L.isSame = function(O, G) {
        var v = U(O);
        return this.startOf(G) <= v && v <= this.endOf(G);
      }, L.isAfter = function(O, G) {
        return U(O) < this.startOf(G);
      }, L.isBefore = function(O, G) {
        return this.endOf(G) < U(O);
      }, L.$g = function(O, G, v) {
        return k.u(O) ? this[G] : this.set(v, O);
      }, L.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, L.valueOf = function() {
        return this.$d.getTime();
      }, L.startOf = function(O, G) {
        var v = this, F = !!k.u(G) || G, z = k.p(O), J = function(ue, Me) {
          var xe = k.w(v.$u ? Date.UTC(v.$y, Me, ue) : new Date(v.$y, Me, ue), v);
          return F ? xe : xe.endOf(u);
        }, ne = function(ue, Me) {
          return k.w(v.toDate()[ue].apply(v.toDate("s"), (F ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Me)), v);
        }, H = this.$W, P = this.$M, B = this.$D, W = "set" + (this.$u ? "UTC" : "");
        switch (z) {
          case g:
            return F ? J(1, 0) : J(31, 11);
          case N:
            return F ? J(1, P) : J(0, P + 1);
          case M:
            var K = this.$locale().weekStart || 0, X = (H < K ? H + 7 : H) - K;
            return J(F ? B - X : B + (6 - X), P);
          case u:
          case y:
            return ne(W + "Hours", 0);
          case l:
            return ne(W + "Minutes", 1);
          case s:
            return ne(W + "Seconds", 2);
          case c:
            return ne(W + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, L.endOf = function(O) {
        return this.startOf(O, !1);
      }, L.$set = function(O, G) {
        var v, F = k.p(O), z = "set" + (this.$u ? "UTC" : ""), J = (v = {}, v[u] = z + "Date", v[y] = z + "Date", v[N] = z + "Month", v[g] = z + "FullYear", v[l] = z + "Hours", v[s] = z + "Minutes", v[c] = z + "Seconds", v[a] = z + "Milliseconds", v)[F], ne = F === u ? this.$D + (G - this.$W) : G;
        if (F === N || F === g) {
          var H = this.clone().set(y, 1);
          H.$d[J](ne), H.init(), this.$d = H.set(y, Math.min(this.$D, H.daysInMonth())).$d;
        } else
          J && this.$d[J](ne);
        return this.init(), this;
      }, L.set = function(O, G) {
        return this.clone().$set(O, G);
      }, L.get = function(O) {
        return this[k.p(O)]();
      }, L.add = function(O, G) {
        var v, F = this;
        O = Number(O);
        var z = k.p(G), J = function(P) {
          var B = U(F);
          return k.w(B.date(B.date() + Math.round(P * O)), F);
        };
        if (z === N)
          return this.set(N, this.$M + O);
        if (z === g)
          return this.set(g, this.$y + O);
        if (z === u)
          return J(1);
        if (z === M)
          return J(7);
        var ne = (v = {}, v[s] = o, v[l] = r, v[c] = n, v)[z] || 1, H = this.$d.getTime() + O * ne;
        return k.w(H, this);
      }, L.subtract = function(O, G) {
        return this.add(-1 * O, G);
      }, L.format = function(O) {
        var G = this, v = this.$locale();
        if (!this.isValid())
          return v.invalidDate || D;
        var F = O || "YYYY-MM-DDTHH:mm:ssZ", z = k.z(this), J = this.$H, ne = this.$m, H = this.$M, P = v.weekdays, B = v.months, W = function(Me, xe, Se, Be) {
          return Me && (Me[xe] || Me(G, F)) || Se[xe].slice(0, Be);
        }, K = function(Me) {
          return k.s(J % 12 || 12, Me, "0");
        }, X = v.meridiem || function(Me, xe, Se) {
          var Be = Me < 12 ? "AM" : "PM";
          return Se ? Be.toLowerCase() : Be;
        }, ue = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: H + 1, MM: k.s(H + 1, 2, "0"), MMM: W(v.monthsShort, H, B, 3), MMMM: W(B, H), D: this.$D, DD: k.s(this.$D, 2, "0"), d: String(this.$W), dd: W(v.weekdaysMin, this.$W, P, 2), ddd: W(v.weekdaysShort, this.$W, P, 3), dddd: P[this.$W], H: String(J), HH: k.s(J, 2, "0"), h: K(1), hh: K(2), a: X(J, ne, !0), A: X(J, ne, !1), m: String(ne), mm: k.s(ne, 2, "0"), s: String(this.$s), ss: k.s(this.$s, 2, "0"), SSS: k.s(this.$ms, 3, "0"), Z: z };
        return F.replace(j, function(Me, xe) {
          return xe || ue[Me] || z.replace(":", "");
        });
      }, L.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, L.diff = function(O, G, v) {
        var F, z = k.p(G), J = U(O), ne = (J.utcOffset() - this.utcOffset()) * o, H = this - J, P = k.m(this, J);
        return P = (F = {}, F[g] = P / 12, F[N] = P, F[d] = P / 3, F[M] = (H - ne) / 6048e5, F[u] = (H - ne) / 864e5, F[l] = H / r, F[s] = H / o, F[c] = H / n, F)[z] || H, v ? P : k.a(P);
      }, L.daysInMonth = function() {
        return this.endOf(N).$D;
      }, L.$locale = function() {
        return E[this.$L];
      }, L.locale = function(O, G) {
        if (!O)
          return this.$L;
        var v = this.clone(), F = R(O, G, !0);
        return F && (v.$L = F), v;
      }, L.clone = function() {
        return k.w(this.$d, this);
      }, L.toDate = function() {
        return new Date(this.valueOf());
      }, L.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, L.toISOString = function() {
        return this.$d.toISOString();
      }, L.toString = function() {
        return this.$d.toUTCString();
      }, b;
    }(), se = q.prototype;
    return U.prototype = se, [["$ms", a], ["$s", c], ["$m", s], ["$H", l], ["$W", u], ["$M", N], ["$y", g], ["$D", y]].forEach(function(b) {
      se[b[1]] = function(L) {
        return this.$g(L, b[0], b[1]);
      };
    }), U.extend = function(b, L) {
      return b.$i || (b(L, q, U), b.$i = !0), U;
    }, U.locale = R, U.isDayjs = Y, U.unix = function(b) {
      return U(1e3 * b);
    }, U.en = E[f], U.Ls = E, U.p = {}, U;
  });
})(Di);
const me = Di.exports, su = /* @__PURE__ */ new Map([
  ["en", {
    placeholder: "Select date",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun"
  }],
  ["th", {
    placeholder: "กรุณาเลือกวันที่",
    mon: "จ",
    tue: "อ",
    wed: "พ",
    thu: "พฤ",
    fri: "ศ",
    sat: "ส",
    sun: "อา"
  }],
  ["vi", {
    placeholder: "Lựa chọn thời gian",
    mon: "T2",
    tue: "T3",
    wed: "T4",
    thu: "T5",
    fri: "T6",
    sat: "T7",
    sun: "CN"
  }],
  ["id", {
    placeholder: "Pilih tanggal",
    mon: "Sen",
    tue: "Sel",
    wed: "Rab",
    thu: "Kam",
    fri: "Jum",
    sat: "Sab",
    sun: "Min"
  }],
  ["ms", {
    placeholder: "Pilih tarikh",
    mon: "Isn",
    tue: "Sel",
    wed: "Rabu",
    thu: "Kha",
    fri: "Jum",
    sat: "Sab",
    sun: "Ahad"
  }]
]), cu = su, Kn = (e, t) => Array(t - e + 1).fill(0).map((n, o) => e + o);
function lu(e, t = 1) {
  const n = e.length;
  if (!n || t < 1)
    return e;
  let o = 0, r = 0;
  const a = Array(Math.ceil(n / t));
  for (; o < n; )
    a[r++] = e.slice(o, o += t);
  return a;
}
const uu = {
  ref: "pickerEl",
  class: "bstar-calendar-panel"
}, Mu = { class: "bstar-calendar-panel__header" }, gu = { class: "bstar-calendar-panel__header__month" }, yu = { class: "bstar-calendar-panel__body" }, du = {
  cellspacing: "0",
  cellpadding: "0"
}, Nu = ["onClick"], Au = {
  name: "BDatePicker"
}, Du = /* @__PURE__ */ $(he(je({}, Au), {
  props: {
    modelValue: null,
    format: { default: "YYYY-MM-DD" },
    disabled: { type: Boolean, default: !1 },
    locale: { default: "en" },
    error: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change", "panel-change", "visible-change", "focus", "blur"],
  setup(e, { emit: t }) {
    const n = e, o = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], r = 7, a = 6 * r, c = "bstar-calendar-panel__body-cell", s = new Date().getTime(), { format: l, modelValue: u, locale: M, error: N } = le(n), d = te(me(i(u))), g = te(!1), y = te(i(d).format(i(l))), { isMobile: D } = Gr(), p = V(() => cu.get(i(M))), j = V(() => i(d).year() || me(s).year()), A = V(() => {
      const F = i(d).month();
      return F || F === 0 ? F : me(s).month();
    }), w = V(() => {
      var F, z;
      return (z = (F = i(p)) == null ? void 0 : F.placeholder) != null ? z : "";
    }), h = V(() => me(new Date(i(j), i(A), 1)).format("YYYY-MM")), f = V(() => {
      const F = "bstar-date-picker";
      return [F, {
        [`${F}--error`]: i(N)
      }];
    }), E = V(
      () => me(new Date(i(j), i(A), 1)).format("YYYY-MM-DD")
    ), Y = V(() => me(i(E)).day()), R = V(() => {
      const F = me(new Date(i(j), i(A), 1)).daysInMonth(), z = me(new Date(i(j), i(A) - 1, 1)).daysInMonth(), J = me(new Date(i(j), i(A) + 1, 1)).daysInMonth(), ne = Kn(1, F).map((B) => ({
        year: i(j),
        month: i(A) + 1,
        day: B,
        active: !0
      })).map((B) => he(je({}, B), { date: `${B.year}-${B.month}-${B.day}` })).map((B) => he(je({}, B), {
        today: me().isSame(me(B.date), "day"),
        selected: i(u) ? me(B.date).isSame(me(i(u)), "date") : !1
      })), H = Kn(1, z).map((B) => ({
        year: i(A) === 0 ? i(j) - 1 : i(j),
        month: i(A) === 0 ? 12 : i(A),
        day: B,
        active: !1,
        today: !1,
        selected: !1
      })).map((B) => he(je({}, B), { date: `${B.year}-${B.month}-${B.day}` })).slice(-(i(Y) || 7)), P = Kn(1, J).map((B) => ({
        year: i(A) === 11 ? i(j) + 1 : i(j),
        month: i(A) === 11 ? 1 : i(A) + 2,
        day: B,
        active: !1,
        today: !1,
        selected: !1
      })).map((B) => he(je({}, B), { date: `${B.year}-${B.month}-${B.day}` })).slice(0, a - (i(Y) || 7) - F);
      return lu([
        ...H,
        ...ne,
        ...P
      ], r);
    }), U = (F) => {
      t(
        "panel-change",
        i(d),
        F
      );
    }, k = () => {
      d.value = i(d).subtract(1, "month"), U("month");
    }, q = () => {
      d.value = i(d).add(1, "month"), U("month");
    }, se = () => {
      d.value = i(d).subtract(1, "year"), U("year");
    }, b = () => {
      d.value = i(d).add(1, "year"), U("year");
    }, L = (F) => {
      d.value = me(F), !(!i(d) || !i(d).isValid()) && (y.value = i(d).format(i(l)), t("update:modelValue", i(y)), t("change", i(y), i(d).valueOf()), g.value = !1, t("visible-change", !1));
    }, O = (F) => {
      const z = me(F, i(l));
      if (!F) {
        t("update:modelValue", ""), t("change", "", "");
        return;
      }
      z.isValid() && (d.value = z, t("update:modelValue", i(y)), t("change", i(y), i(d).valueOf()), g.value = !1, t("visible-change", !1));
    }, G = (F) => {
      g.value = !0, t("focus", F), t("visible-change", !0);
    }, v = (F) => {
      g.value = !1, d.value = me(i(u)), t("visible-change", !1), t("blur", F);
    };
    return (F, z) => Ue((I(), S("div", {
      class: x(i(f))
    }, [
      i(D) ? (I(), _(oo, {
        key: 0,
        modelValue: y.value,
        "onUpdate:modelValue": z[0] || (z[0] = (J) => y.value = J),
        type: "date",
        disabled: e.disabled,
        error: i(N),
        placeholder: i(w),
        onChange: O
      }, null, 8, ["modelValue", "disabled", "error", "placeholder"])) : (I(), _(Ai, {
        key: 1,
        visible: g.value,
        placement: "bottom-start",
        offset: 4
      }, {
        content: ye(() => [
          C("div", uu, [
            C("div", Mu, [
              C("div", null, [
                C("i", {
                  class: "icon-double-arrow last",
                  onClick: se
                }),
                C("i", {
                  class: "icon-arrow last",
                  onClick: k
                })
              ]),
              C("p", gu, Z(i(h)), 1),
              C("div", null, [
                C("i", {
                  class: "icon-arrow next",
                  onClick: q
                }),
                C("i", {
                  class: "icon-double-arrow next",
                  onClick: b
                })
              ])
            ]),
            C("div", yu, [
              C("table", du, [
                C("thead", null, [
                  C("tr", null, [
                    (I(), S(Ae, null, we(o, (J) => C("th", { key: J }, Z(J), 1)), 64))
                  ])
                ]),
                C("tbody", null, [
                  (I(!0), S(Ae, null, we(i(R), (J, ne) => (I(), S("tr", { key: ne }, [
                    (I(!0), S(Ae, null, we(J, (H) => (I(), S("td", {
                      key: H.date,
                      onClick: ao((P) => L(H.date), ["prevent"])
                    }, [
                      C("div", {
                        class: x([c, {
                          [`${c}--active`]: H.active,
                          [`${c}--today`]: H.today,
                          [`${c}--selected`]: H.selected
                        }])
                      }, Z(H.day), 3)
                    ], 8, Nu))), 128))
                  ]))), 128))
                ])
              ])
            ])
          ], 512)
        ]),
        default: ye(() => [
          ce(oo, {
            modelValue: y.value,
            "onUpdate:modelValue": z[1] || (z[1] = (J) => y.value = J),
            placeholder: i(w),
            disabled: e.disabled,
            error: i(N),
            onChange: O,
            onFocus: G
          }, {
            suffix: ye(() => [
              C("i", {
                class: "icon-time",
                onClick: G
              })
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "disabled", "error"])
        ]),
        _: 1
      }, 8, ["visible"]))
    ], 2)), [
      [i(wo), v]
    ]);
  }
})), pu = /* @__PURE__ */ tt(Du, [["__scopeId", "data-v-1227f91b"]]);
Fe(pu);
const Iu = {
  key: 0,
  class: "bstar-tooltip__arrow"
}, fu = {
  name: "BTooltipContent"
}, ju = /* @__PURE__ */ $(he(je({}, fu), {
  props: {
    reference: null,
    content: null,
    placement: { default: "bottom" },
    offset: { default: 0 },
    skipping: { default: 0 },
    showArrow: { type: Boolean, default: !0 },
    zIndex: { default: 8e3 }
  },
  setup(e) {
    const t = e, { reference: n, placement: o, offset: r, skipping: a, zIndex: c } = le(t), s = te(), l = te(), u = () => {
      !n.value || !s.value || (l.value = Rr(
        n.value,
        s.value,
        Ni({
          placement: i(o),
          offset: i(r),
          skipping: i(a)
        })
      ), setTimeout(() => {
        M();
      }, 500));
    }, M = () => {
      fr(() => {
        var d;
        (d = i(l)) == null || d.update();
      });
    }, N = V(() => ({
      "z-index": i(c)
    }));
    return Ve(() => {
      u();
    }), (d, g) => (I(), _(It, { to: "body" }, [
      C("div", {
        ref_key: "contentEl",
        ref: s,
        class: "bstar-tooltip__content",
        style: $e(i(N))
      }, [
        C("p", null, Z(e.content), 1),
        e.showArrow ? (I(), S("div", Iu)) : ee("", !0)
      ], 4)
    ]));
  }
})), hu = /* @__PURE__ */ tt(ju, [["__scopeId", "data-v-51fdbb2c"]]), wu = { class: "bstar-tooltip" }, Eu = {
  name: "BTooltip"
}, Tu = /* @__PURE__ */ $(he(je({}, Eu), {
  props: {
    visible: { type: Boolean, default: !1 },
    content: { default: "" },
    trigger: { default: "hover" },
    placement: { default: "top" },
    offset: { default: 0 },
    skipping: { default: 0 },
    disabled: { type: Boolean, default: !1 },
    showArrow: { type: Boolean, default: !0 },
    zIndex: { default: 8e3 }
  },
  emits: ["update:visible"],
  setup(e, { emit: t }) {
    var n;
    const o = e, {
      placement: r,
      trigger: a,
      visible: c,
      offset: s,
      skipping: l,
      disabled: u
    } = le(o), M = te(null), N = te((n = i(c)) != null ? n : !1), d = (p) => {
      const { type: j } = p;
      if (i(a) === "hover")
        switch (j) {
          case "mouseenter":
            y();
            break;
          case "mouseleave":
            D();
            break;
        }
    };
    mt(() => i(c), (p) => {
      p ? y() : D();
    });
    const g = () => {
      i(a) === "click" && (i(N) ? D() : y());
    }, y = () => {
      i(u) || (N.value = !0, t("update:visible", !0));
    }, D = () => {
      i(u) || (N.value = !1, t("update:visible", !1));
    };
    return (p, j) => Ue((I(), S("div", wu, [
      C("div", {
        ref_key: "reference",
        ref: M,
        class: "bstar-tooltip__body-reference",
        onMouseenter: d,
        onMouseleave: d,
        onClick: g
      }, [
        Ie(p.$slots, "default", {}, void 0, !0)
      ], 544),
      N.value ? (I(), _(hu, {
        key: 0,
        content: e.content,
        reference: M.value,
        placement: i(r),
        offset: i(s),
        "z-index": e.zIndex,
        skipping: i(l),
        "show-arrow": e.showArrow
      }, null, 8, ["content", "reference", "placement", "offset", "z-index", "skipping", "show-arrow"])) : ee("", !0)
    ])), [
      [i(wo), D]
    ]);
  }
})), xu = /* @__PURE__ */ tt(Tu, [["__scopeId", "data-v-9bfba902"]]);
Fe(xu);
const mu = {
  name: "BCollapsedTransition"
}, Ou = /* @__PURE__ */ $(he(je({}, mu), {
  props: {
    appear: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = (s) => {
      s.dataset || (s.dataset = {}), s.style.maxHeight = 0;
    }, n = (s) => {
      s.dataset.oldOverflow = s.style.overflow, s.scrollHeight !== 0 ? s.style.maxHeight = `${s.scrollHeight}px` : s.style.maxHeight = 0, s.style.overflow = "hidden";
    }, o = (s) => {
      s.style.maxHeight = "", s.style.overflow = s.dataset.oldOverflow;
    }, r = (s) => {
      s.dataset || (s.dataset = {}), s.dataset.oldOverflow = s.style.overflow, s.style.maxHeight = `${s.scrollHeight}px`, s.style.overflow = "hidden";
    }, a = (s) => {
      s.scrollHeight !== 0 && (s.style.maxHeight = 0);
    }, c = (s) => {
      s.style.maxHeight = "", s.style.overflow = s.dataset.oldOverflow;
    };
    return (s, l) => (I(), _(wr, {
      name: "bstar-collapse",
      appear: e.appear,
      onBeforeEnter: t,
      onEnter: n,
      onAfterEnter: o,
      onBeforeLeave: r,
      onLeave: a,
      onAfterLeave: c
    }, {
      default: ye(() => [
        Ie(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["appear"]));
  }
}));
Fe(Ou);
const zu = ["id"], Cu = { class: "bstar-message__content" }, Lu = { class: "bstar-message__container" }, vu = {
  name: "BMessage"
};
he(je({}, vu), {
  props: {
    id: null,
    type: { default: "warning" },
    text: null,
    duration: { default: 3e3 },
    offset: { default: 96 },
    onDestroy: { type: Function, default: () => {
    } },
    onClose: { type: Function, default: () => {
    } }
  },
  setup(e) {
    const t = e, { id: n, type: o, text: r, offset: a, duration: c } = le(t), s = te(!1), l = V(() => ({
      top: `${a.value}px`
    })), u = V(() => `bstar-message-${n == null ? void 0 : n.value}`), M = V(() => ({
      "bstar-message__icon": !0,
      [`bstar-message__icon--${i(o)}`]: !0
    })), N = () => {
      setTimeout(() => {
        d();
      }, c.value);
    }, d = () => {
      s.value = !1;
    };
    return Ve(() => {
      N(), s.value = !0;
    }), (g, y) => (I(), _(wr, {
      name: "message-fade",
      onBeforeLeave: e.onClose,
      onAfterLeave: e.onDestroy
    }, {
      default: ye(() => [
        Ue(C("div", {
          id: i(u),
          class: "bstar-message",
          style: $e(i(l))
        }, [
          C("div", Cu, [
            C("i", {
              class: x(i(M))
            }, null, 2),
            C("p", Lu, Z(i(r)), 1)
          ])
        ], 12, zu), [
          [ki, s.value]
        ])
      ]),
      _: 1
    }, 8, ["onBeforeLeave", "onAfterLeave"]));
  }
});
const ku = { class: "time" }, Su = /* @__PURE__ */ $({
  __name: "message-crad",
  props: {
    card: null
  },
  setup(e) {
    const t = e, { classPrefix: n } = re(), o = `${n}-message-card`, { card: r } = le(t), a = () => {
      const { card_uri: c } = i(r);
      c && window.open(c);
    };
    return (c, s) => (I(), S("div", {
      class: x([o, { pointer: i(r).card_uri }]),
      onClick: a
    }, [
      C("div", {
        class: x(`${o}__top`)
      }, [
        ce(Nn, {
          texts: i(r).title_section,
          class: x(`${o}__top-title`)
        }, null, 8, ["texts", "class"]),
        C("div", ku, Z(i(r).pub_time), 1)
      ], 2),
      C("div", {
        class: x(`${o}__content`)
      }, [
        i(r).cover ? (I(), S("div", {
          key: 0,
          class: x(`${o}__content-cover`)
        }, [
          ce(i(di), {
            src: i(r).cover,
            loading: "lazy",
            width: 320,
            height: 94
          }, null, 8, ["src"])
        ], 2)) : ee("", !0),
        ce(Nn, {
          texts: i(r).content_section,
          class: x(`${o}__content-text`)
        }, null, 8, ["texts", "class"])
      ], 2)
    ], 2));
  }
});
const Ut = /* @__PURE__ */ new Map();
let sn = () => {
};
const pi = {
  beforeMount(e, t) {
    const n = t.value;
    Ut.has(e) || Ut.set(e, n);
    const o = () => {
      const r = Ut.get(e) || {}, { disabled: a, distance: c = 50, lister: s, callback: l } = r;
      if (a || !l)
        return;
      const u = e.scrollTop, M = e.scrollHeight || e.scrollHeight, N = e.clientHeight || e.clientHeight;
      s ? l(u) : M - u - N <= c && l();
    };
    sn = Fi(n.delay || 200, o), e.addEventListener("scroll", sn);
  },
  updated(e, t) {
    Ut.set(e, t.value);
  },
  unmounted(e) {
    sn && (e.removeEventListener("scroll", sn), Ut.delete(e));
  }
}, bu = "data:image/gif;base64,R0lGODlhRgBGAPf/AFtbW9zu9YSEhM/o8ur2/fj4+HNzdERERFNTU3t7e/X19dXo7tHp9ODu9dLi7khISJubm2tra+3t7dvt99Ti8c/n7tvq9uXl5eHh4dnt9WRkZPz8/Lm5udXV1dTk8unp6e74/jY2NtHj9LS0tOPw9ebx+LCwsMzMzMTExOb0+snJyfr8/tDl8NPp7t3v96GhoqmpqdDQ0NDo8tDo8Pf7/qysrJGRkdTi9dTm8N3d3aWlpYyMjPz+/9Hj8u31+tXn84iIiPLy8tTj7tXm7paWltnp8sHBwdnZ2Tk5OdDi8uDt99Tm9M7j8tDk9Nns8tnn8s7j79Hk7u33/L29vejy9vDw8PL6/s/p7j09PfH2+tbk7+ny+er1+M/c497r9tLo7NHq75qipc7l9M/m8+Dw+PH4+uv4/fT4+9Xo8dfs9dTs8vb8/tbp8s7l8N3s8tDo7tTp8Z6qtvj6/NLn8tzp89Ln8Nbo9Pb6/dLk9cfX3tnp79Dn9NTp9NLm9PT7/dLl79bm9NPq89vn7dTq79Dj7vb7+7jDyc7l8tLl84qRlY2Wmtbq73BwcH+AgNTk7////9bj8uP0+tLl8eXz/KKxuNLq8sTN0vD5/ePy+OLz+87i9dXk9tbn8dXq9tHe5dbn79Xl9NPo8fn7/dXm7Nfk9PX5/Nfq9OTv+Njr9tXr9NLq8Ovv8oSJjZaanfL5++zz+NXr8vj8/NHq7V9fX9bp+NDp7IiOke/3+tLf5uDo7VBQUOLw/DMzM4GHinR7ffr6+ldXV+f2/P7+/uf2/tHm8dPo89Pj79Pj8tHm79Tl7dLm7dDq8/P5/tHn7eHy+ub0/dHp8e/5//T6/+Lx+uP0/Nbk7dfk8s3k8eDw+vj9/uHy+Nbo9tLm9s/n9tHl7PP6/NLh8dfk9tPk7O/6/Xd3d+T2+/v9/fv9/01NTf79/+T1/f39/dTl9dno9kBAQI6YoNft8Whsb+jt7qWpqrO+wvz7/jw+P87h6Nbn7dfk68bGxrK4vc/Z39Xh6MnT1////yH/C05FVFNDQVBFMi4wAwEAAAAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjFmQS7JHFixgzatx48Rw2iQ+XXeSwbmMBXhw21uC1gSOvi35AMqxo8SXHR7xy6tQ54qZNixlkLkxC86bRoxbT/BDKtKnTp1CjSp1KtarVgTsZZr16cM3Fn0iR8iJyMVhVMl+/XgirEcNPsDeoFmXEti5YTlyZ4KmgBVETRHWiMKnGpxmoOkwQHevRR1MxY4747DFmbA4cHMpOcd3MubPnz6BDix6NMOdD06QFbhnoKquScG7+aQkHCM1OVGgs/OPiWUnGGhF2Ch8+HEmCGBhBlKi6BSO6umF/mqWaIa1FRsN9Cidn3WI3qsO6a/88eREGRrAZeQW5yE2ueOg+McaeyuI88fv4dwq4GA1vVURQQCIEPPA8E8wwwwSj4IIMHqhgggpSM40LUNhBwRI9gOYBNx6E4sgXAywBTTEOzLEMFDKggUYdIkQhjiOI7IFDajTWaOONOOao44489ujjj0A+hYVODW1l407oKGRkaEp4EYwV2VghJTN+rLFGNjSccw4PXHIpzEVcrrCGFcFM4gFnZsAHXwtXhVcTLwIgp+ZFI8wCViBWnTcnRx1IV9UTFwlj3p4b/WRGVXZcpEFGEghX6E5VpBdoO1S5YN0OO8l5VAI7QVATRiJQRc17hH61nkVQuPcpRyO8ZZMC6J2wd+ojaaiK01E5hfBmB0aB9dFURcVa6q0XTUBVCRehEMGwkl60TFWT1BXEBRgcAV8nVnnRQzDZMKtRMCJosQRX0CzABgN1JDOHI6HIIEkUVwgxBwObsLDIIcv8sAQgOFzhSB0MQMFCE5u015kWIvTA4optdEOvEJoso4kjzdRxzAI//AAJDsYQs80NkBhjYwZz9BBKE81s8kkThOBAx2pBxizzzDTXbPPNOOes885NBQQAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQIxb8E+yRxYsYM2rceNFPBokP4V3k8IsjryMbY/Di+GilRWYgGVa06NIkrwO8ct7kBYFlzUcTYi6EM4yl0aMYvRwSyrSp06dQo0qdSrWq1YE6eTHMehWhn4s/kR7l9eLisKrOwIJFIVbjlJo/rVGd+YhR27s/t3UdVIGNlkVzEF3p1IMNogVL9iwrlqxCjz44vC1YdKwCMWMyQBHryrmz58+gQ4seTTphzoenSx/kanDLP9aiRWI8QgRn1tu4s2rQUQCjmVtVU2B8cFdszWBVF6m1SAQ3R2G4e9LEiIPqs+UbhYW4eAIjFp9BLj7/mYu9uNGfAaguwJi7vfvbdi1amWNVsLEKFqYF2z+MwP7/wwQToIAD/hdMCkrwgQgfDGwGmjF/JEMBJBWAgkgdaDQBBzR/4PAGHloMggggAxjjgROqpajiiiy26OKLMMYo44w01vgUEjo1BJuKuim0Y2jf2BGMGVaYYQYI44xziRVM+rHGGjRks4KU50yZzRrSRCNFMC4k0RkB5pnnwVV0hcALMDBsEKZFHQCBI3VWsbcmRypdhBxVTmCkw5wmXWRGVU9cpEFG69y20W3CZFQTD3ZQ5cJyzekEg1jAZLVnSxg1OlUm5fHJXngWgUPedBzVAJdLG4T16UWwjIrpeTnRq8TLCOdhRIarqnr6qkVuUDXJRVMkoKuiGC1TFV0s/SIBBkecgAIHGFwgQW9IoWLVFmAEc86wGgWjBhpFdEXIENzgMIYQ29TxhgN1XNGECEKg0UczezTxwxydLGjMITcsAwkee+AwpmdjLNHhIoAog8YSQuAgoTLEDIEGN9AQQ8wfTSAyhyOVhMJGEyueQYUL4RTDCTumTEBCFja27PLLMMcs88w012zzzVAFBAAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjGhz2qKLFixgzarQYDJHEh04sopCwMcHGdY02PuJl0cpHhsEsslTJi9eLmjUh8NJA8yK8lwtHjVNJtOjFTDOAKl3KtKnTp1CjSp1KdSBOXgyvVkXITKbRrxV5GbFYbqo2r2FngcUIYObKi5ykUqzIc+1Xt4/UbP3RBw8fLcjQgPrzY0CPYo4gLdD0BlqdIaGWLJBRrAUkDz1aeNjKubPnz6BDix5NOmHNh6dLH9SKkLVoNBl/cWik66rt2yEQAOkgDGMwqlwuIrFr1O1vqRbQPgpy+4jGGLcVKH/ER2q56RkFbIRAM4hFblJjhv8lXvyiC6mLLt7mFcKdLgAa4gMDMB8YggdYQtx+YNEPC6pv9DDHG9oEE8wwBhJAAAggjJMFgyBIYQYBCSJ4YDDlmNIECx44EhoU4GiyBAPFSPJGKFfU0cICFezxgwjEVEABG8WIY00KquWo44489ujjj0AGKeSQRBbZlH6pLeSajkuuhpNqdhh4oZRUHmjGMASYoSUICipoIILWfNOZeOR9xcMgVZEZQU3uENHBL3YFMYUGOF1UDFXqlbnRFG4NM5UXFxGh50ZumTEVKhZFkBE6V2l0FQIZuWWOG1IFgFYNV/FX3FVTjGdRUlFRg92gMhVgERzhjWqRTjKFoGpY3lW39FNUZOLlaE2PYFATAEThpU2qnpKKEV4ZSJWCRSO8IOywcE1FwEa/SNCBESa8YMMOjZATARFEvADDFCdcYOpGnVC1BShkLnvROAEQo8VWg2D2x2FweABND1FAIQ4OSxTDDRuCtOHuDVFs80cUiFyhyR43VNPNZxS08MkfM1wBCguItHBMMck0gcgyxrCwzCDHANIDGHWEwk0bSRzS4yv/nEKGPP/gaOTNOOes88489+zzz0AH/VRAACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECMadBHtkcWLGDNq3PgoW7AJEh9au9jhCMeTKB/xujguJMNgF1ee5IVAJS9eGmzOxGjB5UIP51IKTTmsgs+jSJMqXcq0qdOnUKMOvMmrIdWqUg+CiDm0K69fFzNB1cb1UYGbJrta7HBzg0WZFt88hWkRmFqvGItkXQCmBbEl4JjcMCZmDzQ+h8RAGsRAyJ8BTJrIGqBljKw6xcDIzcq5s+fPoEOLHk16qY7SCK8mvGpjNJuTGy6oqLEjQQQNszRoMNCISI0OH9ZxDCYVI9y7Oy0Sf9ruojuMD67yOrDRnXR0xjEievqsLEdhyFUG/7nIZq738ByPu3m6wHiIAxoEQKiBosOFD0GCVPkggf+HDznEwMELAmjwQAg3XXROHVHhwA0xZBAQDAHR+EFDNubwoKEwGp7jYTY0+MHMJSBIOEww5YDCSRTNhLbIFXhosowjdWhRRzIsgIFDDyJoMUMUPwxBSDFRIIIJakgmqeSSTDbp5JNQRinllFQqBQxVVmG5pGoKcVlaH9hM4oI2ZORBjz6W+DNJJJM8k4I6wUzSAAkNNFDOJHi6sIkSnqWAXlcEZEWXWdI9YAAEUxyBnwIFKKBAFRjEYIIAAGBxFSMYRRFVdn9qBAFcyznVAEYCdLoRXMNA9cVFCWikwFWnUuZVgEZwndPAUy6UVYV0U6TEgXQKvIVReU45c56p5x1jnrAc2QAXLwYca9x4FqGyrEoo/ULVI7psm5xFLjw1jLTIHmetU+Na9EIMyGZ03HbiYhREDhzYwAgwB2CBoHRXIXEAAhEIUEMMH2QkFlRKMDBouxjxEMwPymT1Rh/WiEDMHsswwUYTfOCwAAt9DFAHA8qAIk4PfbCxzDFR1NFHCy380Qchn40hCT4V3HBIMsRwg8M1mgByRQvKIPKFHVGAQgEb9xCDBifN4HAFkz78Q4IL8vzDRZVcd+3112CHLfbYZJdtdlMBAQAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjHnRmZsU5GjSyZTzHkYc5HsKEmQv56JEwHiDPaSQwyZFEiJ1KPgoyQqbNmzhzyuQlE8RLhsF26jTJa8MjCLx4PkKiNGfTRxZ+LlwwtKrVmwSSSN3KtavXr2DDih1LtqxALEl5NUyr1uzBYTuBdShwtaqEKU9pkXUh9BGRtCfqllSRVkfJpw7GBi3pTrDjp/DcsmjyYw6ibn2GcGohScwCbh5Y7GlRxxEkNHigoZmjxdGSZHj+kHBLu7bt27hz697Nu7fbGmwVBt/tuLjNCWZtPjWO80PTYGRRyQR2EwDb5YfZzrr59MfYSH2ZD//lFUQmE8XhdcYQoKDkkSlWnyIXa0HmL150xd/8petpj7Ie9BBAMJeco19JwpyzAkuSLENMbknwAUgxFHyBzxB7qALNAqAsUAEyYyBzzCJ7zNDDFX/4puKKLLbo4oswxijjjDTWaKNXEiQVgUNJIeHicAkhkBYWL7JlwkCF/MPMP1kEl81ugERzYFU8ZOKWMzZ1oIE713XpZVohPJCATVZgUpaBh015kwa6yAQdWTYBoCZ3bpK1iExE5ERYUk4lVR5OTa1hJn3hdWnCUMBdlx4YY2USnhEHopDeAOilqZMOTeGXHnd/PtJJpY9gZxM6aY3AljDjHQeqqFM+pQSoO/yRMqdyNnFCFgEy6RDCl7zyGoFNBNxBFiDaoDorTlmN4dYMYzgixDGc1NGCFj+0M0coFjzxRDt2mIIGGnyQyE0F4tSRzAJa/NECNLcRw4cMQ9jRhgeIFIOIIzfgscAYYzQhwg2dsMHGD1ccYowdInDy34pZuOAEIH14wAkkfNhRwo0YZ6zxxhx37PHHIIcs8lcBAQAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjJmxX5Mm/NPEAzNLgi007OhbcoArgoZfJXi4mZCgCSqJLL49iPiIns6bNmzhl8pIZzCXDYDpzPqqxMyavEDEVFMXJK4hMeD4XDqu5rkCVHCemmHhBBIiABOQiRBAAZAcRCDU4nDjyQcEGmxOiyp1Lt67du3jz6t3LdyAvXkga6vrLqy/CZzI3PCAMGB0ARo1sQHhBGULXBBoQuAvBmINMHkv2Tgj6yATjCL+ExixwgPEUozVb6AUKW7VtpjXj8qWjJUogR1C+ICMmiQ0eCiKSFHNgDNEgERSgiajAJBQbNG+u3PhEzLD37+DDi/8fT768+fOGGS9UXx7x7fc4LxmuuRS+6h1IY/bUW0lmo5sfIEEYU3+h88FNS2Wz1ySk2XcbL8LIxMJsDeKk1F+PCPAXFqrV54Ve5chUQw0OPlgTGHw54gIIJd6WzTAtfCFeDyxo0Uc3V3zxhx19zPGJB3V8scAADOBwxR8sMPBDBXyg5+STUEYp5ZRUVmnllVhmqeVdLzykz5QAEMYBQ+xFWaZBwBCmy3lpEHBOi0KZA4IL3rmhWgESYNCBCihwMAUHRqAQwxEXVPFLhDgN01c0FcJJXw4yRcIXfY7iJMxSiup1jEz6SJDTCwXgVMALQi1lRRl6OSGTOzUZwBgvuuDehM6rNFVojV7YkFbFUa85yAFnCtQW0yJ6ufdIfQDmVEWpTsVUh15TCcsUAh8QpsEFvLCaU3264UXbsZVuW5MSFMY0S7i4yYSKXnTQ9ypjIcQb71H0cvYuLyTGBEIAe+FxCbq2OdNDX+1UwoKKmQQTzDAEmAECCNGYMc7DIJhhccMEKBxMOZNMA08Sm3jgBnjELCEEGsQsE4oIf1SgBQub1HGDDN70AAooWsCBxh+a/LDHF4h80Qd6TvTQQjUseMAJBctUYE0UTTTBySYjb2n11VhnrfXWXHft9ddgRxUQACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECM2hMCr4oGENSryQiKxY8FHIB/xCkmypMmTICWMBBnM48JyIVeeLPAi5BGSMFCKDBJykMuEp8zF5BUCy4EH6BAAmzVLg9OmTJkCA6YL3QEsSELwIhJy3M+vAjP8E6THxT8SYNOqXcu2rdu3cOPKVXhOp7ANBYJI+PDhQl8JEoIUWKfzUQC4dEK6C3khgsaKAk42esyL0YeYJB25DYa5sOeTMh+5iVsNhxMXZMqZMQMi2qXXVl7LjpYFBAgzXIKliDRNWwYwY0bNHU68uPHjyJMrX878JwCNDR8rV2MmG4/r585d5yHM3HVhIME//xIGHvz2c9lABPAh10zMGArEf0a5oQqvKiG1ve0UssPNkypscNIvJ+gkk1duOdOZCkQBgcF8IOUAhFYxgBQaFJt1hhIvO2CAQEVEYBDCAQaSZEGGIAEA4YqhOfGWGwSsKCNIK6DCwnBsoCGDEB4g0gQY3XhQBzQsMADFHCwg0wMOiFSwzB84aLLMMmBw0tyVWGap5ZZcdunll2CGKeaYZHpU0UMVMaKldAqho5ENV3Ix0FX22PMCCdMoQYIbDbjhAjpVoSPIaK8cp8QKM0IoDAErxAUTSBdo4A4S7uiigQGN7EAEBC+8oIMOL0AAgQ1AJBABAA+EgMQDOoR0zgxw8f+gYaImMYJOSC255QRJjdBaIktv2RHSDiYFkQASRIG2EREKmCTTCqO1hUpnMTwGDAcC0seBO4/9F9oACWr4oK/jiiRfCyiKpNMLMvEyC0gFhFYSLzyBRIdbw8xqkgLcIiDMCAcgQeyvICmRrry+khSawW1NE5I+CSRsUg6hkfIWZ/DGoIIRI8AQKhE77CCAAAkkQM7IIRNBxAswmMCBPjHgF5JZcKGBjRXySRwSDQSEY8xwAwCyxB9gLKHFMizUEcofaPwARhODtMDHMWAUUwwnPVTAwBBasOBBNUUgx802czDgARQ4aAGFKR4MwQADgzy5BzLXeODNFW+wUebefPcM7fffgAcu+OCE+x0QACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECM2fICFXMNGB9xJ3Fhw2qOPL3TAqFHDhEkTI1CqTMnSZEmSMGDsEPaRRiiOC118fMTrYwwkSGY1gqHiw86jHz/oe9FoFtAjH3vurIAz4bCdD5Bq3cp1p9SPpqo6rPNHRotlkIi1QTQEUBQwHhYtQFNhQDdiA0D1q4CDmDIPYgMLHky4sOHDiBMrXpghAKYSp8iUMESESKt9ZE5hIvM4haUXEF5QyqUE0ykSuZzgWDxnp4QXXDEU2FoAQ9evUhAH89q1Ay99F0zwmqXiApEDt2d/LJI428cLHWLEUKEPBYopRqZM4cCdu3btRlDo/1NxIkaHHB+FSZmwuL379/Djy59Pv779+/gXauDFH4ZCYPyFUB8Bzm0lzAa/KBBEFQwyGIQCBRSwAU1anXMJKoqdw1tXHG71gi47BYNYax8ZQOEjHYxgQwTo8ILAVrrwgo4BNozQwVFfnePIYZFs+MgRVSBl1EcbHCWBkVBFpdwj2xy2W1QcnrCDAETkMMIOO+igwG1HsWfYLRTmoAEEEOigA0klsTRCSy2ZQJKZZAoQwU7ZLJYGCVzckgUzrtzhBw2F3EHDoIT6eccd3yD6DZ9ZgMBFCm6slt+klFZq6aWYZqrpppx26umnoIaaUBX/EPEQBP8YQSkR/PFiqkIotP96gKVYAAXAEf+s8M8l/3DRK0buHKAICPS1M0kZ2WRzzrLMNnsOD8+eYw6z0EI77TnZuMKFC4tlUOAjMRjBgQkxmSnSSOjWUK65Z44wBQpBfjTJD4lJsxMSMWDwAYTrdHjUgQVIcEEOusD2kTOI5XIUOv42/JEEX4l4GBs7jXABUkEY8YIAEGwFgQAvnBCEVl9Jw61h7eyE3CMKvJAAAFiEAEACOmylQwIAYjHzC8p99Qgkh2GzYQ4cc3BEv/4WcAQHH9vG04nLOOmjVjGQsxMQI3ykgNVc8TLyR7BIDSVXv5ATARAA7ACAAQIAY/BWvJzoZWFP8tRhAVUgnWCHPpOEcFgKOzVyo8P+/uLzEohdshMRNjDOuA072CB55FgCAfnlkjeu+Q5GpLeFYpgwoyHhDfNAw3ru4UCHE24E0IALJJBBwuyzn5YZGbhrQ4Y2SpyihAsWTIDKAPU9MccfOEBBiCaHmOWBFiy0QEwUSyzQxBhRaOGEqNx37/334Icv/vjk5xcQACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEhxIq0UfrJlo6FRI8dsK1acG5ltpEmSG7P54eJFW0WG3B7J1HdBJgwONWXq3MlTpgQVI3Ty0mnlZcJgQnvuxMLoxQMEvMi94NVIqcyhOlEZTejjnNWvYHmugbe1rNmzaNOqXcu2rduBvOI2jCv3bcFLQnMUCMtXmIIQJ3Q6W4stqUwMjQ4gSTAiyNcPNSIgOZDgiGGZTNQO0xlhA9/Plx+ZspviS4UxdY71OeThBqgZoCDVKXZsiLEkMjhdQYaoGzG7wIMLH068uPHjyJMrF86BLpaEO+hGKA7Hq84NQS7kiKHCyJQRI0yY/6gx3sQIDlNQqOhw5IOCdTvJsOWyEwnoz0GwPgq2No3OAzt1AEMCD4SAABBKaXAAL7owQgQHjl210zJqlXNZEL/s9IEOOqEAn0w17LRBFUJF+IgWahEQ2n1g6feIC2utoZMGD7hj4wEHPICOLrog4GOPQOqCzgM42ujOAcBwoJMUb0nCxgR0aEMCJlSmkEIJW1iJSTklRFICJqeQIaYLSkwQQCedONDHcmy26eabcMYp55x01mnnnXjmqeeeI9TFUHS8zNImXbwstGBcJiAXABsZWNBJO4ow4osBcaQBjwUBTNBABnk00ounmMKThhuwBDeNdSyCdskTbU2jUweNRP+gQQQRMEJOIwLssAMRNvDK6w5ACEAOI7RqMGuIMmXDAlvCrJgqTzsAKBN/ajmhkzAJPNuiTgSs9YNO2crEyGQG1NBBhlb9BAE56DB42QpkpTXBihjUMAsvB5CjFDkHhGCACRjw5KIyamVymQazENEBaMLEQMQswAiF7iOEqIWUhFZNwQt8F7j7iMZf8bKXTFqldfEjLvbUAQC6RBCEDhAjGPJOMJqsk33azqxTAGo5o5M+QLhXwAYbNMvwOhsooIAEKLg4x1raXIdBDh2cgIIRHHAAnng11ACDeOBlbYQRKsRwhF460aBHW6YEsIUfNJxjDg8s8iAMDzyYRIMU2ixJ4QVwx+yBCBpj9AFHE3wUswkTfPzRzAJieMAHGJt8Qswby/DhCDGOzPE3cg0s8UULnBCDCAOgHOPIIqlMsOfrsMcu++y0175cQAAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIsaJBXhh5JUSSMYHFiSUeiXx0YKTJkyhTjuQ1cthHhMFWqnykgqXIWQVkquQVZKSplwf9jESXsajRo0gxYvk1MhjQp1CjSp1KtarVq1gTGshq0NTJCydgAImgyx2SEElDIHmAgNGOER2qmCRQ1YlOkwoYZUyJMUQjDChtiqwwNaZIwTMT8zUZwKqWCmzAFAuUxoUXFy6wkdGWebMLzkomTHAz4UmxH6H+MPmzhKvr17Bjy55Nu7bt27g/ZsTCsOjsYDwUC09JANFVZneHK+Y1YuQzqqBGcsj5iNEL6sofrVNB5K4fqs7uBv/JuEP4Og0ZPyRnUTg5SqIYgRSVMBNxY6mGHwFRkH04YjZVuUBDf/2ZwQQVXCHChDHJIOMIIkkQ4wEOM7yhhRBz/GCMMsZ4wMIxV4SiBR925GbiiSimqOKKLLbo4oswxijjjDSe+EBGDfmWm44J8SibEs4EY0YwRAaDyRYpEKAkAWY0KYUZT0oBQpNKckGCKlzlR+BwNLRWVX56IWDAC/pcUIAwwv1SxREcjHWjSYFUZRJiW56kg2AuTQXPSBu8UGd9I5lBlRojzTLSBbpkBIR6KqGAXl/lHTYSD6hMFYB7CjSiFKMnGYEWL0BgJ+lIDEw1yV07wFBnDQms1JNI7OG0555JHdikAEYijUDnnNhl0N6oM0FAjhEi6bDDBokh5sKvj4TwJ6AjTTCVFyMFEUIHF0igQAEbCIOmYuusU4ACElzQgV4mQUNVEc8qZ8YPVg0ByzTMZBPcs2gKswYBARwCIFan2HHFEnv84EEFV4zxxSd//PAJMmBoMQgYDiyBxh+h2KHFHkwQ88cbsw2wACF/wJEEKaEIMUgfe7CByA0MIMIAJD14cIWvNeas88489+wzVgEBACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixokFeGHklxJJRg8WJWR6JfIRlpMmTKFOO5DUy2EeEw1aqfKTgwEgTJtHN5BVkZKiXBkHxWJmxqNGjSDN2GEnAA1CI0Ih9IcSiCRgtUYgpS8JiSBtH1pQ8HUu2rNmzaNOqTWhgLcKT66rEqLFDg64DSEIYDRECywFgEWyMyKHgpMuzE2Se7IAkY8qM7kagZDmygtmYIinP3KxS86MAaK+MqVDBAplJ5YKpXk2AwDDXqp+tDvZsUqZpSj6FClXhk9vfwIMLH068uPHjyJOrzYiFYdHiz85xnp7ycForiqlP53Wi5Vk4I430/3wEA4P2k79iZLdyVlt2khgfFN4sQS+vku/rmA32fjIvd/dhBOAUO5nkxn4jJXCedp5x8h1/Cy6YDQNOraVFBW8UM4cMdXgAyihsEALIMvccMgAnXwDSQx9v1LEAGs1cQwwoxyhn44045qjjjjz26OOPQAYp5JBEFvnPAxk19JyNSybUZHGnBTNJMOVE0kADp0SymhmvDWMGAWYEQ8BqzzyjDXAQRqgdDWqlaQMvSDxAjg4nfFCAMJvFlcMUNswCYAgmNYGWSZ6peRIEmg1zVgAmQWBogSIRcBYaI0UwEgcZIaHCZgUgmpFOmY3EgxdmJRbqSSpkxEFKjWSk3kmeibVglnunPvIXngsKAwASK833yB8I1orSCJphJFIVhRLqKyrBPpLsSe6EoIFIDyCRw2aeYWMWF/09SqhJE5hFxkhH2OTtYp7VaBY251JHww9peZABAe2i5EcwiAiylh6QWKPFMogMsIwHUThyQzciEAOIFh4MQIEjY3gjwgJtDFDBAsQssccykAS3hxY4EPNDJT0sc4PIahSDiBgyBNLNJ0tccQgbcLCwBB5oGKnzzjz37PPPagUEACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEix4r9JwSY920InRowO/MwQMMNFCgEpSnKpzGVGZIpJFh82eESzAAyaOHPq3MnzES+cUmIiDIbzZ08VRgvwMmrEKE9eCnC2E3owU84CQT7kiKFvyggTMGC8eEEEgo6wNUZMQfHxgoQCOc2homrRx78UdPPq3cu3r9+/gP8t5dVwMOHABYnSBDbLBgx9OT4UWNcTp7BfWWNwgADE6SNTfV0U1fmhM68HKHiacMcrxI4POj1/4avYZ+Xbtz3P9cuJxQBEM27gIcamDhgGOEDhqCCJECgWIupcgTLkzxgte5h88TCjDuLv4MOL/x9Pvrz58+jTB0YwWIBCw+Wj4Z5/+xzgnJ7p3x7hdFhfPjgxgpMNISyVAAqU9SRBDbMMBsxoNNnHFzUQPvIAAhzohxMHwLhTFFw0RUFbhT0lMAsRjyjQCCMn5JbTBHxhg1MOCPySoIY7rfOLCZ714dccqIDAA47z+TFJON18glgbLLAAxTJDoGHMHNwMcMwXPWwSRQUe4BFFEsYMQEgFA3jwRg+gqKfmmmy26eabcMYp55x01mnnnXWig8VD6CBhwpqDhbCQabygwyZ8CCEaH5H6+aEEYFzktAEGJ4xAViPkRKABAAAA4ykwAMyiASMJAEGEDlN0ABtOBPxFA4mM6v/kDoo0BeNXTh7G2pNTtvJFCk4jgMiIDUcQ+UENAlToRyl8TQDrIxg0gsRST/Hizg4xCBNbTmjEWOEFByy1QxW4fRDBUgfkQKIyI9KUX04xoIMTECA+gkBlvASBUxHt2oavOxDwgkWhRPDSCL4v9vuuriRqw9cwOEXA8K456cHXHOfgVKBhS4UQAhIghxyyxxwPNgVOZuDQVz4paDtxZTQ4ccxfiIBhDB8BkKENRj6YAcLPWYAQTTQ/SyGFSMEE85Iz2ijhBBrbgLIIYnNo0QYUxVRQzDJR4FHMMSJA2SQkLCSDwxgzeMOJCFp4IMQbbxQzXgBXiNPGIsoso4wIaDQeEQUOmvTQgjibeIDD4X0wUUEFeDbu+OOQRy65mgEBACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEhRop1zjzJq3Mixo8eNBCoyZKMRgUZeKKt89JgDJa+TGv2ITBgM5kqXvPThXPnopcYMMxGOqcmzaFEanEIFXcq0qdOnUKNKnUpVIM6FV6saxJjRp9Gv7mxoHBbVhc1HWFAC+JoRCcoEZx91gzpM4wO2eL0+0kQVEo5mPYxJQnNMUptFOIix2UbBgyQh3Ji0eYMIGjIPcyqAEaFMq+fPoEOLHk26tOnTDIGhPNAwhEvTWp7w4dPEA85EoA7VvtKDzb0QwHnVkYFjDzQZnqdtZISzufPnLkNspIEjagmNH2rgNRrEa7CoTuJq/0Th0mN58xvvQS0nfqMGr3r1cuQlTOMcqER7bv+q1wnUdtFo5Bp0BBa40XdSeTOABzL0UMwC8LhAxiTUBPPMhcMMUw6FmWjjghKmwDLIMmMsgscXDFYHmgVReBBFMS22cUw3x2hByA8eQMNADzdA0Q0eaMCB2pBEFmnkkUgmqeSSTDbp5JNQRvnQgLwowFBWRGJpUFooIVAaIcNksx9PNATDSVVbjLlfJlPlxwsHana0jl5ARbWRLnF6BAMWY0WFg0YvqJRnR16ZEZUaGiGx0Q44GfGRMFTywudZPAAClVldceQWSuusNIJLGsy3EThQZXLWC3FWkcNJ9WV05lNurqV0gk8GoJSRazdt5B+s7XHUCDoKZASDAEXpNQF+vQ6qFypQTaARBOgMytF7G20S1TbSGmWFEFMRckMKl2SrUTbDcHLINlVtogULHrAgwjItdNIHDsZEsQAnLIgDyhMVNIEIMYCMQQwpdjjAgiM4oLEIaCxA48EfeziAAzTVgMECC6DAgowMC0DRAiRwhPMHNMa00MR9R47zTxZStuzyyzDHLHOUAQEAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSFFiCxCPMmrcyLGjR43CMlVkCEgjr4wQePEy8vEjBpUvMu7QpRFEm5EIJ5lsWUClygM+T34UJjSjLJwIWwxrybSpxnM3QD1BSrWq1atYs2rdyrVrUIZfux60kpFIFadoMxZ99IxNVi871aoEkjaBz41rwWQtFzetU2A0NaLp2gIRkytjWEBZBGkPDgYeBiRhgQPRjEV/8KDBEUWLCGWEekBq4kGs6dOoU6tezbq169cjfTqUDdvNv1P/SHxdxKkOngUMeiDxiQBH5UW2T6fZaDeo8+fQeSGpsdGMsa19/TLldTZjsB5Zm2X/1xhCpQqPdztWKXquWFYy4/F2fxT4kYYILdd2yxosvvaOHazFSVZ1mGFSdAgmiMBGwyCz1QIiRMEGIlrQMU05wWQ4jIYbZuhhMNRkok0AaSzRxBeI/FBJBapBcUwgffwRCjTghOIIH4j0gQgDcIhQARhvVOABMTJAAtuRSCap5JJMNunkk1BGKeWUVFaZVVgKEeGTEUpieZCXq3lBDQjCZMTDfxzxYEYwODQg1plo+oUKV0upxVKcGwUxCzobMbAVnFjg+dFawWjxln+CHgCDRsGMkRUofQURFF0fFTCcT0hoFEMIGvkBRVZFjBdUS7/4FEKZIK31R1Yu9LWWdg/gvrXRAlllgugjKsklgFon5LfRAFk9c6tcGXWAxYItKbAWHPwNiyYRnGpkKFbLqSUoejFpVIdWqFyLljTKbLJVIBUEk423GwkzzAQ/oMFNV9B8wckeLIzxBwstRDFAE2j8AIoxS4gAShLHiNBHMuIwwYcH0DCwDCjL4GDKaT4ssMwYM/SxDQVCHAKNMjN8IcMCb8yBwxvFfDGDJHtwcwUDLAyBJBV0DPLHIjJwU4sx1kzwzzhWBi300EQXbXTQAQEAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSFHilmCPMmrcyLGjR41+2iWruJBOxgu8MvLiJeCjSwwrNabUGOwLSYRKMmIZ4XKlz58GenLYKOPYzYNihrlcylSjMG44JB2dSrWq1atYs2rdyvXnQiJeuR4koLKpWY1INmpDg1VSRndDHxXwybPpOp8h0NbNuCDAVWcZUcw823RwRkJNtv5xsKTbDWIMZIEqFqWYBzzXPFwegmNBmytNohCT0WcJNGhNAoldzbq169ewY8ueTZukT4e3axNE4tMAwrCxQW18geCn8ePIAdTgOKyT1nNlCRfeGGwZVjAZE0ToCMSnx+4xO/L/CqKRmfOrqDIiOdFT4y9hMl1igbARVGKrmTIC2C6d6fiNDuBw1RNmZIQOcggm+NMFGw3jiFZXsBBFEwPAk0kwGGYYDAHBDKOhhxqWQ4YXGYTTzSYsyICIa2gwgYYQlfThQQ9gvPGHFo4cEko1kDDQwyZD/DHIAFdooduRSCap5JJMNunkk1BGKeWUVFbZUG4LAXeklgZxCZsFwfhxjh9k0kBDNuecwwMPTfGQjR/BlLDMeVtd0l9/HjSjFUaP6MMLEQzeqVEHAhj2SAXFZMVMdIJ6ZFgKRmEVX6OOUmfdVZ1kNMIBGhW3ki5LFcCbT1hMmhEIA2DFQkbA0OeeT+648uQpL+xtFEIMGp0DCVZL6GRERjYYelawGrnzwkZ4FHHVBL5+dNcUKg0mLFo6bCSEgFaRkdEDNixFDi95PbISI0vx0sFG26Rq1TQZAcEppeLBp9EcM1xVR0ZzwSveRjzwwQdWThC2TgHkSefHGNZotQcafOq7EQHasHEMFE9sVUEdYrAhyxVL/BFFMnzsodkiP/zRQzJXvOEILPhIIkMzfWyCCBiDeNNDD6y9YUcyOLxxhQxLaPFGC3NAEoUQoATSTDFMEJPEH0ksM4MIkBzTAyy0ScHHDD30MQQaHmgiCRrHwLEANMXQYeXabLft9ttwNxkQACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEhx4rBHGDNq3MixY0YCy7pVXNgAowlgGHnxwuCx5bpZvDLGzBgMEqKRB+1gxBKjpUpgKlUi4CWgZYieGZeAwXnwTbCWUKNq7ANmBtOrWLNq3cq1q9evYIPyWmgjKBawCJ8+mim17YcIGk0N4ToEozukVYImaKsvKKOMSJA+OjdjwFZtGHcAaMt47cY9g74OiCKEQgVJTOY46gNqTIshIhYxuMFHC4sbN6AI4QMJlKM2FWSAoYC2tu3buHPr3s27t++KKkM4VHngd8EQQVEgFNtbi8YLL2CKnU5dLAITwjYG48Oiq59H69g2/4YqflgULlsXYNTwYuM6JEE7agjagSMvBRlBMMCxFQ9GJDl4FMQBGf2iEQItYWGERj3MpZUbGKHT3nhR8RLEVEls5QEBKVXn4Ydi6aNRMMsY09UbeyzQwwSTDDNMMMG8COMwBNQYzDMyPjOji5M4U8ESc4xBASE31dZCJ00M0AIYnDhihwwy4MNEMVBo4UgzIvCxgBb44NBNOH/AY9yYZJZp5plopqnmmmy26eabcMbJUFANIadSmWWphERCOTDnmxbBmHGJFGaYAQIIVlxihRXM+LHGo9lEms0KNNAgTaIEBJNBE3igpRaFjaGxjFeTYDQFL+hAcAGoGGHQiEoaCf8zCBRdgZASqy0hoZEzInR1ziMXhICrR+KRKKZWbCRGDkZ5BQUDVMIYIJawKWWHUTDFSLJVIBFyoNF7elprX1DiYhQCSxjdAYoQW1mzU32PAFUuY1iw5Q4KGokRmVafvOtRDLxI8MgvsD4ijHgbYYFvRh7csJUFGB3gba68CEswquQFmBEk+2Y1AUYR7DWsfRtotIAHWxGDkREIj+xYRjQgsgBXH7ekwAUdqDDFCDXooE8MMWAggYFQrTHAEshwlcVln7qckRXBeOABPj18NccC0CxxBRhDWCNCMttEUYwjxBTzRguLHDOIODLgMAcxyYCCzBDF7LEHDpJ0h9YATPxIwQIxNyCDQzHFRCEGGizAMsQSOHSyzCdMgjEAGpAwsAkcMzjRGz5D9FGHNTMMsogDyHgjhCNowHHIFXbkIufrsMcu++y0nxkQACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEhRIqJhjzJq3Mixo0eNw3oMqbhwgUZgwjLyIvexZUYBjDIK4wWyAkmEdjTS/DgzxA5eQJEk4KWv5c6MPSbcPHgsmMunUB8t6cFiqdWrWLNq3cq1q9ev/4DyaigWrMFKTjNiicqWVw6NaZhshaRT4wWxHKKKPfro6Aq5Wl1oXMs26ga+0Lh4FfEFzZ8vAwZZIwVuBo5DP2SIa9GiTg88OKC0uUJBTJ0KjpqAGmS2tevXsGPLnk27tm2GQB2+yH2b4N6BPv5h+qckrFgS/17BPtYRgw0AIfZKn87LnYGiHINR4CqEWUZ9IwpD/9WhC2RVrcrqciQiFp3HvTU6HpWyZysg9R5znPhowugGjS1sodUE+InnEl9aIJdVMSDoRN2DEO4lAUiHdKXJIXsE4kwwwQwTDAEgRGOFFcwwM+Ill4AgBQEEdMjhi6gs4cAQHuDj2h6EEAPGDW9UsEwLHtixCBsDwDHADVfgoAkOx3gQyCHn9SbllFRWaeWVWGap5ZZcdunll1z+hltZUkbHW0JihUDbJkK4OIyHLwZjxjBmEGBGNCCME80l0fQJAggtcgjJMvB81URaBhbGxyZdTTIYULNwoECiKhgAFGGP8LDAHHOZkVEQMSX60Sw7aOTCAFttc05GO1wg6kcYhP8AkgdbLTOYRoyI5Q5UEOzlnkoaPSPDVh4U+Igw7oj1EQxi2SCfRtIssxVzwKqExH/incBLBDqllJEWWy1h7Eaz7HQELwhkZKlR3j5STQBaZTDuRofxIutPvLxw4EYDOBHYvK9Wm1GUWJmiEQITBsxRDEdlA8VWfAjW0ToYxDCCDjYIQA4jGgAAQAKNAGGDDhzE8AG2HPHABjFctQAKPBgp3NE5wTDwiRBeuTFDFFD0Mwc3xyzAhwhRDDKGI9700wIaPdQxBgNNLCBDIANEIY4kx/RQARh/tIZMNx78gMMeV7BRAQt4sNGECMSwQMwXfBjDSR3bRAENN6H0QcwbgNggRkcxQogDyB6Q2IFIM8QMsc0PJGQB5uOQRy755JRfGRAAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSFEitEg8HmncyLGjx48ah12pyLACR14ahfGqArKlRiAsHxk5oDHYSJIGf7TjiKTlCF4QavAaOuIBryAtUWrkhvMgmGIEXEqd+sgFqKZYs2rdyrWr169gwwocOpQhWV5iC8oIttFAI6pwlT7i01XPGJ4biZDVMdUG2R0nNa5owbWHi8BwqU4JsXEG2D8/HCFC8yZKEjYyNjG48udeHWJfWPT4w6IPqHBJ7Fz59MZRiy9U0sqeTbu27du4c+vezdAvWodlc5OSBCcVGzuGzl7bI4bFGzTcoOU5i2gOjjqy55j0KKwDBA1Yzor/P4tFA5EcHoP98VqH2UZeBRJPfTCiplcxiDcWOPtxw1kgHe2nkRTGcDUHGBxh0VIH8r230RdcaXGYgw26JKBGx3R1jHsa6TLehyCCKExNHnxFyABNPBHMigRE4wcN2ZwjIw8yZmMjDX5YMY4UBKy4RTAuEMOCLNXUNgc00LQhQh3LyDDIDU38sUwSHmjhwR4esLAHGgy00A5vYIYp5phklmnmmWimqeaabLbp5kNkYdEQWWOepZAGZCGA2zHEZBLMMMOsKOifgQb656GDGhpMJsbcIJYmw1SY2Dl7fHXDNByFMBQW5HCAFFwYjAAAWRxolM1VXbFhxkbuqCApSCtp/+SCV8VkQ+GrHiWQQEihcLXCMvmdNUVfZzGi0QWMPfJMH1yR0USmHpGVrEeaDrVBtBoxg6pWi0iS4HshxCefUSjcmgxXpODwLawGaHQALww+gsUDSW1U6VZLZABtS0gM1W61pdarEQtcMRBAfrhyhIFcFaBLC8IJa9QIvY+cUyJXOGAaoAo12ECOBgi4U620SCDxAAARCPCCERdcyxEaE9AKyTRWRPxRMIEMMAdYS8CyABSIePAGFD1AgcwPdVTDwgJ4WONBMgssIQOUSziwCQ5/AMLGHm8MMVsfcCijRSW1HMNCBQxsIgkYyMgwhBBLNFMHJwN4EAU3UfzRRCXIgBrpCiZupNIOIE44cYoSWbyp+OKMN+7442oGBAAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIMaKxbQH8PNrIsaPHjyAf8QgGqeLCOmA6IuCw0UCOkDA56uPIa+Mwkwj3tOtYEyYvdI94CQXwixcSmFiMbMSJMMmbSzGjSn2UogHTq1izat3KtavXr2AHCuWFZWGjscDCEiwWjOfUt7OAbETDNcketxwPjFUQdcrYWR2xqHiUjWsLbB1DxHj7tucjsFqWtdjm6Ec3Yx6OtQG1QBOYbU3Q9MDTDQyOGyIC4ajjCMoCRw7Uyp5Nu7bt27hz697tUOhD37hBCWG9pMkQNGN5hfOQbE6FT8Z6gAox9p0IHKHohl3QDaYwFRAMAP+jnlxoCCwAEuiIIexjiq6OQDHjiOIAY6kKej7jyqQHT74cFZAcSx9hkRwMHvESxCNmcIXMHHjdF9UBJiy1lQcu8PSLhFHxcoGFWu2Bg0YbfVDeWCEg8QA6CDxwgDsvuoMFEicKBdQjwXg1RgX3COFMMMGY4Uc2PEQlDA/nZOOHFZeYAWQwx4Ryg219QDHDF3twgogWfeAAyQ+OvDHAFXzMcAwLoHiwDW9stunmm3DGKeecdNZp55145qlnRAmM1RCKbqIzFiMKJXfbHAP0McGTjD45zJNcPBoMF40+OcEYoID1BTfDcMiYNM14NQcZHWGQHDo2GPFBVAocAUMCNAr/5c5GfpDAFSd/mMFRfp6GNMWsj7jAlTd9ZMPRDoz0GlJPOW5FCCCBvRTUWAhKxUhyNG3UrFYLzMDTOh6NMFYBIO0wFgYfIXHEI8wY1kSEQgEjoQFC5cWSMFwt80OEH/m1UVFYbMRrSAeMsNEWW8mACk/thaTDWMLQWy9Mim0UyVabZEiTBMqCxAuAZWzVhx4dPfBCxx/1xENXY5TjEQYjABEBOuTVWOMBGgABQwcdWeMVHhUMcw7KIAXDRqZfBbJHHTOwIMMiS8hwDDFzsLBHMVHgwMIMktSBgwfXGBMFN8fgsIQHb4CyiRazaSLGEi0QAs4AfBjDACFRJDEHGDM0HNHGMiwsU4wMMrQASTVowLPn4ow37vjjkEfOZkAAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSFFiCycEHmncyLGjx4+P/FADU5EhDo66NApTALLlxnUbeUnQOIxkSYNDnGwkcqQlLyyPIPDi9eARFl4tdwDY6OHmwVEtsrmcSvVRMDROs2rdyrWr169gw4oVOHQow7K8xhYEEyzmhqpVTRzYiMwroDobYcTYiKIsuakXyrrjCESDxmwtuibBtvECI7hweenb6Cjsl214euxxMIABgwE90CAS4ojNjCjFKlzxAGrJFUTcerDxoAVNsWVqc+vezbu379/AgwtnCCDtQ+PDB6IdyOUfGef/GpXF8q+57gaIXAZRUWMHOQ0AgAH/AxDBAJAX+j60zETsa5NLMSFXRaqR2tcfGzFA4PghRFnDHk2BFhJBcITACxoRcExXbByykQ0YyEcVBClplBhXLASw0QgjSDgVMAJsxIdXHqwQE1pYPDALIwLYAMELENggow072CCAAbM8gNZQGwVTB1gedDPAMMGAQIOHj/Cwgh+XmBFMKpIwccNux3iAyB7EoAHODHCAwYcmWkBBCBtaXAHOMdCkBo0WTCTn5ptwxinnnHTWaeedeOap5556BmYWQ7OUBadgCqGFwm+biMCJEsFo48w0zuThiSANBGMpkZdmamkwk5BRDCEOjDUkknCBMAZYFUzA0Y68aEDECEcE/yEMR+tUcQQHNmiAxIAbWbHEV32YER+pHv1C3yMufFWHVBqFQOxHxwbzRFeiDLKRAn89UtxQk1F1gX9DVaERFntZxU1XJLCwkRFGeASusx4ZUZZ6HZHTiEZWLNJVOx5sBEEOGtUQrnwa8KgREUslCUVXTUjyYIQfbXCswY/wAvBHRCCw0QBdaZKBv+V+JExZJthQFksgkRPBRjJ0dYwLG52w37MduaPDRhdu1Uc7G/1SIc0x0ctDMV5505a/jOjI6tJMI2CAChyZsqBXODAxDNAfgYAKHziE1cccUXTSxDKEcALFHjeI008LQrTwxzI34ODBMmgsQ8wyHvRRByIeGEtTxxB/nJGbJI4MMUYxPbDQzSCyMBCFIx6wwQQhNwwAiJXJLMDCF8vgcMUMwr3CyTIzLDNHJ1C8QcwMM7TjgBt8xi777LTXbnudAQEAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSFGil27BHmncyLGjx4+PzLggVpFhoI28NgoDyfIjgBcbCTQpiXCbRgkpQYZIuY4XLySPCvD6BfJCTo1XyNA0GGAZj5ZQoz4KJmbO0qtYs2rdyrWr169gffpkuHMsWIN9Mj6aAlOq1KOPGGjiCkqjArhlea1reUTsA45GN2ZDxlUbSrduGc3i+MOHVzGBvPU4tEfLmCUDtLBB1KMNMU574IACF2rGHGhDQLERAckOExYyzsqeTbu27du4c+veTZMXRF5AeBd0J9ZGQrG+cWuBKuzCCQ41YOiAMcJIjA8boDb409XDJY1AEUf/5ZVdY6QrXMcc3tghLzmQyHk14mgC3UYzn7he0/gBrniQVcC1CVcTaCTUf1BNEZ5GFJyyFRMrPYKETwfMIgAROkwRAwYXBPHBBxiEiEEOR6gwAgSNaHCAWBwFE1tXmnAzRDBm0IBgR+f4EYw2OIjQQwWzcSNENws4koQ3jmhSjI/QeIADHnWwMMMnoCwxyAJP9CEDPq8I5+WXYIYp5phklmnmmWimqeaabDIklkNidfClEWKFoJAGfu2WBh+LKOGCE6j0wkoirShBhjbOTDNNJtR00YUn/GiTiTNkuGBBDzc4IdszN7o1DCxf2bFRBPHxgsUsjUBgghH6qGDEFDDY/8CILqXCBQIOE3DVAgEaaVBApx/BFQAnXB1j4yP+AQteDhsFQwpXdaxHhFgmuDWtTzZoBEQEzS7D1Rwa9eSRUT7B51MQHh2xoBVWbYWDRkHktIFP3CIGjE/lBbgRD9Bwxc1NyaKU7SMmHMULIwDCJQZXqMAbMEpiTSHWfCDlAJcHAWwVgEbCPNzpC39t1K/G6ynLETpAcIQHV2AMs5EGedUqc60hbxQAA11BowWvJn+0RiafsNGOVzc4UsEfUZDCAhrGQNHGMZws8skixfBBzDFX/EAMGJhJQggkePChxh/LVLDIbNZ8cQM0bLRwRQVwR4EDMRWgsYQjTRCzjDVJ8DOhxRJawCLCIg5wh5sXiDjJwBBNAPJHMct4QAwDm1hTDDR/CLEMDpq26fnnoIcu+uhfBgQAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSJFisEcYM2rcyLHjo2BOxFVkSMLcoxMHPKpc+YiXxmDI7Iw8CAsjkg4eC/Ca9WgHL15BHulw6RGJCo2htMw8yIKlU6fBrh2rtLSq1atYs2rdyrVr15+8BDAEy8srwostn6rdcTTjDGJaGWA8gEIjWHfCVoYAq0BjiCMZ1xDrk1UbRkYR1KrllTcjDkRcIc0Y0qIHmy9DGCwpVoETsSGgloD60aMNojbFmKBhc2XGAGLQBiyDQ8Ks7du4c+vezbu3798V3T0kggW4QbIKwf7m8XSDgue/Gj+F94frJYxEFbPM/mgSFK12MJL/A+L3rscNZHmRz8hrQ0YzXyBlBWUT8CNh7rVntP8IixGNY/SQlQVz1aDfdh9o9IMjWe2BEXq6JADBFEdIkJ9TBeSgDwxAAMBLCBoRgMYPWy3TghPB+HFgRzwEE8wQYHgwBAW28cFHBT/8AcoQHijTQyg9XDHAH20kFQUgHkDDBBiafMKEDHYcY9yUVFZp5ZVYZqnlllx26eWXYIa5kHIM1UDmlMgld6Zv55CCCipOMIKEPQ8AQAcOqVgwQQYToGJLIorY4sYEEzwxBxN41GabMyuqNcwycG2FRkYHpHcXAhEYQA45jGigCxKW/pSARmYMUcxWaHHXaEa/6KJRAEpp/0XDIzqt2hF3w+AQQFZ0YPSCBtj9RI5iNoDF3ktjDJEVMRgBY+BGIxjL0VC8MHJrghhdIgQ0DWLkTgwYzfLTC4pRmx0WbT1iTo9ZydUffxsNxd6o2Knkzn8ZebBAVvB4my5H5IClC1kFqBQCThmh0URWLjRrg60c8VJwRnMMkJUTvqID8Uaq4iAlVk+gVUWoJJcMFhIbuVAMg1m1MARaG28kTDCf4LPwVjIsM8A2y0jiyDGEzNHOBAEoMQEZhGaASjvtcMIGCz1UAAs4hHjATR3H9LAJy14dykcUV3iAyA94sNACMn3MkRoxkIhQATfd/NAMMfckU0cx3GgSxW5swCkxACkV1AHFJt5AwwY0QizzhxALcOIBIV8I4rEHSohp+eWYZ6755lMGBAAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIcSKnYdkeadzIsaNHj2uCHWNTkSEDcxojKPjIsuVGBbw2BtNSEmGajTFZvsgJjFdOXgda8hK2cYCSmgZFzHDJtKnGYCxYIJ1KtarVq1izat3KNYRPXg2/huBq0E0wnE7T5tRYTBlWHGg3/vLKC8m6liO+aui4dk0orNjipnW69hEUAlqhgFqgLEoPYji+IBoT5RgaHH+4adnDqdihJcuQHRLhzREeJmCi4GBCtrXr17Bjy55Nu7btkiNu1yTyFUlCLF9tzE5ybrDxjYBqZWURTSMGIMddJmC0MRIyrEs2IuFo4yuvKSxz0P/1OYvjWjNNsKIRDCO6RgUScN7V+AarF8HuPxZm0eBqn4068FJDDCvlV8UJOyGwkRl1aLXEEtoQwEN+Hl0yzAxJOLKEa2/MQAgcaCADShSgwGGMB1/8gcghy4iAjCZgaPLHEIRocQUOsOim44489ujjj0AGKeSQRBZp5JFIMoSOTxqE5dMDPHq3kJS2OQKIJAxAUYd3cSQzwABNKIODB5Qc8IA77lDQBwPdjFELIq5ZQGFTwXizFTEc6eLdnmLx6SdHBEBSBlZXnKUROnN25A4HG3kRBVaB0KDRgIlyhII7MtF01R4bPYCTT1UMNsVXggUzBlYO4LdRAk/q5xNLa43ocwxWYwiGhE82DHYrLxDgRNQj5wiB1RyqcnTAWrzE9wgGhfE13yOgYIVKseZ9lYN3LhW2BBlXBUDtnIUVI+1GB/xa6SMwcYQHViwY+sh4fsYrL6IbTbJIVjNEAcK5Hw0jxDHsaOVIEwMcw8IybIQCTwPYTENNJpOUM8kk2kwyzSkuuJBBO2qYIsQfCwgBRg8/IOMGWYEsM8cxn2yzxzJv4ACNDH2wQQEaUQAihCQsQNMDH2MgsswfnLQwhyb9ybYEAyygQcwCaFTwxxxDhNIGKBWA0QQeiHiwiSNoHJXk2GSXbfbZaOsYEAAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIUaIxOJmkPNrIsaPHjx9BBGvzpiJDROY48gLJsmXHF8A2BjNm8mCPJx2RtESy8hEvXgc28mrUsucjODUPFvvisqnTjQR6JJ1KtarVq1izat3KVeDPnwyBfe1aEFIwjiqMPnV5wWidrMY6hui4jievEL92fv3gsSeNZVcraOuodq3LDkYPbZ3RQssnIaBwDCHm7caYN5LmXMFxrA4OaHXeREE2Y0ydOZBIaSE2hKzr17Bjy55Nu7bt27jJhhib8Cuv2S38GB7O0dikrB5AcAyBgbjLEEc2HsfKgDBHBb4RtKxywHcEjlV6Bv9zcPXGjI5YOD5Y5/wRugIqOSa7qsyFdZcKJBjeYHQT1iSEzSJMex8hRsRGIHSTFRoevPEMMwSCdE4wnMzQmmvHFFNHEjIggogyQrQxAA4e7CFJBd0Yc8MAnAxQQTKabOJBJ7nVaOONOOao44489ujjj0AGKWSQezXEW42+LZQkbYdcMwA0MiTTjTW+MQANaS0sA0YU8Xx1wCIeOMCCN02Q1UMLPETYVDDHaBXFHx6R49ucdNb5lQkcBSNLVjKctREAL6jZF3uPTJDVGGuoNKCgHAEDgUwZYMXHfYjxssNwOfAEwEYxpPfIMFJZhckV93lkw08KgPRToB+t09MlM1zYxQkO6Kn0EwprTfHVBvE9ck5JVj2BE0fuFHXBRrpyZMNcLBmFz1VDbJOTS7414hu1HF1YlTj29croRuFxtM1Vc3Qr1LccweDpI39gFYqfjxRg57z08qILR8/IkFULbEiD7kfBtIDGVgMspYVlamiTSTDBDMPwwxAH8ww10zjjgguDIHLFIoM44IG2W4WyRyikeKDMG3M0QwwLPSTRTDdLFDMAE2iMAQsUOOCDyBdjMFCBB5zQ9gYYSzQRRZZXtDzD0k0MIMMCdXzyBhtPDGn11VhnrfXWNwYEACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEhRYqBjE4LReJSNRrZs53jwEPaopMmTKM+tCTZpCJ2KC5u1MGdSAxGUOHPqLMmrZDCYCDWpOdlTJwZe6x4J4FVUR9GcWDiUBIqwwpCdWLOiBFGHqtevYMOKHUu2rNmzAhsx5dVwbQi0BBelICpVq1ZhvCSUXDA2yRiiKHOsBbATwNopKJF0eLRm7AIXRC/YnfyI16+pZQPMMIanRQUW4KKIADQHypAFTADdEPEFShtITcZ0WzSDDbEmxfoMgcu7t+/fwIMLH068uPHea9kmTP67Qh0QlKObBESWD45oJjGEkI41x/ZHzsZS//BwMsSHkgrcrX2wYWeH5Lxu8mz/U2yLJoBLIiHH/dEsdyYdMAJmYREDmUlIYYWBDSZVcUJWvORAIFj3OHKSAd/1h5NaJUVTVhMsKBMMDxrqFMwEdYDRWw8MGEPMNogY88cQDrzRgyZQ4GCNFmNU0AQkpEhSxwAsLHHckUgmqeSSTDbp5JNQRinllFRWyZQuDcHAVAJIMqeQl8DhkQQUjrAQCJHFJJdHFIcgIgIYbHKT3BwLEBPIItXAVcEYa5SYVQpmLdAGSsKoBd+hiCb3wIAlEUCWHmMEYxJefqK0A2GPTDCWJFf4YZIJCFR60jpF1ReWOKGc9IAKPPHCX3RGMPCFYEnDjIXMIERdhtIGTCGRUwi8PKATL+d5KNYYe+T3iAZrkaTVUUztYJI7Rjxyzlh2zKEsTiMAyJM+s+okYEk+iPUHHdvilBwSyemwExbgPnKKWJoEQJQCohKl1yNjVWOvSVigkG+4/IoFBiiSIpjowgzzUoVPZDHQTAAkDoxSMJqcVUwybeDQhhvYBCPyMMOIbPLIInNh8iSZkGFBKH8wgEcUvOFQQRvbDBGKHcosY8wenCyBzx9o9NDCH8ksA0kPWhDTgjGH9DCHkcJx0QcOHpCCwxySLILIEzPIIMMSf7BBiBdVpq322my37TaTAQEAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSFHiMhmbgoHwAwJEtEtWrDCT5odGNpPnUvIwlzJbNj9WQASbYCxZRYYVzj3aiWWnz59Agwp9xGvDzmCabh68ssinjRxDiX7YyYuXsEfrig61gcCnMqUHmSyL6rOABAxHYqCYcuTChyDryD7ygwOs3bt48+rdy7ev378Cq/JqKHgwYIJ/gvl80FOuY6ojfFbgO3YnBxVADwguMBSB4BhAGzHaKQ2NXjhKfHYA8rj1IyQmfPbo66ZYiy9s+rRAU8cYty8V6kD6swSMbxxRfizh04wJIk3bBtXZE6XS4evYs2vfzr279+/gwx//LqyQ/HYxZlyr91mXLygQPnmtlyt/pzO+3XxKELBTWAjBs8gFRGEhLDbFTsMwoRcaPfgEAVSPqKDVegM62NVOc+iFgxc+wWAEWUccYMNO+hgQV1QakOPTDXsd8lN98wlVgFU7MfMFX52wUIxiMUYVTQpoQOHGdQNQgEMTkPTgQShNNKEFHJJ0U8ECzbDARChJvEFMN4j0wMKN4oUp5phklmnmmWimqeaabLbpJptVIeGQYGKal5AOgoXgnR5QJPNGDzJQoIFg6CAzhiTIkAIGDocUFoYYeLCAQyguHEbMH/D1KJczjvRlzQBAXUDEA4WVamqpBwDRwU/BtKdXMjwS/6VpUBfAaAFfM0gT36xBwRiMF3sl49M6GuxEKhHzGUDjIyFccFQdem0BjU8nRAZUEEhUJdQsVWEWlAYjPgICFHrZcYVPL0BIVFUQPBaDYKPtZEOAj5zzh15jyOKUs0Jl5RO48akLFAQXPvKDXjfA46DAQHmmmWCaIRGVAMXutI1exXBoWQ28AqULsjtxohcYLvhURcUdU3WET0vshUN6O2V76sw0CxaBT8GIvNcmk6Q8lBRRaOHXGJt48MYT2gQzjNLBENB0MFBDPczSTFP9zCRkvLEHODiYBtgxaOxBSCeKcsJAN2wcAwYYP8xxDR894CCECEOEUsEAOOQzSD5asCrAHR1R1EGMCINUYM0cC0RxTBObDLGECMv07QEbn3Ty5uWYZ6755pyLGRAAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSHEiBTzBghEgMCxjRgLlpICIFu2SFZNWUp6MZibYsGHF/jypyNCDuUePeOHcybOnz5+PDkzZGQwHTYS0cH7QCZTXAZxIeEnAyQsG0KU8kyg5ahCQl5/CquTQN0IHkR0CEkQAYgPCCxNTOlQB+ijbFaNcK275V+IflbyAAwseTLiw4cMHeSkG0FAxL8QHpQzbyWso3cs8LwAzwNMDJ8JgcG5gulOfYyBAHzg+0jNHiJ1+7hF2QRmz7Z5AdPEcYqbwqS8sHN2gsKzNmBnQmhGjUGwMmx6Q2Ayw1qIbGzCLJDVBxqcOoGaDZkD/Hk++vPnz6NOrX8++fXvHjxPCV88m2O37P43tKUxICk50wuBnG2mPYHMDYS3UhhMWjjWCWQEMOjbVIxDMQhQfhC2AkwRM/cLLDgLiRA4vAT5SBYF4EGYBTgoQ6NNoTHEQAjCXnfDaTnM0MBgyCoZIFy8cwNZMYR7gsYh9Pl5GQzALzDHIeMQkAcUcxFyBxh/NcLLMHCJAowULoVTCxDJNVGAHHiyAcQMD27nn5ptwxinnnHTWaeedeOap5558MhSCYg45BuefisGw0Hzu3TKQYyG84tcpSpDQwAS+OIZFACScMsl5eyCZ5GXZWCDDYaT0FMQIGsCn6qqOuWOACuv0/xQMGoWZgqQNGHz6E4FqYDjYFX5QpeuuQRD1A2FsKKgCkD5+EMJcjzCCGk7BsEAYHz3uBCMvMezKSwgl8qSPOzuB0ARhOLBIGgKO3XaiYkjshBVO59A6mDUbusgTL9A+whlOGtgA1Ik8/UGYHTgRDJQAvERAKC8JKEbXBQRyoqNgtD0y2rA+jYAFT/YKNkG2HD8yCyM8JUPYGyDgpAOrMMesKk/DOFAYNJOVDJQfgXRp2Bg94IADGQR4pJEZIIx0yTjRJG1G0UZ7lEIaS3xphzGQdTPHAoiI0EYUpGgxQwV4LICDI814NgYOQhwzQw9FYlfBNgxcIcR5aLARDiI3DCTRhzEDAO1IJXNcuckc3NixDBqDDIEDC472KfnklFdu+eXuBQQAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQI0qcSJFimRTBMmrUOGxYxmcbzZTjmHFYJDvbKjZ8xeORjgePYsqcSbOmTV4zhx3jo/KgnZg4bT6aFVQYLyQyg96kyWlBz4PTaAbpUAOCAEYA0LlDEoIXL3cH0AGLkICICRUfbAqL0g3K04h7uFUAMwTMjAoLcOyZQ6iHMTaL3goeTLiw4cOID8Pwyqsh48aJEQaLiS4EhLRCM8+cokFpzGWcDCMDKoxmBMalaypgPKKmZz8VBhTGBhSD5ttLZ7ZxgDjUGwdMQFEYE+rPomKIcNxoQwrSgmKH+FSIwgLNmDE9FnjodkUSm24eIov/H0++vPnz6NOrX8++vcLHC+Grn4y7vtBiIhCDAGq//rpZM02DiGFLxITECTE9wFgIuOXQFWNJzRSMCAwUxgB/QPFyQX8xLaaUZ4+wgExhFmCYmVcAZFiDZiAOcENhfMTECIgc5hZTNk2EYpgFoZARTY31BQPGHjI4Il4fhBAzxBtsLHHDXW/MAUUFOECxhwc/sKBFHcfg0AMxA7wByTEUQOPemWimqeaabLbp5ptwxinnnHTW+R4vOjjklZryJfQgL4zwyVhCfao3DJD1WQHIgIgpUVMORGiAxWOUUuoOOTBgRlMwP8hm2KGP0IhoTBDYJlMa4Rl2xyMFiDpqqBIS/2OYGzHNskNMIWiAqAoIRChTMJwwURgkQClQEwIQuuYVTK7NlMUSbhHWh4lGeYUUbo/N5Nk5cIBSGA4m1jSCOzKhoO2JNDXRQmGohKtsB4y5ow8vRKA70xM4FOYCUAW8amNMFdhRmDYGwuBvszMNEO1gSzCTYaUQR1zpERIi8odhxNB3sFA8GEMMIYhBAkUoaHQUDAEgWGEFDTRk43I2LNMgjcrRgGDGRsGUAwUyOHjggaeIQbGIN5XgQUwxQnDTBBgtDMCCLH1AMoAHSMIChjLLGHMFGGC8AccyTSxhngjJVNBPCx78scwoV7AzAA61iDEHND3UgQY+C2xzBTFoeA1gpp2ABy744IQX3l5AACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEixootgGIMNyzhso0aNKTJi3EgyWIAZHio23PKoJa+WMGPKnEnz0UuYwySpROiiJYwDNW0acXnTpoSaNULELCJjp8Fbw2AKO2LChgZdWHhp3cqVKxYEjIBwOLJOJrw2TiN2+sNESIVPTEDNqHCPT5QlLOoQ05O2r9+/gAMLHjx4q0PDhBEGg8krRIITQSM/+rADCa+yMImhCSyjJYaiLYVtdVdz646ZAhDAPFchcLmWQUBLnv0oBJGYLP4IPjXnBxNixoYMwPMFDQswf1iAI1RsCJhiTa6IwQGKWIsrFX6wwDOmzj0LicOL/x9Pvrz58+jTq1/PfiFXhe/TL6ZNXyYPEbUG+3FZnzboZwsEVgxjPnFF2whcbdBSCCrANM4SgQHS0gikPaICL0j098gJWsE0QoaZpQHYJC2hoFRQEWilgE0dBsUIOjHdIwRgARCoYWS8/BITBaYEtoQmwZxz42zB4CAJHlGEtwc3zdRRjAjEzPDDMlcQA8gySYxCzB8t2DEdKFeIEEUboCxDzA+ntKfmmmy26eabcMYp55x01mnnnXgqFEJjh2HIZnzwIbYmoAZpsBUW6803ZGQgcNMEYUrQpIAKEGjwwJ5dbYUEMAKYcEFNwwQoGAEtVbjoTKC5wIlgQtp0Kk2gBf9TSWBe2IgBI4uOwNiKLQUzQGA/tFSAbI/MspWkW0EwEwAJwETDZoCx0ZIKWHi4VQezHbBVDjC9YOojzTQA2AQt1fBAUMS21GxNHJzYEh6IAEbGhN/K1CEAx2obFATVwoQkYJG0lEO6pyKgQUwe6PZXVI+I9iqqkME0BByANcMDUZlqigUSIezZMaYZx7qMYHUo+nBNGVTQwmDJoAGFMwQEQ4AVa5xzcVA8nJPNGsxcAoJILCyDgwhXhFeHB4HAgQMOh8DCzRNv7QFKCyzMYSUndSCTRBNg9DCE1dA0QUgUr5TXAiCbVIPDEslA48AQV0Dy3ACBPDFHDzcM0UM+QrQQsEAxpOQp+OCEF2744e0FBAAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjSpxIkWIZJ+WGTUpRblKwj88+ihQ57GPJYSUnFWFQ0aG8RzCxwJxJs6bNm49eHJg5rFhLhJlm8sL5iNfQRwV4KYCp6+hNp4/e/DxIIthMDEBmuTPKtavXryHQRbBRkxqOqRHTgDr040eUH1eEEMODJkqPL4GatEPLt6/fv4ADCxbMNURDroMTWoXJNcKUdUSJTtFgFABNPoH1CLWpguuGp0Y1PKUpCzCBzZFTj57ZSTA8FoS0QOE2BNEcZUuaQEGjjFOtHouW5CZ2DA+oQWMW9PjRjdgPa4gSS59Ovbr169iza9/OvTvDrgvBZ/9frLq8TR5gBp+DeUGH+fJKZwbjBLgF6qJczc/qClOYU2lzAKbEfUYB8d4jVRgFw32P/AHYMAzahIFRSDyyFS8nRAYVfX9pE+GBN+0AFROB9XAMhCCWZ4U2fSwyHSRDUADKAKBAwQc0kEShRQUtSNIHBXtosUQPnxSDRjHLKNONB8r04N2TUEYp5ZRUVmnllVhmqeWWXHb5HS8PGRVlCFwJEB5XKkgp3kFrjpdieWZINVgGRFUxAhEJzIIOFiH06Q46ADCyAwcYEBWMg4GBMJM7b+IEVSanBDYTEAU0epM77sEUjDWA0cnYTC9YOpMEToEADWDQfMgIV2TZ1JURrs7exEOAf03AIJm8hKAaZUaNQBNU2wBGxoczcQDZTUcQBRULgJVDLEw68PJZfhtgqCxNrf1FHlSiMpjBg882GsSGgLExkwldIfGnBuQAYQMRENiww7zzNpLnnrga9cFMzCQTGCzjdJsaNU2wFBgkLLTwEQg0CAMiD+dk48clZgRjgRYe4NBNYnIwgIcIeLBRQSB/UABGKJ/gwAIUMwhBSAVzvFHBDMd4IMkNPXjAwjI5W+eGMlcsIsQffHizzAJJ1OHBHnVUIMIAFdQhAwsLLHPMHz0c4uXWXHft9ddgPxkQACH5BAUEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEiR4pMAwYINK5dRY8ePHYdlFBmMQMYJfyo6dPOo5SMiLmPKnEnTJS+XZlQmDGaz5iMIN1vyOtCzJq8gLk3pPJihnMsjvKJKnUq1alUIMYMtjTigwgAWfH6AiSLL2DJEgSos47bsBrF/JbbKnUu3rt27eO0ikdpwal6EPFs+iBoBRQGfPj8QGRy0pbG7E4rKlDqL5l5eSGg2fuTB7jDJiENPjpkB76clVxxBqgAl1ABkf1S14zTBFB0nqOwsQjQGTYUF/ZgYmxNFWQsWUdD8Xc68ufPn0KNLn069unWGUxkp9Cs9sOjvNGXk/425GbzPF4212l3kspFNqVW+65gqOdvdTJKlmhcaFfQMz6Bp1t8O+vm0mRoAtqSDCvuJthkbd92ACAENmkfADJ0tNwAaYwwBiSRfCFFME/ew0cMybywgwxBQLFABMrXMcMUiTVhzBRgDXKfjjjz26OOPQAYp5JBEFmnkkUhix8tDUU3BI3cJkQOljlMWVOVzgHxWoWjRQJjXDTUVkIMOAmiADhZIhKAmEki4g44GO4yAwTo0qXcXMwFuadMILtlZF3l6GtXnXT+4hEJ8jzCo52FCuWTFN3Zl4FIIM81X4GRSGTDTZk3Y1QBojUhlRGjoRUUOoC7lWNczecY0Kk0dGLyIVEs42OVdeZOZ8EgIUcXwSH+CujSBra0G+mtMShArmLGaxWSBXYOQhxkCCdigAwcn5PBBFQpI8MEF4F6AwRFGmEBEAsBgcek5y9w1Bw/MhhbMF3lpwYAFwVgBL7PnDPOMI8YMsRwniIgzhhY4ENMHH2p50EQox7DQBANg9BDFEMUkEQUkHsxADDJoLEHMEs/9YMcCfbCAxxCbKKOMFn90IkQT4sDMwIaaFIMGGE30UEGSQAct9NBEF61jQAAh+QQJBAD/ACwQABMAKAAmAEAI/wD/CRxIsKDBg/+QIByIymAVGBEO8JpIsaLFEAfIofiFMMBAXgbXLTSIYeQ/MCZTqjQoYkiRYZfOrVzIg0awfz3AwJrJk2eInj1TrIwwcAPBBCvtDDE4EUGEBDZ0cEBxIoYKI1ixcjABAUgEBCFAFlxRzOAiYh4QoXFUAcqiJkv6IIrS4pgHPEugLOuBzxEkRMUGAFUp9h+AlFouDU75aBJBGotNhtgxcNi/ZgM5GP2ny8TgApQPZiGD8KdAYSYLDDR9MJzlof/EAumphCC6yCpN/QslE3fKOgT19EHjYQwDNk1E9GkhKZkjR9w4EdtU4Z8yFssG4DjmCA2fJRWiLP9Iydr3Sg0fzRf0EGyYmWDBCPwzQ8CMGRAgol26xKw/s3HMWGFFNCDIF4wTWhikmHoIsXAQLyGYoMAjjwBFIQY2FBQIgwiNMJIwOnB4EBoDGTDQAQM1kpIwCvl2xEAxHGRibCWN9IljCKHH0ywjOajSCwUVJiJCMf6D4kou3DRkRwTBMMWSAzmS5EBV6KLeAU9WJhALLSi5ZDBQ4DDQGMsw0cYMLIDhzRse/LAAG0WgQgsbDKSihSSgMKHFAA7gI8YNoJCIyB84HeTAHDccMsYgfECiCQvH/NFED930sAwfA4QSSh0iGAMJGHv8gQMOoKxEDA51/ICGFld0o8kQdeAP0MIAfzBxAx4LvIHJQgEBACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEhxIptn0h5pfCRso8ePID2OC6alYsMnG6twCMmypUdeG6OZTBhsI0yWRm4+4nXzgk6QvIJsRDXzIImaG1W8SIDAXQieUKNK5RUCCzoDRKZ8nFQ0YpE5xZZU+LNMSA8WUZgM+YGjGJpQM7rKnUu3rt27ePNCbRg1L8JyNi+4HPzxp4u7LmyCxAKVZQGo7oB63GN3mGLCmC9rnIC3zSdAh2olQQPKmKk5fwINgHYFh5Zlf66AYwG2AqR7VwYg0gINWp1KfoMLH068uPHjyJMrz6sj4qzlB/sinAU1RPLM2EGSyfsy++AjOoPd/2WzUcNGCVFfuNxAHSowzTzuRtLMs4B3BTxtKthYxy7SnYPxFNlOvHTg0k8B2KXORhzs4F2AHn1xFyhJ/PegS8xMIoQMwlGASB/WLMECHD28gYgj3gwhBAtMfCIDC0k4UsEN0OCQBCI31FGBNdD16OOPQAYp5JBEFmnkkUgmqeSScwGxF0PS+RglQlMix8UTnBThhBNP8TRLGzK8wc4inTRRjDvu2IOFB2OwwcccZhCXyYWZiZeXNh4dAUyXU/XZJxaMeLTGdnedoxmdHgEDwEbP4OWRLoiGFN5dQ2ykg028qOCdBA/opNMar9jlxKEbmdAYUDwZKNlGTdhFhmbCQM11KWHoQGWfRj8t4B+pHvm0UQTdsRTURtvsiuuBBVZ3Ai/otPQTZ3VZdmykq2qEjV1cbLQotYV5RIddh7z0pzvo6AIMOug8oO4DBzjVJ6Qa+dGqXdBEw61Lk7CRVyDFtBBMMNHQ0FF2wpyTjR9WSBFMBnOIIEZwp+yhDA6QBJIEG5vgkwQOdXigcROICAEGJ8XUYc0cHvwwRhQgXuENN8V9sgQUdRAzFiEeLENMD8SM4Qg7TYgwBB/EODAAJ2Pg4wEkTDbt9NNQRy11kQEBACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEhxYjAejzJq3Mixo8eMBPhUZJhG44kLGT8I+8hSYwGNvDRaGZkwGEyW63ite2SCV8xH7n56FPrIAk2EkVgK26CgyocLOXLEiIHhw4cqQX6t/Cis09GJdkAtuwKpGwtimv78qNDmn5KvcOPKnUu3rt27An36ZKiXF96D4262HMyRFweNwepiE5wRQwifCHZ+VHDAZwgMG4keomszYwjCoDNvTHPXThNHOHAke/OHxbE2Tb5c+dKkggwofJqA6kGsh7EruZv9edMHx9/jyJMrX868ufPn0Gn6hOHQJ7DoBfsm1N5clccqRzjY/yCnAQG6A+7Su3uADpiGRhCmHHnJcdhd0aFBC01Ml5ZGdBspEIFeB6DUEQR9uXMYY48sQldSGQl1wS/5bbRBBzAFoVELdA3DoEcFYJjROhq2RFQAdE2gkQK8FLBVhRwJ88uAG2lhFxQBEAAjYTSkMEYxNv6VzAIMMIDDFUt44MgmiPRRTBN4QAGHJCJcccgiykDBzSBvvDGECNiFKeaYZJZp5plopqnmmmy26eabDD22F196jfmAXg8oxJ1zskwyDAHBBCooAWYQSgChZiSKaKEEDGNGMLtwgpyOO+bHzV2dPRIDgbMIUIMKOUigwC+/rLPBLwVUcUF4EJCDgJwIbP80h134VXrgfnW5sFECtn6EK11waCQATJDRNxgGAOjFWDYk0BXAhxnN4hMSQ/n0wlAbEUPXNIwFxQsR+dlgGYNXcAatRkAIxYsO50ZY4iMTmBthS1joJUBfCrBEVLxzZUpUr7U+4kKHGpEDMLYaeTUXISsQ29fDEEf8sLHBQFNXKJke7NEaLQxx1zVwsICGC5GkMCgIiYKAshSKmvFnMMMEOkkkzjzBwCIMLHNcGx7AsQgkYHjQRxTWfAHLHjewwAkOTXDSQgV/KPnGGND8sQQLQzRDxnJCQHFID8tEMQcFmzAARydzoCFGHaFUAAYh1wyBAyKwsOADnHjnrffefPcDHWZAACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECNKnEhRopVHGDNq3Ciso7CNIDPyqMgwVUZGG2PsCMGrZciWvA7siPExI6+M50gmDGYzZMYaLZHEINcS2Aafj25mdKMTYY9p2ZBKnYqRGRtlTbNq3cq1q9evYMOKFbgDJjCFMLGMPahRKdW3J9wG+zqpJ0YFb33ixcjrV8ZuXnlitJEjb163j8aIFVFhzJUFeJpYa8KiByEcc5LMMKYsGZobSwYMwUFBBAUhTLQsqLO2tevXsGPLnk27tm2GMBvC5EU70yVpNNbQGC58OI1sx7MpX848+JpLc8cKfqSBkQ0YHE4c+VClwIZ1NR91/9zwS4GEHB1QmICwA4lGO19JZPwFwfBbt2a+urBrZDc5Dkf5tAEHGux2Al8aAdbVdIhtpINbvOyAUQENthVERqgEZpd9UyFmgVfEZJEREQZEoAEAwCCAzgMPHOAOFjBi4Y47BxzwADq6AAOABtUB4RdGkSACFjQsgIKDGmqgMsEEAWhDxpMkkIHJNM44Q4ISZLhAghcuTGABLWzggAMeHlDgWhYysPFDFNww0McxYjLQzBjHdINGDzf00AIDmjABhiRJ0HHboIQWauihiCaq6KKMNuroo5AW1B8vAjjUkgaF7rYQMDDZcFtOAvUyC4/z/JONqajKw4gB8RiAqiixWf8RHodS0eCCWNhoxAEEQCQQwSwpIgCMjgDMAgCKKeqS4ywRJGDDCx9kxExYfmxIK0gHvJBROWBp9MC1SMn1FRwZGSEBSMKcYMMUIXFgQww+uWXFV/BkhEVGBO6mi7YgvYDAbhpwYC0cXpFh1wUP/BfgWwOS88C5SWn0iVfPWLuRAgJjdISu4V6I0RJecWGxRsLwYoMKGrAEgQpYABOuRhNoiKBUMUyBAUYdqDArSIjdumBG6ID7ckYxdzVBRh8cYAIHU6igQgwdHHFEDhhUncPVWKPXwQkqGMGBCY2EINIfX2XAQ0jCbFBAAUEEIYEEH3xwQRVVtL32BjtndEkgYCmcwQQbSvymHA88ePRRR+JhJAzhhJ/j+DnIWZECKjJAAY5Yc3AS5jZzhLOHCMSEUk0TxizwwyZtLBFIM2KosYwkUNRyAzF/gLPAJsqc0RoiDAxRjBg4VPDFElcMUMwxdkDxhwdRNFPHMo50MkcFOGxSgSRoyDHbFhWQgkYnSUDiwTIe/NCMBy2E4kEfQmzSAxgNRCr//PTXb//9jQYEACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECM25EVxIkVeEjMSDPaoIwJyLzicyPFBwa91HVOqFLaugIQLHYzUgBBCpQWNC12k5NURwkVgHH6pHNqxgA5gF2t05JkSEc6EHJcSnUqVKtOOE54q9ODIUZJlC2gVgdduwgQvFs6adUMrQ4AAE+g4QUXKjhZQqkI1mzFEq9+/gAMLHky4sOHDCLUxo8GYcbZsNB5LznausuXKk2kw24L4n5OUEkZUHV31KojCw3ZW5cC0AK8HHU9cJcpLQUonhAmZScnBBpBGBiJo0AAAGAJd6NA9eIAOAQJgAGZpiMAogYAdMFRm2tRZ4AJlWv4Y/0vyBVKTWnuueFDW44uYBX2GEBPBB5KQQ93z69/Pv7///wDmB0FEAgR40EUhJNTIRQD8t0JVLSkgwQcXXIBBhR98UIVJwlTlwmEqzUbaiB1cFUxhbKQUwUooGHCRiEtRhAQ5KAx1FQ+FZaLaiDzuVEBKfxAW1SMwqqRPCLy488EOIYSgwWizuUHYJCmNAEGPPH4wmyOFNUEHCOdgiSUN03jATmdCSMKAI1cMoIk13iwwxycDONIEFC200ckAVwDSAwM9VNBEFB7gUUwyBiaq6KKMNuroo5BGKumklFZqqUQ2UPRAQ7NQlOCiLy6EzkU2JJrNPyv808gs8Wjwwj/n/P9Dwz93/LOKAb7g+s+p5vDnQjZiYikMAYg5o5IJO5ATATC6HLBcc8BAF+1xyzmLDgARNGKDBClZcRiwUgVbFTBPdnRiYSqhIy6UKZ07mCQpwSDUUDnYgE4jUyWAjg1VTHWVNHIQ9llHSKSkw6gMcjDVCEhdhE524XaUBmHGhhsEOkDEEGwMQKBjG5EqzSDkjlN1YEBKEPzYETmlBZESGiNH7K8BHDyABC+NjBDCilapRELMIJOGEpazZTXYkAisy25KbBCWYkfC8KIBI+Q0IgAQOxBBBAQQvMD11mATYcMOAjRCDiMaIMHzI2sgShgqYfK4zjobbPBIhzya4TZhZziPskgGPlziR2SX8cCDMIbzYI4wl50DGWN+SAOCNmmwgMc2iOFhTQtgjMHCEhVwIgkLxCzzBSIL9DCIJFEI8YUIFYxxAwMemL5IGwO8oR8LmrBXiyOkgAHJKI4woMUVfRAighahAILGIpZDMkYfC4CyjKKmMPDFFSz8gQYLknCzCB2cXWr++einr/767LcvUEAAIfkECQQA/wAsAAAAAEYARgBACP8A/wkcSLCgwYMIEypcyLChw4cQIzbkRZHXwooWJWok+KjjI14eQ4ocSbJjIyweg21cmMkjyI4SSsoMGbPjy45gViYM5hFIgZlASd581EQnw1DdjP2oc+hQmyQi6lTwcK9FqE89lnkY4MhYkzdgPHhAxKQJHzZG06pdy7at27dw48o9yDOoXZJr5ALy2GjkkQMVhVIEkGPkzWxw636c2ajilBAVf8kc6gZunXJ3M4f0QwrN3M+gQ4seTbq06dOo4SKpOJH1aR/Ogm0JRjuFmwaYSpjZbQaEbx8govkGsZtAMDITQCs2QfGABgEQRujrgOGDhCpBqkiQgCHHiSkwiJD/Q7AaWEhIcBuE7KsZ6E0CcCe47FgFIy8BP0sqEGBfgc2QLLyl2FAiQXATLyjMVxIvQXjkmVsDthfUUMm5BcolHhmABGT2deihfUgAsEFKScTVBAM9iBGIHagEoIQz2mQSSQopTBLJNJNMk8kuzrjgAjwWBICKKbQ4spUkD4YGzgA4/GFMFMj0wEQUx1QQyhg/ENNCCzfMcIUW4CBizAKplWnmmWimqeaabLbp5ptwxrmWOxk1ROcJaB5RUQgLwbCnmhglxGGdpk1yjoRACWOGE3MFINI6VcQwwgtAJBDBLMAggI4umyIAgAYRJGDDCxzk4F9IKsU1joKIGoaBR9rE/xVSCK2SJMxNqbqFikcdHFHSBTIBu6BHl8BVhEcHhLSDfQiQhI59O4Q01CJvuaDgCxRhMUJmI6zGiwn/eYSeW5OwaquEDHoUylvDmPsoL/o8Qg5FvmJBoLQhKcGuuyMZ8UJhj6jAgTAzDRUrhB65U+uwHmVQrUcfuPOBAr8QjOgGBUhgw1DNxDeTMOts8EsBBQSRHcm/bLCOxSWt0U1c7OwxQRY8LDySH5GYEsUoc90wRDgeiDDHHzj8gEYxLHgwRx9QEDPDHxUs00MxgcCxhDWI8GHMDX3UklNoLXSzwCLQ9KDJDI5ogowQdYjwyQ2aeDBEGx5AMUMUeBAzxpdJmilWAicMeIADKRXUAcoyFPwwACQMiMMHC05kIefklFdu+eWYZ6755hoFBAAh+QQJBAD/ACwAAAAARgBGAEAI/wD/CRxIsKDBgwgTKlzIsKHDhxAjOuRFkVdCdxURSNxY8JHHR7w+ihxJsqTHICE9BuO4sNzHlCZjyuQV5OMMlgldfJQQYp3MnyKF7YD56AvOhm+G8PmjaZOjOpquVKjT6c2cJQ6aQBoVCpGmBT2MaeHDwNjRs2jTql3Ltq1bhhqwQHT3diFQYRsKBJHAt4oCBeuE/Sz3dtFHdCJHVKxYcjFFDiKJBmo77OVPFTY+eIwBeabICW+TWDAjGKhpj9JSzMGBo67r17Bjy55Nu7bt27crhmC4+HYmP6eDnwtWxzUIy8F/8vr10ZnbIh9znEgOFOY4t0qQD6UIITiRit1Biv+c0zYY8pJVUn6g6JER0ZG8Nny00JbAxxDUq4uk5TZAfup+3ODaDVd0Q8wVDMggRChXtMDCMTJoQcwhODQxyBvHMNDDF3swsQALrM2xQBu4/ePEPdCIcYMHV4CYxAJv8DHHKSXWaOONOOao44489ujjj0AG6VYEFTXUG45HJpTkbRnM4QQnPwQSDwIAABAPKmx4gUoAEwTQji2J2MKKBQGkkcYPeshW2X+mmXFHXWs+glJFWCBADhEmqNABBhh8cMEFOcRghA4CaPAAEhUlIJJZbvFwHpsiGeDORyu1RYZIikJKEkzDuAXHR0SUxAFjm1Kk2aYf0fBKW14gJ4xjuhTkEFMBujhWGlGItOXMeY0wl98vAjzaRHmPjmQDTLxgUGxkNXmECmXLijRLRUYsVlpjIrlArEfvacqtSGRs+4gAPnkbmUjstAWNo9w65u678Jr6EQEsuPWGeeaatAYYxdTlwRjI8OHCJJEEQwABZpgBwsILJ5wwAcOYEcwwzzwTSSZkoGLKH0sAAhsatVTwRQtjdIOGDG8wAQsenOBgTSgeCCHCG5Ig0kQffyCyBAOIzACKG7Q54UExWkCiDDI9IPIHKAP88IMjLcjAgiOE9LDAEDdA0YOQXHft9ddghy322GSXHVFAACH5BAkEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECM65EWRV8KKFiVqJOjjkcdHWD6KHEmy5EdeH4NtXPjspMlHH5B83CEypEleQT4WWZlQmUiMFZFgcXfggdEDSJNiQRICKK8EHy814ekQVJMKbaqx6ZGEzRIZaJDJEBKqxR82zXr0AfOmDhQ8WqjKnUu3rt27ePM2pChgIi8sehN6GYmBAzkE7pwqphjCHTAbKKqIJKB3gkuPwIDOegkAKLDLHufgDQb6pemSKD+60FtnATcywwiAsOJnzYpzuHPrzraGhjQrl6KZIRAsBS0tUFoEXs68ufPn0KNLn069OsaF16cv8nO6+8tyy2mU//ZuGgtUjyrxLvpoQlhJE7zIlTTAa8TNj37yYgPNS4N78h4JM0tqjxD4SDh4DTPeSLwgoU9F7qDACwIvGehEgh9tBqB3Bu6EFxhmbCjiIxPUwRwxC4ASyjHH1MGGFmLUocUMjniwgAhjXKEJG8SM0kYdjtQxgAicsPCJaNUlqeSSTDbp5JNQRinllFRWaaWSSFS0l5ZN0sclQtlRl8owUlxiBgggjJNmcFYww4wffkizxpw00LBGnMwIN4wLqDTH3YgALhEYASdpcEQBgH5UhREGmqLXT4mWJGFKeRXxUQEmRIraRyDkxcdHEYwkIEaoVeQfgx+ds9pdLlwGBEYYeP1XA0ZEeGTgGHhlsqCmBf7yEQuj7eoRBwRS5NEHBjKowEcX3kWaradhwQsAj2xwQAgqmGagEsFCyyuqH02A1yQfoWDAt5ca6ABeSjzrEQYxcPDCDglEoAEwuqDzAFLuoIOOLgjMEgE5QEAwggo5/OfRNJjkhU81k2SD7khmWKAFsHpFEUoFC/TAAA5gVDDHEkmwIEM3Y/yAzxgOFNOCEC0cQuMcFCAjhB0OeMBEH86N0YI40CBHCAObLPOHDMd4gwMaaIQywA1q9OEBCyIMwIYjDBzSZ3WEfMLHErX0YQcay7RATA9iJONIKJzAs8WVcMct99x012333XjnvVFAACH5BAUEAP8ALAAAAABGAEYAQAj/AP8JHEiwoMGDCBMqXMiwocOHECMiDDDp2aSLDXD1yyfoWbBhIIcFe1YuhclgKC9aaCcxIplHMB8JiEmzps2bMXnFJNCSIYGcOB+90AmTlzuYG4je5BUkZpGeCi0Ei/kBggBGAHQdcIcFSQheYMOGCIEEibsD6IBFaEQkBk1qUCW+8vbmj5YB0PrgQJaMDx4oy4rVecOigocZxAbEXcy4sePHkCNLZhy2YVhekxVOhXki7AENAmAY6YBBQpAgChQEqXIhx4kRNsghQAIWGM0/k90AfVTjMqN1QZGiu8yhKM03kjc/Uhq8eU3mEzLbOVRHDCIwxZIIEfFnBgMPxRaw/+EGjZskLaDAgHrDoMeNTsuO1b3SLbP9+/jz69/Pv7///wAy9BVYQCh0GYA/OafgTTwAYh9NzC0Y1FAxBTPZJzElYFMMly0FFhYd2KTUOZNlspuEzvEiTExNSDbMiTdxCNYGCIQVHHMuJBcTBDmgmCJNxkyGQwvBrOijc9K44IEH+TkCigdzvIEDFIvMsYQjUVSwxBczNGGHDB5wMgMaSyywhDXdDFAMCwG26eabcMYp55x01mnnnXjmqR9YD4F1Qpy9fcjQgXISepCh/2VCw5HNmRNMHfctcZMCOejzwg4JRAAAMLroggACwMwSQQJE1KDCBQXYZGFm0sDIKIQjxP80TGY0hfAqTkqtGpkeMRnRlE0bkHPBTRiQswGuMTGTjWR2xHRUTLNcxsssNwEgrQZGLkcTH5K9ZNwjVfASQnEocvCVAt/CtIlkKbha0682pYorvJ3omO5SjfxCGy9EFCBuUMwpYa+2ty5Fk8CRvQgTAgUbHBMqkhUDYQhYHIAAABEY0IgAO9hAhA07hBwyEAKQw8gsCDzgzlfoxESDEJOx0bBzwcxh3xV1BBKJGVb4kU02PAS9ojBEw0S0MDycc042NNBghRXjDONFMnbUdx8kyUADypXLQPIJKDcUs0wgUYQiCQtjLCMDDmpo0YwQy4Cxxx9LGMPJGPztMYYxbbwvkcwNx3BCTB1osAHNF800wQIxbQyBAxid/PDHHIvoafnlmGeu+eacd+7556BDFhAAOw==", Qu = {
  name: "Loading"
}, Cn = /* @__PURE__ */ $(ie(oe({}, Qu), {
  setup(e) {
    const { classPrefix: t, lang: n } = re();
    return (o, r) => (I(), S("div", {
      class: x(`${i(t)}__loading`)
    }, [
      C("img", {
        class: x(`${i(t)}__loading-icon`),
        src: bu,
        alt: "loading"
      }, null, 2),
      Ie(o.$slots, "default", {}, () => {
        var a;
        return [
          fe(Z((a = i(n)) == null ? void 0 : a.loading), 1)
        ];
      })
    ], 2));
  }
}));
const gr = "data:image/png;base64,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", Uu = { class: "empty-container" }, Bu = ["src"], Yu = /* @__PURE__ */ $({
  __name: "empty",
  props: {
    img: { default: gr },
    text: { default: "" },
    showImg: { type: Boolean, default: !0 }
  },
  setup(e) {
    const { lang: t } = re();
    return (n, o) => {
      var r;
      return I(), S("div", Uu, [
        e.showImg ? (I(), S("img", {
          key: 0,
          class: "empty-container__img",
          src: e.img || i(gr),
          alt: "empty"
        }, null, 8, Bu)) : ee("", !0),
        C("p", null, Z(e.text || ((r = i(t)) == null ? void 0 : r.noResult)), 1)
      ]);
    };
  }
});
const Ii = /* @__PURE__ */ wn(Yu, [["__scopeId", "data-v-b34e0156"]]), Ru = ["href"], Gu = /* @__PURE__ */ $({
  __name: "message-content",
  setup(e) {
    const { getNextSystemNotify: t, messages: n, isMore: o, showLoading: r, refresh: a } = Ot(), { classPrefix: c, env: s, lang: l } = re(), { studioUrl: u } = jn(s.value), M = `${c}-message-content`, N = V(() => i(n).length >= 4);
    return Ve(() => {
      t();
    }), In(() => {
      a();
    }), (d, g) => {
      var y;
      return I(), S(Ae, null, [
        i(n).length > 0 ? Ue((I(), S("div", {
          key: 0,
          class: x(M)
        }, [
          (I(!0), S(Ae, null, we(i(n), (D, p) => (I(), _(Su, { card: D }, null, 8, ["card"]))), 256))
        ])), [
          [i(pi), {
            callback: i(t),
            disabled: !i(o)
          }]
        ]) : (I(), S("div", {
          key: 1,
          class: x(`${M}-list-state`)
        }, [
          i(r) ? (I(), _(Cn, {
            key: 0,
            style: { "margin-top": "0" }
          })) : (I(), _(Ii, { key: 1 }))
        ], 2)),
        i(N) ? (I(), S("div", {
          key: 2,
          class: x(`${M}-footer`)
        }, [
          C("a", {
            href: `${i(u)}/notification?activeTab=notify`,
            target: "_blank"
          }, Z((y = i(l)) == null ? void 0 : y.viewMore), 9, Ru)
        ], 2)) : ee("", !0)
      ], 64);
    };
  }
});
const Pu = {
  name: "UserContent"
}, fi = /* @__PURE__ */ $(ie(oe({}, Pu), {
  props: {
    user: null,
    showFeedback: { type: Boolean }
  },
  setup(e) {
    const t = e, { user: n } = le(t), {
      classPrefix: o,
      config: r,
      locale: a,
      lang: c,
      isMobile: s,
      onLogout: l,
      onLogin: u,
      onSendFeedback: M
    } = re(), { resolve: N } = Ke(), d = te(
      "user"
      /* User */
    ), g = `${o}-user-content`, y = V(() => !!i(n)), D = V(
      () => {
        var f;
        return (f = ft.find((E) => E.value === i(a))) == null ? void 0 : f.label;
      }
    ), p = V(() => {
      var f, E, Y, R;
      return [
        {
          name: (f = i(c)) == null ? void 0 : f.myProfile,
          icon: "profile",
          url: i(N("account/setting")),
          show: i(y),
          newWindow: !1,
          isButton: !1
        },
        {
          name: (E = i(c)) == null ? void 0 : E.creatorCenter,
          icon: "creator",
          url: `${i(r).studioUrl}`,
          show: i(y),
          newWindow: !0,
          isButton: !1
        },
        {
          name: (Y = i(c)) == null ? void 0 : Y.history,
          icon: "history",
          url: i(N("history")),
          show: !i(y),
          newWindow: !1,
          isButton: !i(y)
        },
        {
          name: (R = i(c)) == null ? void 0 : R.fav,
          icon: "fav",
          url: i(N("fav")),
          show: !i(y),
          newWindow: !1,
          isButton: !i(y)
        }
      ];
    }), j = (f) => {
      d.value = f;
    }, A = () => {
      M();
    }, w = () => {
      l(), De.clickLogout();
    }, h = () => {
      i(y) || u();
    };
    return (f, E) => {
      var Y, R, U;
      return d.value === "user" ? (I(), S("div", {
        key: 0,
        class: x(g)
      }, [
        i(y) ? (I(), S("div", {
          key: 0,
          class: x([`${g}__head`])
        }, [
          i(n) ? (I(), _(Rt, {
            key: 0,
            avatar: i(n).avatar,
            name: i(n).name,
            width: 32
          }, null, 8, ["avatar", "name"])) : ee("", !0),
          C("p", {
            class: x(`${g}__name`)
          }, Z((Y = i(n)) == null ? void 0 : Y.name), 3)
        ], 2)) : ee("", !0),
        C("div", {
          class: x(`${g}__list`)
        }, [
          i(y) ? (I(), _(Cr, {
            key: 0,
            onClick: E[0] || (E[0] = (k) => j(
              "message"
              /* Message */
            ))
          })) : ee("", !0),
          (I(!0), S(Ae, null, we(i(p), (k) => (I(), S(Ae, {
            key: k.icon
          }, [
            k.show ? (I(), _(Xe, {
              key: 0,
              url: k.url,
              icon: k.icon,
              "new-window": k.newWindow,
              "is-button": k.isButton,
              prefix: "",
              onClick: h
            }, {
              default: ye(() => [
                fe(Z(k.name), 1)
              ]),
              _: 2
            }, 1032, ["url", "icon", "new-window", "is-button"])) : ee("", !0)
          ], 64))), 128)),
          ce(Xe, {
            icon: "lang",
            prefix: "",
            suffix: "",
            "is-button": "",
            onClick: E[1] || (E[1] = (k) => j(
              "lang"
              /* Lang */
            ))
          }, {
            default: ye(() => {
              var k;
              return [
                fe(Z((k = i(c)) == null ? void 0 : k.language) + ": " + Z(i(D)), 1)
              ];
            }),
            _: 1
          }),
          !i(s) && e.showFeedback ? (I(), _(Xe, {
            key: 1,
            icon: "feedback",
            prefix: "",
            "is-button": "",
            onClick: A
          }, {
            default: ye(() => {
              var k;
              return [
                fe(Z((k = i(c)) == null ? void 0 : k.sendFeedback), 1)
              ];
            }),
            _: 1
          })) : ee("", !0)
        ], 2),
        i(y) ? (I(), S("div", {
          key: 1,
          class: x(`${g}__footer`)
        }, [
          ce(Xe, {
            icon: "logout",
            prefix: "",
            "is-button": "",
            onClick: w
          }, {
            default: ye(() => {
              var k;
              return [
                fe(Z((k = i(c)) == null ? void 0 : k.logout), 1)
              ];
            }),
            _: 1
          })
        ], 2)) : ee("", !0)
      ])) : d.value === "lang" ? (I(), _(Bo, {
        key: 1,
        title: (R = i(c)) == null ? void 0 : R.choose,
        onBack: E[2] || (E[2] = (k) => j(
          "user"
          /* User */
        ))
      }, {
        content: ye(() => [
          ce(aa)
        ]),
        _: 1
      }, 8, ["title"])) : d.value === "message" ? (I(), _(Bo, {
        key: 2,
        title: (U = i(c)) == null ? void 0 : U.message,
        onBack: E[3] || (E[3] = (k) => j(
          "user"
          /* User */
        ))
      }, {
        content: ye(() => [
          ce(Gu)
        ]),
        _: 1
      }, 8, ["title"])) : ee("", !0);
    };
  }
}));
const Fu = typeof window == "undefined", Hu = (e) => typeof Element == "undefined" ? !1 : e instanceof Element, ct = /* @__PURE__ */ new Map();
let yr;
Fu || (document.addEventListener("mousedown", (e) => yr = e), document.addEventListener("mouseup", (e) => {
  for (const t of ct.values())
    for (const { documentHandler: n } of t)
      n(e, yr);
}));
function dr(e, t) {
  let n = [];
  return Array.isArray(t.arg) ? n = t.arg : Hu(t.arg) && n.push(t.arg), function(o, r) {
    const a = t.instance.popperRef, c = o.target, s = r == null ? void 0 : r.target, l = !t || !t.instance, u = !c || !s, M = e.contains(c) || e.contains(s), N = e === c, d = n.length && n.some((y) => y == null ? void 0 : y.contains(c)) || n.length && n.includes(s), g = a && (a.contains(c) || a.contains(s));
    l || u || M || N || d || g || t.value(o, r);
  };
}
const Vu = {
  beforeMount(e, t) {
    ct.has(e) || ct.set(e, []);
    const n = ct.get(e);
    n == null || n.push({
      documentHandler: dr(e, t),
      bindingFn: t.value
    });
  },
  updated(e, t) {
    ct.has(e) || ct.set(e, []);
    const n = ct.get(e), o = n == null ? void 0 : n.findIndex(
      (a) => a.bindingFn === t.oldValue
    ), r = {
      documentHandler: dr(e, t),
      bindingFn: t.value
    };
    o && o >= 0 ? n == null || n.splice(o, 1, r) : n == null || n.push(r);
  },
  unmounted(e) {
    ct.delete(e);
  }
}, Zu = Vu, Wu = {
  name: "Dropdown"
}, Ln = /* @__PURE__ */ $(ie(oe({}, Wu), {
  props: {
    right: { type: Boolean }
  },
  emits: ["show"],
  setup(e, { emit: t }) {
    const n = te(!1), { classPrefix: o } = re(), r = () => {
      n.value = !0, t("show", !0);
    }, a = () => {
      n.value = !1, t("show", !1);
    };
    return (c, s) => Ue((I(), S("div", {
      class: x([`${i(o)}__dropdown`, { [`${i(o)}__dropdown-hover`]: n.value }]),
      onMouseenter: r,
      onMouseleave: a
    }, [
      Ie(c.$slots, "default"),
      C("div", {
        class: x(`${i(o)}__dropdown-content`)
      }, [
        Ie(c.$slots, "content")
      ], 2)
    ], 34)), [
      [i(Zu), a]
    ]);
  }
}));
const Ju = {
  name: "Action"
}, ro = /* @__PURE__ */ $(ie(oe({}, Ju), {
  props: {
    icon: null,
    url: null,
    isButton: { type: Boolean },
    newWindow: { type: Boolean }
  },
  emits: ["click", "hover"],
  setup(e, { emit: t }) {
    const n = e, { classPrefix: o } = re(), { icon: r, url: a, isButton: c, newWindow: s } = le(n), l = V(() => {
      const N = { class: [`${o}__action`, i(r)] };
      return i(c) ? N : ie(oe({}, N), { href: i(a), target: i(s) ? "_blank" : "_self" });
    }), u = () => {
      t("click");
    }, M = () => {
      t("hover");
    };
    return (N, d) => (I(), _(Dr(i(c) ? "button" : "a"), pr(i(l), {
      onClick: u,
      onMouseenter: M
    }), null, 16));
  }
}));
var Ku = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function qu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ji = { exports: {} };
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function(e, t) {
  (function(o, r) {
    e.exports = r();
  })(Ku, function() {
    return (
      /******/
      function() {
        var n = {
          /***/
          686: (
            /***/
            function(a, c, s) {
              s.d(c, {
                default: function() {
                  return (
                    /* binding */
                    ne
                  );
                }
              });
              var l = s(279), u = /* @__PURE__ */ s.n(l), M = s(370), N = /* @__PURE__ */ s.n(M), d = s(817), g = /* @__PURE__ */ s.n(d);
              function y(H) {
                try {
                  return document.execCommand(H);
                } catch (P) {
                  return !1;
                }
              }
              var D = function(P) {
                var B = g()(P);
                return y("cut"), B;
              }, p = D;
              function j(H) {
                var P = document.documentElement.getAttribute("dir") === "rtl", B = document.createElement("textarea");
                B.style.fontSize = "12pt", B.style.border = "0", B.style.padding = "0", B.style.margin = "0", B.style.position = "absolute", B.style[P ? "right" : "left"] = "-9999px";
                var W = window.pageYOffset || document.documentElement.scrollTop;
                return B.style.top = "".concat(W, "px"), B.setAttribute("readonly", ""), B.value = H, B;
              }
              var A = function(P, B) {
                var W = j(P);
                B.container.appendChild(W);
                var K = g()(W);
                return y("copy"), W.remove(), K;
              }, w = function(P) {
                var B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                  container: document.body
                }, W = "";
                return typeof P == "string" ? W = A(P, B) : P instanceof HTMLInputElement && !["text", "search", "url", "tel", "password"].includes(P == null ? void 0 : P.type) ? W = A(P.value, B) : (W = g()(P), y("copy")), W;
              }, h = w;
              function f(H) {
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? f = function(B) {
                  return typeof B;
                } : f = function(B) {
                  return B && typeof Symbol == "function" && B.constructor === Symbol && B !== Symbol.prototype ? "symbol" : typeof B;
                }, f(H);
              }
              var E = function() {
                var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, B = P.action, W = B === void 0 ? "copy" : B, K = P.container, X = P.target, ue = P.text;
                if (W !== "copy" && W !== "cut")
                  throw new Error('Invalid "action" value, use either "copy" or "cut"');
                if (X !== void 0)
                  if (X && f(X) === "object" && X.nodeType === 1) {
                    if (W === "copy" && X.hasAttribute("disabled"))
                      throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    if (W === "cut" && (X.hasAttribute("readonly") || X.hasAttribute("disabled")))
                      throw new Error(`Invalid "target" attribute. You can't cut text from elements with "readonly" or "disabled" attributes`);
                  } else
                    throw new Error('Invalid "target" value, use a valid Element');
                if (ue)
                  return h(ue, {
                    container: K
                  });
                if (X)
                  return W === "cut" ? p(X) : h(X, {
                    container: K
                  });
              }, Y = E;
              function R(H) {
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? R = function(B) {
                  return typeof B;
                } : R = function(B) {
                  return B && typeof Symbol == "function" && B.constructor === Symbol && B !== Symbol.prototype ? "symbol" : typeof B;
                }, R(H);
              }
              function U(H, P) {
                if (!(H instanceof P))
                  throw new TypeError("Cannot call a class as a function");
              }
              function k(H, P) {
                for (var B = 0; B < P.length; B++) {
                  var W = P[B];
                  W.enumerable = W.enumerable || !1, W.configurable = !0, "value" in W && (W.writable = !0), Object.defineProperty(H, W.key, W);
                }
              }
              function q(H, P, B) {
                return P && k(H.prototype, P), B && k(H, B), H;
              }
              function se(H, P) {
                if (typeof P != "function" && P !== null)
                  throw new TypeError("Super expression must either be null or a function");
                H.prototype = Object.create(P && P.prototype, { constructor: { value: H, writable: !0, configurable: !0 } }), P && b(H, P);
              }
              function b(H, P) {
                return b = Object.setPrototypeOf || function(W, K) {
                  return W.__proto__ = K, W;
                }, b(H, P);
              }
              function L(H) {
                var P = v();
                return function() {
                  var W = F(H), K;
                  if (P) {
                    var X = F(this).constructor;
                    K = Reflect.construct(W, arguments, X);
                  } else
                    K = W.apply(this, arguments);
                  return O(this, K);
                };
              }
              function O(H, P) {
                return P && (R(P) === "object" || typeof P == "function") ? P : G(H);
              }
              function G(H) {
                if (H === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return H;
              }
              function v() {
                if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham)
                  return !1;
                if (typeof Proxy == "function")
                  return !0;
                try {
                  return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                  })), !0;
                } catch (H) {
                  return !1;
                }
              }
              function F(H) {
                return F = Object.setPrototypeOf ? Object.getPrototypeOf : function(B) {
                  return B.__proto__ || Object.getPrototypeOf(B);
                }, F(H);
              }
              function z(H, P) {
                var B = "data-clipboard-".concat(H);
                if (P.hasAttribute(B))
                  return P.getAttribute(B);
              }
              var J = /* @__PURE__ */ function(H) {
                se(B, H);
                var P = L(B);
                function B(W, K) {
                  var X;
                  return U(this, B), X = P.call(this), X.resolveOptions(K), X.listenClick(W), X;
                }
                return q(B, [{
                  key: "resolveOptions",
                  value: function() {
                    var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    this.action = typeof K.action == "function" ? K.action : this.defaultAction, this.target = typeof K.target == "function" ? K.target : this.defaultTarget, this.text = typeof K.text == "function" ? K.text : this.defaultText, this.container = R(K.container) === "object" ? K.container : document.body;
                  }
                  /**
                   * Adds a click event listener to the passed trigger.
                   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
                   */
                }, {
                  key: "listenClick",
                  value: function(K) {
                    var X = this;
                    this.listener = N()(K, "click", function(ue) {
                      return X.onClick(ue);
                    });
                  }
                  /**
                   * Defines a new `ClipboardAction` on each click event.
                   * @param {Event} e
                   */
                }, {
                  key: "onClick",
                  value: function(K) {
                    var X = K.delegateTarget || K.currentTarget, ue = this.action(X) || "copy", Me = Y({
                      action: ue,
                      container: this.container,
                      target: this.target(X),
                      text: this.text(X)
                    });
                    this.emit(Me ? "success" : "error", {
                      action: ue,
                      text: Me,
                      trigger: X,
                      clearSelection: function() {
                        X && X.focus(), window.getSelection().removeAllRanges();
                      }
                    });
                  }
                  /**
                   * Default `action` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultAction",
                  value: function(K) {
                    return z("action", K);
                  }
                  /**
                   * Default `target` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultTarget",
                  value: function(K) {
                    var X = z("target", K);
                    if (X)
                      return document.querySelector(X);
                  }
                  /**
                   * Allow fire programmatically a copy action
                   * @param {String|HTMLElement} target
                   * @param {Object} options
                   * @returns Text copied.
                   */
                }, {
                  key: "defaultText",
                  /**
                   * Default `text` lookup function.
                   * @param {Element} trigger
                   */
                  value: function(K) {
                    return z("text", K);
                  }
                  /**
                   * Destroy lifecycle.
                   */
                }, {
                  key: "destroy",
                  value: function() {
                    this.listener.destroy();
                  }
                }], [{
                  key: "copy",
                  value: function(K) {
                    var X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                      container: document.body
                    };
                    return h(K, X);
                  }
                  /**
                   * Allow fire programmatically a cut action
                   * @param {String|HTMLElement} target
                   * @returns Text cutted.
                   */
                }, {
                  key: "cut",
                  value: function(K) {
                    return p(K);
                  }
                  /**
                   * Returns the support of the given action, or all actions if no action is
                   * given.
                   * @param {String} [action]
                   */
                }, {
                  key: "isSupported",
                  value: function() {
                    var K = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["copy", "cut"], X = typeof K == "string" ? [K] : K, ue = !!document.queryCommandSupported;
                    return X.forEach(function(Me) {
                      ue = ue && !!document.queryCommandSupported(Me);
                    }), ue;
                  }
                }]), B;
              }(u()), ne = J;
            }
          ),
          /***/
          828: (
            /***/
            function(a) {
              var c = 9;
              if (typeof Element != "undefined" && !Element.prototype.matches) {
                var s = Element.prototype;
                s.matches = s.matchesSelector || s.mozMatchesSelector || s.msMatchesSelector || s.oMatchesSelector || s.webkitMatchesSelector;
              }
              function l(u, M) {
                for (; u && u.nodeType !== c; ) {
                  if (typeof u.matches == "function" && u.matches(M))
                    return u;
                  u = u.parentNode;
                }
              }
              a.exports = l;
            }
          ),
          /***/
          438: (
            /***/
            function(a, c, s) {
              var l = s(828);
              function u(d, g, y, D, p) {
                var j = N.apply(this, arguments);
                return d.addEventListener(y, j, p), {
                  destroy: function() {
                    d.removeEventListener(y, j, p);
                  }
                };
              }
              function M(d, g, y, D, p) {
                return typeof d.addEventListener == "function" ? u.apply(null, arguments) : typeof y == "function" ? u.bind(null, document).apply(null, arguments) : (typeof d == "string" && (d = document.querySelectorAll(d)), Array.prototype.map.call(d, function(j) {
                  return u(j, g, y, D, p);
                }));
              }
              function N(d, g, y, D) {
                return function(p) {
                  p.delegateTarget = l(p.target, g), p.delegateTarget && D.call(d, p);
                };
              }
              a.exports = M;
            }
          ),
          /***/
          879: (
            /***/
            function(a, c) {
              c.node = function(s) {
                return s !== void 0 && s instanceof HTMLElement && s.nodeType === 1;
              }, c.nodeList = function(s) {
                var l = Object.prototype.toString.call(s);
                return s !== void 0 && (l === "[object NodeList]" || l === "[object HTMLCollection]") && "length" in s && (s.length === 0 || c.node(s[0]));
              }, c.string = function(s) {
                return typeof s == "string" || s instanceof String;
              }, c.fn = function(s) {
                var l = Object.prototype.toString.call(s);
                return l === "[object Function]";
              };
            }
          ),
          /***/
          370: (
            /***/
            function(a, c, s) {
              var l = s(879), u = s(438);
              function M(y, D, p) {
                if (!y && !D && !p)
                  throw new Error("Missing required arguments");
                if (!l.string(D))
                  throw new TypeError("Second argument must be a String");
                if (!l.fn(p))
                  throw new TypeError("Third argument must be a Function");
                if (l.node(y))
                  return N(y, D, p);
                if (l.nodeList(y))
                  return d(y, D, p);
                if (l.string(y))
                  return g(y, D, p);
                throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
              }
              function N(y, D, p) {
                return y.addEventListener(D, p), {
                  destroy: function() {
                    y.removeEventListener(D, p);
                  }
                };
              }
              function d(y, D, p) {
                return Array.prototype.forEach.call(y, function(j) {
                  j.addEventListener(D, p);
                }), {
                  destroy: function() {
                    Array.prototype.forEach.call(y, function(j) {
                      j.removeEventListener(D, p);
                    });
                  }
                };
              }
              function g(y, D, p) {
                return u(document.body, y, D, p);
              }
              a.exports = M;
            }
          ),
          /***/
          817: (
            /***/
            function(a) {
              function c(s) {
                var l;
                if (s.nodeName === "SELECT")
                  s.focus(), l = s.value;
                else if (s.nodeName === "INPUT" || s.nodeName === "TEXTAREA") {
                  var u = s.hasAttribute("readonly");
                  u || s.setAttribute("readonly", ""), s.select(), s.setSelectionRange(0, s.value.length), u || s.removeAttribute("readonly"), l = s.value;
                } else {
                  s.hasAttribute("contenteditable") && s.focus();
                  var M = window.getSelection(), N = document.createRange();
                  N.selectNodeContents(s), M.removeAllRanges(), M.addRange(N), l = M.toString();
                }
                return l;
              }
              a.exports = c;
            }
          ),
          /***/
          279: (
            /***/
            function(a) {
              function c() {
              }
              c.prototype = {
                on: function(s, l, u) {
                  var M = this.e || (this.e = {});
                  return (M[s] || (M[s] = [])).push({
                    fn: l,
                    ctx: u
                  }), this;
                },
                once: function(s, l, u) {
                  var M = this;
                  function N() {
                    M.off(s, N), l.apply(u, arguments);
                  }
                  return N._ = l, this.on(s, N, u);
                },
                emit: function(s) {
                  var l = [].slice.call(arguments, 1), u = ((this.e || (this.e = {}))[s] || []).slice(), M = 0, N = u.length;
                  for (M; M < N; M++)
                    u[M].fn.apply(u[M].ctx, l);
                  return this;
                },
                off: function(s, l) {
                  var u = this.e || (this.e = {}), M = u[s], N = [];
                  if (M && l)
                    for (var d = 0, g = M.length; d < g; d++)
                      M[d].fn !== l && M[d].fn._ !== l && N.push(M[d]);
                  return N.length ? u[s] = N : delete u[s], this;
                }
              }, a.exports = c, a.exports.TinyEmitter = c;
            }
          )
          /******/
        }, o = {};
        function r(a) {
          if (o[a])
            return o[a].exports;
          var c = o[a] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return n[a](c, c.exports, r), c.exports;
        }
        return function() {
          r.n = function(a) {
            var c = a && a.__esModule ? (
              /******/
              function() {
                return a.default;
              }
            ) : (
              /******/
              function() {
                return a;
              }
            );
            return r.d(c, { a: c }), c;
          };
        }(), function() {
          r.d = function(a, c) {
            for (var s in c)
              r.o(c, s) && !r.o(a, s) && Object.defineProperty(a, s, { enumerable: !0, get: c[s] });
          };
        }(), function() {
          r.o = function(a, c) {
            return Object.prototype.hasOwnProperty.call(a, c);
          };
        }(), r(686);
      }().default
    );
  });
})(ji);
const Xu = /* @__PURE__ */ qu(ji.exports), _u = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjYwODEgMi4zOTE5N0gyLjM5MTk0QzEuNTEyNTIgMi4zOTE5NyAwLjc5Njg3NSAzLjEwNzQ5IDAuNzk2ODc1IDMuOTg3MDNWMTQuMDEzMUMwLjc5Njg3NSAxNC44OTI2IDEuNTEyNTIgMTUuNjA4MSAyLjM5MTk0IDE1LjYwODFIMTUuNjA4MUMxNi40ODc1IDE1LjYwODEgMTcuMjAzMSAxNC44OTI2IDE3LjIwMzEgMTQuMDEzMVYzLjk4NzAxQzE3LjIwMzEgMy4xMDc0OSAxNi40ODc1IDIuMzkxOTcgMTUuNjA4MSAyLjM5MTk3Wk0xNS44MzU5IDE0LjAxMzFDMTUuODM1OSAxNC4xMzY1IDE1LjczMTYgMTQuMjQwOSAxNS42MDgxIDE0LjI0MDlIMi4zOTE5NEMyLjI2ODQ1IDE0LjI0MDkgMi4xNjQwOCAxNC4xMzY1IDIuMTY0MDggMTQuMDEzMVYzLjk4NzAxQzIuMTY0MDggMy44NjM1MSAyLjI2ODQ1IDMuNzU5MTUgMi4zOTE5NCAzLjc1OTE1SDE1LjYwODFDMTUuNzMxNiAzLjc1OTE1IDE1LjgzNTkgMy44NjM1MSAxNS44MzU5IDMuOTg3MDFWMTQuMDEzMVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuODUiLz4KPHBhdGggZD0iTTcuMDYzMSA4LjMxNjMxSDUuMDEyMzJWNS44MDk4MUgzLjY0NTE0VjEyLjE5SDUuMDEyMzJWOS42ODM1Mkg3LjA2MzFWMTIuMTlIOC40MzAyOFY1LjgwOTgxSDcuMDYzMVY4LjMxNjMxWk0xMi43NTk3IDUuODA5ODFIOS4zNDE3N1YxMi4xOUgxMi43NTk3QzEzLjYzOTIgMTIuMTkgMTQuMzU0OCAxMS40NzQ1IDE0LjM1NDggMTAuNTk1VjcuNDA0ODVDMTQuMzU0OCA2LjUyNTM0IDEzLjYzOTIgNS44MDk4MSAxMi43NTk3IDUuODA5ODFaTTEyLjk4NzYgMTAuNTk1QzEyLjk4NzYgMTAuNzE4NSAxMi44ODMyIDEwLjgyMjggMTIuNzU5NyAxMC44MjI4SDEwLjcwODlWNy4xNzY5OUgxMi43NTk3QzEyLjg4MzIgNy4xNzY5OSAxMi45ODc2IDcuMjgxMzYgMTIuOTg3NiA3LjQwNDg1VjEwLjU5NVoiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuODUiLz4KPC9zdmc+Cg==", $u = "data:image/svg+xml;base64,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", eM = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjQyNTc4IDEwLjgxNzZDMi40MjU3OCAxMC41NDE1IDIuNjQ5NjQgMTAuMzE3NiAyLjkyNTc4IDEwLjMxNzZIMy40MjU3OEMzLjcwMTkyIDEwLjMxNzYgMy45MjU3OCAxMC41NDE1IDMuOTI1NzggMTAuODE3NkwzLjkyNTc3IDE0LjE5NTFMMTQuMDY5OSAxNC4xOTUxTDE0LjA2OTkgMTAuODE3NkMxNC4wNjk5IDEwLjU0MTUgMTQuMjkzOCAxMC4zMTc2IDE0LjU2OTkgMTAuMzE3NkgxNS4wNjk5QzE1LjM0NjEgMTAuMzE3NiAxNS41Njk5IDEwLjU0MTUgMTUuNTY5OSAxMC44MTc2TDE1LjU2OTkgMTQuNjk1NEMxNS41Njk5IDE1LjI0NzcgMTUuMTIyMiAxNS42OTU0IDE0LjU2OTkgMTUuNjk1NEwzLjQyNTc4IDE1LjY5NTRDMi44NzM1IDE1LjY5NTQgMi40MjU3OCAxNS4yNDc3IDIuNDI1NzggMTQuNjk1NEwyLjQyNTc4IDEwLjgxNzZaIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwLjg1Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC45NTUzIDExLjcwMTdDOS4xNjQwNSAxMS43MTYgOS4zNzc2NSAxMS42NDMzIDkuNTM3MjMgMTEuNDgzOEwxMC4wNjk2IDEwLjk1MTRMMTAuMDYyMyAxMC45NDRMMTMuMDAzNSA4LjAwMjc5QzEzLjI5NyA3LjcwOTMyIDEzLjI5NyA3LjIzMzUyIDEzLjAwMzUgNi45NDAwNkMxMi43MTAxIDYuNjQ2NTkgMTIuMjM0MyA2LjY0NjU5IDExLjk0MDggNi45NDAwNkw5Ljc1MTQ4IDkuMTI5MzlWMi42NDcyMkM5Ljc1MTQ4IDIuMjMyMTkgOS40MTUwMyAxLjg5NTc1IDkuMDAwMDEgMS44OTU3NUM4LjU4NDk5IDEuODk1NzUgOC4yNDg1NSAyLjIzMjE5IDguMjQ4NTUgMi42NDcyMlY5LjEzMDI3TDYuMDU2ODggNi45Mzg2QzUuNzYzNDEgNi42NDUxNCA1LjI4NzYxIDYuNjQ1MTQgNC45OTQxNSA2LjkzODZDNC43MDA2OCA3LjIzMjA3IDQuNzAwNjggNy43MDc4NyA0Ljk5NDE1IDguMDAxMzRMNy45MzY4NCAxMC45NDRMNy45MzAzMyAxMC45NTA1TDguNDYyNzMgMTEuNDgyOUM4LjU5OTU3IDExLjYxOTggOC43NzYxMyAxMS42OTI3IDguOTU1MyAxMS43MDE3WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC44NSIvPgo8L3N2Zz4K", tM = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAB0AQMAAABuVIRkAAAABlBMVEX///8AAABVwtN+AAAAnUlEQVQ4y8TIQWEgQRDDQDEwf5ZioJvbMOg84pfK/PkqnfviYOE/9cXJKTbNs/mdNzgbfPCLgyu/VQd/s+3rg5suVPDi3GiuOFiX8TA8OGEprotHtsfgYudi8xUHF5kb5cEWDm2ePBtQxsE/n8jNlRuqeLDgqKdxcepzOa92/BuQQy4fEh1AM8nig4SAGJiiSOYjypP/YFNJ5w80AADx/h1KLyD4fgAAAABJRU5ErkJggg==", nM = /* @__PURE__ */ $({
  __name: "toast",
  props: {
    message: null,
    onDestroy: null,
    containerStyle: null,
    msgStyle: null
  },
  setup(e) {
    const t = e, { message: n } = le(t), o = te(!0);
    return Ve(() => {
      setTimeout(() => {
        o.value = !1, t.onDestroy();
      }, 3e3);
    }), (r, a) => (I(), _(It, { to: "body" }, [
      o.value ? (I(), S("div", {
        key: 0,
        class: "toast",
        style: $e(e.containerStyle)
      }, [
        C("p", {
          class: "toast__message",
          style: $e(e.msgStyle)
        }, Z(i(n)), 5)
      ], 4)) : ee("", !0)
    ]));
  }
});
const oM = /* @__PURE__ */ wn(nM, [["__scopeId", "data-v-3b1f7b60"]]), rM = (e, t, n) => {
  const o = document.createElement("div"), r = Er(oM, { message: e, onDestroy: () => qn(null, o), containerStyle: t, msgStyle: n });
  qn(r, o);
}, iM = ["src"], aM = ["src"], sM = {
  name: "Upload"
}, cM = /* @__PURE__ */ $(ie(oe({}, sM), {
  setup(e) {
    const t = "https://bili.im/iXuyrBY", { classPrefix: n, lang: o } = re(), { QRDesc: r = "", QRDescLink: a = "" } = i(o), c = r.split(a), s = `${n}__download`, l = [
      {
        icon: _u,
        text: i(o).downDesc1
      },
      {
        icon: $u,
        text: i(o).downDesc2
      },
      {
        icon: eM,
        text: i(o).downDesc3
      }
    ], u = (M) => {
      Xu.copy(t), rM(i(o).copySuccess);
    };
    return (M, N) => (I(), _(Ln, null, {
      content: ye(() => [
        C("div", {
          class: x(`${s}-content`)
        }, [
          C("h3", {
            class: x(`${s}-content-header`)
          }, Z(i(o).downTitle), 3),
          (I(), S(Ae, null, we(l, (d) => C("div", {
            key: d.text,
            class: x(`${s}-content-benefit`)
          }, [
            C("div", {
              class: x(`${s}-content-benefit--item`)
            }, [
              C("span", {
                class: x(`${s}-content-benefit--item-icon`)
              }, [
                C("img", {
                  class: x(`${s}-content-benefit--item-img`),
                  src: d.icon
                }, null, 10, iM)
              ], 2),
              C("div", {
                class: x(`${s}-content-benefit--item-text`)
              }, Z(d.text), 3)
            ], 2)
          ], 2)), 64)),
          C("div", {
            class: x(`${s}-content-qrcode`)
          }, [
            C("p", {
              class: x(`${s}-content-qrcode--desc`),
              onClick: N[0] || (N[0] = (d) => u())
            }, [
              fe(Z(i(c)[0]) + " ", 1),
              C("span", {
                class: x(`${s}-content-qrcode--copy`)
              }, Z(i(a)), 3),
              fe(" " + Z(i(c)[1]), 1)
            ], 2),
            C("div", {
              class: x(`${s}-content-qrcode--img`)
            }, [
              C("img", {
                src: i(tM),
                alt: "qrcode"
              }, null, 8, aM)
            ], 2)
          ], 2)
        ], 2)
      ]),
      default: ye(() => [
        C("div", {
          class: x(s)
        }, [
          C("a", {
            href: t,
            class: x(`${s}-btn`),
            target: "_blank"
          }, Z(i(o).app), 3)
        ])
      ]),
      _: 1
    }));
  }
}));
const lM = { class: "login-tip" }, uM = ["src"], MM = /* @__PURE__ */ $({
  __name: "login-tip",
  props: {
    icon: null,
    tip: { default: "" }
  },
  setup(e) {
    return (t, n) => (I(), S("div", lM, [
      C("img", {
        class: "login-tip__image",
        src: e.icon,
        alt: ""
      }, null, 8, uM),
      C("span", null, Z(e.tip), 1)
    ]));
  }
});
const gM = "data:image/svg+xml;base64,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", yM = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+aGlzdG9yaWNhbCByZWNvcmQ8L3RpdGxlPgogICAgPGcgaWQ9Imhpc3RvcmljYWwtcmVjb3JkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cmVjdCBpZD0i55+p5b2i5aSH5Lu9LTMiIG9wYWNpdHk9IjAuODIyMjIwMjAzIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPjwvcmVjdD4KICAgICAgICA8Y2lyY2xlIGlkPSLmpK3lnIblvaIiIGZpbGw9IiM0QzkzRkYiIGN4PSIxMiIgY3k9IjEyIiByPSI5LjUiPjwvY2lyY2xlPgogICAgICAgIDxwb2x5bGluZSBpZD0i6Lev5b6ELTMiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgcG9pbnRzPSIxMSA4LjM2MTMyODEyIDExIDE0LjM2MTMyODEgMTUgMTQuMzYxMzI4MSI+PC9wb2x5bGluZT4KICAgIDwvZz4KPC9zdmc+", dM = "data:image/svg+xml;base64,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", NM = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Y29weXJpZ2h0PC90aXRsZT4KICAgIDxnIGlkPSJjb3B5cmlnaHQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxyZWN0IGlkPSLnn6nlvaLlpIfku70tMyIgb3BhY2l0eT0iMC44MjIyMjAyMDMiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PC9yZWN0PgogICAgICAgIDxjaXJjbGUgaWQ9IuakreWchuW9oiIgZmlsbD0iIzRDOTNGRiIgY3g9IjEyIiBjeT0iMTIiIHI9IjkuNSI+PC9jaXJjbGU+CiAgICAgICAgPHRleHQgaWQ9IkMiIGZvbnQtZmFtaWx5PSJTRlVJRGlzcGxheS1Cb2xkLCBTRiBVSSBEaXNwbGF5IiBmb250LXNpemU9IjExIiBmb250LXdlaWdodD0iYm9sZCIgbGluZS1zcGFjaW5nPSIxMiIgbGV0dGVyLXNwYWNpbmc9Ii0wLjMzMDAwMDAxMyIgZmlsbD0iI0ZGRkZGRiI+CiAgICAgICAgICAgIDx0c3BhbiB4PSI4IiB5PSIxNiI+QzwvdHNwYW4+CiAgICAgICAgPC90ZXh0PgogICAgPC9nPgo8L3N2Zz4=", AM = /* @__PURE__ */ $({
  __name: "login-panel",
  setup(e) {
    const { classPrefix: t, lang: n } = re(), o = `${t}-login-panel`, r = V(() => {
      var c, s, l, u;
      return [
        { icon: gM, tip: (c = i(n)) == null ? void 0 : c.freeVideo },
        { icon: yM, tip: (s = i(n)) == null ? void 0 : s.syncBrowsing },
        { icon: dM, tip: (l = i(n)) == null ? void 0 : l.sendComment },
        { icon: NM, tip: (u = i(n)) == null ? void 0 : u.watch }
      ];
    }), a = (c) => {
      c === "main" ? De.clickLoginPanelLogin() : De.clickLoginPanelRegister(), typeof window != "undefined" && window.postMessage({ name: "bstar-header-login", page: c }, "*");
    };
    return (c, s) => {
      var l, u, M, N;
      return I(), S("div", {
        class: x(o)
      }, [
        C("p", {
          class: x(`${o}__title`)
        }, Z((l = i(n)) == null ? void 0 : l.loginEnjoy), 3),
        C("div", {
          class: x(`${o}__content`)
        }, [
          (I(!0), S(Ae, null, we(i(r), (d, g) => (I(), _(MM, {
            key: g,
            icon: d.icon,
            tip: d.tip
          }, null, 8, ["icon", "tip"]))), 128))
        ], 2),
        C("button", {
          class: x(`${o}__btn`),
          onClick: s[0] || (s[0] = (d) => a("main"))
        }, Z((u = i(n)) == null ? void 0 : u.loginNow), 3),
        C("p", {
          class: x(`${o}__footer`)
        }, [
          fe(Z((M = i(n)) == null ? void 0 : M.tapHereTo), 1),
          C("button", {
            class: x(`${o}__footer-link`),
            onClick: s[1] || (s[1] = (d) => a("register"))
          }, Z((N = i(n)) == null ? void 0 : N.createAccount), 3)
        ], 2)
      ]);
    };
  }
});
const DM = ["href"], pM = ["href"], IM = ["href"], fM = {
  name: "UserDrawer"
}, jM = /* @__PURE__ */ $(ie(oe({}, fM), {
  props: {
    visible: { type: Boolean },
    user: null
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const { classPrefix: n, lang: o, onLogout: r } = re(), { resolve: a } = Ke(), c = `${n}-user-drawer`, s = a("account/setting"), l = a("history"), u = a("fav"), M = () => {
      t("close");
    }, N = () => {
      De.clickHistory();
    }, d = () => {
      De.clickFav();
    };
    return (g, y) => {
      var D, p, j, A, w;
      return I(), S("div", {
        class: x([c, { show: e.visible }])
      }, [
        C("div", {
          class: x(`${c}__header`)
        }, [
          C("button", { onClick: M }),
          C("p", null, Z((D = i(o)) == null ? void 0 : D.account), 1)
        ], 2),
        C("div", {
          class: x(`${c}__list`)
        }, [
          C("a", {
            class: x(`${c}__btn fav`),
            href: i(u),
            onClick: d
          }, Z((p = i(o)) == null ? void 0 : p.fav), 11, DM),
          C("a", {
            class: x(`${c}__btn history`),
            href: i(l),
            onClick: N
          }, Z((j = i(o)) == null ? void 0 : j.history), 11, pM),
          C("a", {
            class: x(`${c}__btn profile`),
            href: i(s)
          }, Z((A = i(o)) == null ? void 0 : A.myProfile), 11, IM)
        ], 2),
        C("div", {
          class: x(`${c}__footer`)
        }, [
          C("button", {
            class: x(`${c}__btn logout`),
            onClick: y[0] || (y[0] = //@ts-ignore
            (...h) => i(r) && i(r)(...h))
          }, [
            ce(Rt, {
              avatar: e.user.avatar,
              name: e.user.name,
              width: 24
            }, null, 8, ["avatar", "name"]),
            fe(" " + Z((w = i(o)) == null ? void 0 : w.logout), 1)
          ], 2)
        ], 2)
      ], 2);
    };
  }
}));
const Nr = (e, t) => {
  var n, o, r;
  (n = t.value) != null && n.id && (e.dataset.bExposeId = t.value.id), (o = t.value) != null && o.key && (e.dataset.bExposeKey = t.value.key), (r = t.value) != null && r.data && (e.dataset.bExposeData = t.value.data);
}, hM = {
  mounted: Nr,
  updated: Nr
}, vn = hM, wM = () => {
  const e = (c) => window.localStorage.getItem(c), t = (c, s) => {
    window.localStorage.setItem(c, s);
  }, n = () => Number(e(
    "bstar-login-panel-show-counts"
    /* loginPanelShowCount */
  ));
  return {
    loginPanelShowCount: n,
    increaseLoginPanelCount: () => {
      t("bstar-login-panel-show-counts", (n() + 1).toString());
    },
    getSearchHistory: () => {
      const c = e(
        "bstar-search-history"
        /* searchHistory */
      );
      return c ? JSON.parse(c) : [];
    },
    setSearchHistory: (c) => {
      t("bstar-search-history", JSON.stringify(c));
    }
  };
}, gt = wM(), EM = ["href"], TM = {
  name: "UserInfo"
}, xM = /* @__PURE__ */ $(ie(oe({}, TM), {
  props: {
    user: null,
    showPanel: { type: Boolean },
    showFeedback: { type: Boolean }
  },
  setup(e) {
    const t = e, { user: n, showPanel: o } = le(t), { classPrefix: r, isMobile: a, lang: c, onLogin: s } = re(), { unreadCount: l } = Ot(), { resolve: u } = Ke(), M = `${r}-user`, N = te(!1), d = te(0), g = te(!1), y = De.exposeLoginPanel(), D = V(() => {
      var f;
      return (f = n.value) != null && f.mid ? u(`space/${n.value.mid}`).value : "";
    }), p = V(() => !i(a) && !i(n) && i(g)), j = () => {
      N.value = !i(N);
    }, A = () => {
      d.value && clearTimeout(d.value), i(o) && (g.value = !0);
    }, w = () => {
      g.value = !1;
    }, h = () => {
      i(o) && !i(n) && gt.loginPanelShowCount() < 3 && (g.value = !0, gt.increaseLoginPanelCount(), d.value = setTimeout(() => {
        g.value = !1;
      }, 5e3));
    };
    return mt(o, (f) => {
      f && h();
    }), Ve(h), (f, E) => i(n) ? (I(), S(Ae, { key: 0 }, [
      i(a) ? (I(), S(Ae, { key: 0 }, [
        C("button", {
          class: x([`${M}__avatar`, `${M}__avatar--mobile`]),
          onClick: j
        }, [
          ce(Rt, {
            avatar: i(n).avatar,
            name: i(n).name,
            width: 24
          }, null, 8, ["avatar", "name"])
        ], 2),
        ce(jM, {
          visible: N.value,
          user: i(n),
          onClose: j
        }, null, 8, ["visible", "user"])
      ], 64)) : (I(), _(Ln, { key: 1 }, {
        content: ye(() => [
          ce(fi, {
            user: i(n),
            "show-feedback": e.showFeedback
          }, null, 8, ["user", "show-feedback"])
        ]),
        default: ye(() => [
          C("a", {
            class: x(`${M}__avatar`),
            href: i(D)
          }, [
            ce(Rt, {
              avatar: i(n).avatar,
              name: i(n).name,
              width: 32,
              "avatar-border": !0
            }, null, 8, ["avatar", "name"]),
            i(l) ? (I(), S("span", {
              key: 0,
              class: x(`${M}__reddot`)
            }, null, 2)) : ee("", !0)
          ], 10, EM)
        ]),
        _: 1
      }))
    ], 64)) : (I(), S("div", {
      key: 1,
      onMouseenter: A,
      onMouseleave: w
    }, [
      C("span", {
        class: x([`${M}__btn`, { [`${M}__btn--mobile`]: i(a) }]),
        onClick: E[0] || (E[0] = //@ts-ignore
        (...Y) => i(s) && i(s)(...Y))
      }, null, 2),
      C("div", {
        class: x(`${M}__login-panel`)
      }, [
        i(p) ? Ue((I(), _(AM, { key: 0 }, null, 512)), [
          [i(vn), i(y)]
        ]) : ee("", !0)
      ], 2)
    ], 32));
  }
}));
const mM = {
  name: "Loading"
}, OM = /* @__PURE__ */ $(ie(oe({}, mM), {
  props: {
    onelinkUrl: null
  },
  setup(e) {
    const t = e, { classPrefix: n, lang: o } = re(), r = `${n}__openapp`, { resolve: a, toUrl: c } = Ke(), { onelinkUrl: s } = le(t), l = a("download"), u = V(() => i(s) || i(l)), M = () => {
      c(i(u));
    };
    return (N, d) => {
      var g;
      return I(), S("button", {
        class: x(r),
        onClick: M
      }, Z((g = i(o)) == null ? void 0 : g.openApp), 1);
    };
  }
}));
const Jt = (e, t, n) => {
  const o = jn(e), r = n ? `${o.loginUrl}/x/intl/passport-login/web/` : `${o.apiUrl}/intl/gateway/web/v2/`, a = (l, u) => Le(void 0, null, function* () {
    const M = yield fetch(`${r}${l}`, u), { code: N, message: d, data: g } = yield M.json();
    if (N !== 0)
      throw new Error(d);
    return g;
  });
  return { get: (l, u) => {
    const M = Object.entries(oe({ s_locale: Qo.get(t), platform: "web" }, u)).map((N) => N.join("=")).join("&");
    return a(`${l}?${M}`, {
      credentials: "include"
    });
  }, postForm: (l, u) => {
    const M = Object.entries(oe({ s_locale: Qo.get(t), platform: "web" }, u)).map((N) => N.join("=")).join("&");
    return a(`${l}?${M}`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });
  } };
}, zM = () => {
  const { env: e, locale: t } = re(), n = Jt(i(e), i(t)), o = te({
    today: { name: "", cards: [] },
    yesterday: { name: "", cards: [] },
    earlier: { name: "", cards: [] }
  }), r = te(!1), a = V(
    () => [
      "today",
      "yesterday",
      "earlier"
      /* earlier */
    ].map((l) => i(o)[l]).filter((l) => {
      var u;
      return (u = l.cards) == null ? void 0 : u.length;
    })
  ), c = V(() => !i(a).length), s = fn(300, () => Le(void 0, null, function* () {
    r.value = !0;
    try {
      o.value = yield n.get("history/nav_list");
    } catch (l) {
    } finally {
      r.value = !1;
    }
  }));
  return { histories: a, isFetching: r, isEmpty: c, fetchHistory: s };
};
var hi = /* @__PURE__ */ ((e) => (e.history = "history", e.explore = "explore", e.hot = "hot", e.hotUgc = "hot_ugc", e))(hi || {}), Ht = /* @__PURE__ */ ((e) => (e.OgvHistoryNav = "ogv_history_nav", e.UgcHistoryNav = "ugc_history_nav", e.OgvFavNav = "ogv_fav_nav", e.UgcFavNav = "ugc_fav_nav", e))(Ht || {});
const CM = {
  name: "PopoverHistory"
}, LM = /* @__PURE__ */ $(ie(oe({}, CM), {
  props: {
    histories: null
  },
  setup(e) {
    const t = e, { histories: n } = le(t), { classPrefix: o } = re(), { resolve: r } = Ke(), a = zr.historyCard, c = V(() => i(n).map((l, u, M) => {
      var d;
      const N = M.map((g) => {
        var y, D;
        return (D = (y = g.cards) == null ? void 0 : y.length) != null ? D : 0;
      }).slice(0, u).reduce((g, y) => g + y, 0);
      return {
        name: l.name,
        cards: ((d = l.cards) != null ? d : []).map((g, y) => {
          var p;
          const D = {
            cover: g.cover,
            title: g.title,
            subDesc: g.view_at,
            progress: (p = g.view_history) == null ? void 0 : p.progress
          };
          return g.card_type === Ht.UgcHistoryNav ? {
            expose: De.showHistoryHoverCards(`${u}-${y}`, JSON.stringify({ sid: g.aid, pos: N + y })),
            card: ie(oe({}, D), {
              id: g.aid,
              type: "ugc",
              url: i(r(`video/${g.aid}`, `${Uo}=${a}`)),
              desc: g.author.nickname,
              maskText: g.duration
            })
          } : g.card_type === Ht.OgvHistoryNav ? {
            expose: De.showHistoryHoverCards(`${u}-${y}`, JSON.stringify({ sid: g.season_id, pos: N + y })),
            card: ie(oe({}, D), {
              id: g.season_id,
              type: "ogv",
              url: i(r(`play/${g.season_id}`, `${Uo}=${a}`)),
              desc: g.view_history.progress_text,
              maskText: g.index_show
            })
          } : null;
        })
      };
    })), s = (l, u, M) => {
      const N = i(c).map((d) => d.cards.length).slice(0, l).reduce((d, g) => d + g, 0);
      De.clickHistoryHoverCards({ pos: u + N, sid: M });
    };
    return (l, u) => (I(!0), S(Ae, null, we(i(c), (M, N) => (I(), S("div", {
      key: `${M.name}-${N}`,
      class: x(`${i(o)}__history`)
    }, [
      C("p", {
        class: x(`${i(o)}__history-title`)
      }, Z(M.name), 3),
      C("div", {
        class: x(`${i(o)}__history-list`)
      }, [
        (I(!0), S(Ae, null, we(M.cards, (d, g) => (I(), S(Ae, { key: g }, [
          d ? Ue((I(), _(i(xr), {
            key: 0,
            card: d.card,
            width: 139,
            "bold-title": !1,
            "bold-mask-text": !1,
            layout: "column",
            onClick: (y) => s(N, g, d.card.id)
          }, null, 8, ["card", "onClick"])), [
            [i(vn), d.expose]
          ]) : ee("", !0)
        ], 64))), 128))
      ], 2)
    ], 2))), 128));
  }
}));
const vM = () => {
  const { env: e, locale: t } = re(), n = Jt(i(e), i(t)), o = te([]), r = te(!1), a = fn(300, () => Le(void 0, null, function* () {
    var c;
    r.value = !0;
    try {
      const s = yield n.get("fav/nav_list");
      o.value = (c = s.cards) != null ? c : [];
    } catch (s) {
    } finally {
      r.value = !1;
    }
  }));
  return { fav: o, isFetching: r, fetchFav: a };
}, kM = {
  name: "PopoverFavList"
}, SM = /* @__PURE__ */ $(ie(oe({}, kM), {
  props: {
    items: null
  },
  setup(e) {
    const t = e, { items: n } = le(t), { classPrefix: o } = re(), { resolve: r } = Ke(), a = V(() => i(n).map((s, l) => {
      const u = {
        cover: s.cover,
        title: s.title
      };
      return s.card_type === Ht.UgcFavNav ? {
        expose: De.showFavHoverCards(`${s.aid}-${l}`, JSON.stringify({ sid: s.aid, pos: l })),
        card: ie(oe({}, u), {
          id: s.aid,
          type: "ugc",
          url: i(r(`video/${s.aid}`)),
          desc: s.author.nickname,
          maskText: s.duration
        })
      } : s.card_type === Ht.OgvFavNav ? {
        expose: De.showFavHoverCards(`${s.season_id}-${l}`, JSON.stringify({ sid: s.season_id, pos: l })),
        card: ie(oe({}, u), {
          id: s.season_id,
          type: "ogv",
          url: i(r(`play/${s.season_id}`)),
          desc: s.view_history.progress_text,
          maskText: s.index_show
        })
      } : null;
    })), c = (s, l) => {
      De.clickFavHoverCards({ pos: s, sid: l });
    };
    return (s, l) => (I(), S("div", {
      class: x(`${i(o)}__fav`)
    }, [
      (I(!0), S(Ae, null, we(i(a), (u, M) => (I(), S(Ae, {
        key: `${u == null ? void 0 : u.card.id}` - `${M}`
      }, [
        u ? Ue((I(), _(i(xr), {
          key: 0,
          card: u.card,
          width: 139,
          "bold-title": !1,
          "bold-mask-text": !1,
          layout: "column",
          onClick: (N) => c(M, u.card.id)
        }, null, 8, ["card", "onClick"])), [
          [i(vn), u.expose]
        ]) : ee("", !0)
      ], 64))), 128))
    ], 2));
  }
}));
const bM = ["href"], QM = {
  name: "Popover"
}, Ar = /* @__PURE__ */ $(ie(oe({}, QM), {
  props: {
    type: null,
    url: null,
    isLogin: { type: Boolean }
  },
  setup(e) {
    const t = e, { type: n, isLogin: o } = le(t), { histories: r, isFetching: a, isEmpty: c, fetchHistory: s } = zM(), { fav: l, isFetching: u, fetchFav: M } = vM(), { classPrefix: N, lang: d, onLogin: g } = re(), y = { history: !1, fav: !1 }, D = `${N}__popover`, p = te(!1), j = V(() => i(n) === "history"), A = V(() => i(n) === "fav"), w = V(() => {
      var k, q;
      return i(j) ? (k = i(d)) == null ? void 0 : k.syncHistory : i(A) ? (q = i(d)) == null ? void 0 : q.syncMyList : "";
    }), h = V(() => [
      D,
      {
        [`${D}--show`]: i(o)
      }
    ]), f = V(() => i(j) ? { loading: i(a), empty: i(c) } : i(A) ? { loading: i(u), empty: !i(l).length } : { loading: !1, empty: !1 }), E = () => Le(this, null, function* () {
      yield U(!0), p.value = !0;
    }), Y = () => Le(this, null, function* () {
      p.value = !1, yield U();
    }), R = () => {
      i(o) || g(), i(A) && De.clickFav(), i(j) && De.clickHistory();
    }, U = (k = !1) => Le(this, null, function* () {
      if (!i(o))
        return;
      switch (i(n)) {
        case "fav": {
          if (k && y.fav)
            return;
          yield M(), k && (y.fav = !0);
          break;
        }
        case "history": {
          if (k && y.history)
            return;
          yield s(), k && (y.history = !0);
          break;
        }
      }
    });
    return (k, q) => {
      var se, b, L;
      return I(), S("div", {
        class: x(i(h)),
        onMouseleave: Y
      }, [
        ce(ro, {
          url: e.url,
          icon: i(n),
          "is-button": !i(o),
          onClick: R,
          onHover: E
        }, null, 8, ["url", "icon", "is-button"]),
        p.value ? (I(), S("div", {
          key: 0,
          class: x(`${D}-content`)
        }, [
          i(o) ? (I(), S(Ae, { key: 1 }, [
            i(f).loading ? (I(), _(Cn, { key: 0 })) : i(f).empty ? (I(), S("p", {
              key: 1,
              class: x(`${D}-empty`)
            }, Z((b = i(d)) == null ? void 0 : b.nothing), 3)) : (I(), S("div", {
              key: 2,
              class: x(`${D}-body`)
            }, [
              C("div", {
                class: x(`${D}-list`)
              }, [
                i(j) ? (I(), _(LM, {
                  key: 0,
                  histories: i(r)
                }, null, 8, ["histories"])) : ee("", !0),
                i(A) ? (I(), _(SM, {
                  key: 1,
                  items: i(l)
                }, null, 8, ["items"])) : ee("", !0)
              ], 2),
              C("a", {
                href: e.url,
                class: x(`${D}-all`)
              }, Z((L = i(d)) == null ? void 0 : L.viewAll), 11, bM)
            ], 2))
          ], 64)) : (I(), S("div", {
            key: 0,
            class: x(`${D}-login`)
          }, [
            C("p", null, Z(i(w)), 1),
            C("button", {
              onClick: q[0] || (q[0] = //@ts-ignore
              (...O) => i(g) && i(g)(...O))
            }, Z((se = i(d)) == null ? void 0 : se.login), 1)
          ], 2))
        ], 2)) : ee("", !0)
      ], 34);
    };
  }
}));
const UM = () => {
  const { env: e, locale: t } = re(), n = Jt(i(e), i(t)), o = te(""), r = fn(300, () => Le(void 0, null, function* () {
    try {
      const { upload_badge: a } = yield n.get("badges");
      o.value = a;
    } catch (a) {
    }
  }));
  return { activities: o, fetchBadges: r };
}, BM = ["href"], YM = { key: 0 }, RM = {
  name: "Upload"
}, GM = /* @__PURE__ */ $(ie(oe({}, RM), {
  setup(e) {
    const { classPrefix: t, lang: n, config: o } = re(), { activities: r, fetchBadges: a } = UM(), c = De.showCreateHoverCards(), s = `${t}__upload`, l = V(() => `${i(o).studioUrl}`), u = V(() => `${i(o).studioUrl}/archive/new`), M = V(() => {
      var y, D, p;
      return [
        { icon: "videos", name: (y = i(n)) == null ? void 0 : y.myVideos, url: `${i(o).studioUrl}/archive-list`, pos: "my_videos" },
        { icon: "data", name: (D = i(n)) == null ? void 0 : D.dataAnalysis, url: `${i(o).studioUrl}/data-analysis`, pos: "data_analysis" },
        { icon: "interactions", name: (p = i(n)) == null ? void 0 : p.manageInteractions, url: `${i(o).studioUrl}/reply`, pos: "manage_interactions" }
      ];
    }), N = De.clickCreate, d = (y) => {
      De.clickCreateHoverCards(y);
    }, g = (y) => {
      y && a();
    };
    return (y, D) => (I(), _(Ln, { onShow: g }, {
      content: ye(() => [
        Ue((I(), S("div", {
          class: x(`${s}-content`)
        }, [
          C("div", {
            class: x(`${s}-content-header`)
          }, [
            ce(Xe, {
              icon: "upload",
              url: i(u),
              prefix: "",
              "new-window": "",
              onClick: D[1] || (D[1] = (p) => d("upload_video"))
            }, {
              default: ye(() => {
                var p;
                return [
                  C("span", {
                    class: x(`${s}-activity`)
                  }, [
                    fe(Z((p = i(n)) == null ? void 0 : p.uploadVideo) + " ", 1),
                    i(r) ? (I(), S("span", YM, Z(i(r)), 1)) : ee("", !0)
                  ], 2)
                ];
              }),
              _: 1
            }, 8, ["url"])
          ], 2),
          C("div", {
            class: x(`${s}-content-body`)
          }, [
            (I(!0), S(Ae, null, we(i(M), (p) => (I(), _(Xe, {
              key: p.icon,
              url: p.url,
              icon: p.icon,
              prefix: "",
              "new-window": "",
              onClick: (j) => d(p.pos)
            }, {
              default: ye(() => [
                fe(Z(p.name), 1)
              ]),
              _: 2
            }, 1032, ["url", "icon", "onClick"]))), 128))
          ], 2)
        ], 2)), [
          [i(vn), i(c)]
        ])
      ]),
      default: ye(() => [
        C("div", {
          class: x(s)
        }, [
          C("a", {
            href: i(l),
            class: x(`${s}-btn`),
            target: "_blank",
            onClick: D[0] || (D[0] = //@ts-ignore
            (...p) => i(N) && i(N)(...p))
          }, null, 10, BM)
        ])
      ]),
      _: 1
    }));
  }
}));
const PM = {
  name: "Actions"
}, FM = /* @__PURE__ */ $(ie(oe({}, PM), {
  props: {
    user: null,
    showSearch: { type: Boolean },
    showCreator: { type: Boolean },
    showDownload: { type: Boolean },
    onelinkUrl: { default: "" },
    showMore: { type: Boolean },
    showUser: { type: Boolean },
    showLoginPanel: { type: Boolean },
    showFeedback: { type: Boolean }
  },
  setup(e) {
    const t = e, { user: n } = le(t), { classPrefix: o, isMobile: r } = re(), { resolve: a } = Ke(), c = `${o}__actions`, s = te(!1), l = te(), u = V(() => [c, { [`${c}--mobile`]: i(r) }]), M = a("search"), N = a("history"), d = a("fav"), g = () => {
      De.clickSearch();
    }, y = (D) => {
      const p = i(l);
      p && (p === D.target || p.contains(D.target) || (s.value = !1));
    };
    return Ve(() => {
      i(r) && window.addEventListener("click", y), i(n) && Ot({ isLoad: !0 });
    }), In(() => {
      i(r) && window.removeEventListener("click", y);
    }), (D, p) => (I(), S("div", {
      class: x(i(u))
    }, [
      e.showSearch ? (I(), _(ro, {
        key: 0,
        url: i(M),
        icon: "search",
        onClick: g
      }, null, 8, ["url"])) : ee("", !0),
      e.showCreator && !i(r) ? (I(), _(GM, { key: 1 })) : ee("", !0),
      i(r) ? ee("", !0) : (I(), _(Ar, {
        key: 2,
        type: "history",
        url: i(N),
        "is-login": i(n) !== null
      }, null, 8, ["url", "is-login"])),
      i(r) ? ee("", !0) : (I(), _(Ar, {
        key: 3,
        type: "fav",
        url: i(d),
        "is-login": i(n) !== null
      }, null, 8, ["url", "is-login"])),
      e.showMore && !i(n) && !i(r) ? (I(), _(Ln, { key: 4 }, {
        content: ye(() => [
          ce(fi, { "show-feedback": e.showFeedback }, null, 8, ["show-feedback"])
        ]),
        default: ye(() => [
          ce(ro, {
            icon: "more",
            "is-button": ""
          })
        ]),
        _: 1
      })) : ee("", !0),
      i(r) ? ee("", !0) : (I(), _(cM, { key: 5 })),
      e.showUser && !i(r) ? (I(), _(xM, {
        key: 6,
        user: i(n),
        "show-panel": e.showLoginPanel,
        "show-feedback": e.showFeedback
      }, null, 8, ["user", "show-panel", "show-feedback"])) : ee("", !0),
      i(r) ? (I(), _(OM, {
        key: 7,
        "onelink-url": e.onelinkUrl
      }, null, 8, ["onelink-url"])) : ee("", !0)
    ], 2));
  }
}));
const HM = {
  name: "SiderLanguage"
}, VM = /* @__PURE__ */ $(ie(oe({}, HM), {
  props: {
    visiable: { type: Boolean }
  },
  emits: ["backClick"],
  setup(e, { emit: t }) {
    const n = e, { visiable: o } = le(n), { classPrefix: r, isMobile: a, locale: c, onLangChange: s, lang: l } = re(), u = `${r}__sider-lang`, M = V(() => [u, { [`${u}--mobile`]: i(a), visiable: i(o) }]), N = V(() => {
      var D;
      return (D = ft.find((p) => p.value === i(c))) == null ? void 0 : D.label;
    }), d = V(() => ft.map((D) => ie(oe({}, D), { selected: i(N) === D.label }))), g = () => {
      t("backClick");
    }, y = (D) => {
      D !== i(c) && s(D);
    };
    return (D, p) => {
      var j;
      return I(), S("div", {
        class: x(i(M))
      }, [
        C("div", {
          class: x(`${u}__header`)
        }, [
          ce(hn, {
            "show-back": !0,
            title: (j = i(l)) == null ? void 0 : j.chooseLang,
            onBackClick: g
          }, null, 8, ["title"])
        ], 2),
        C("div", {
          class: x(`${u}__list`)
        }, [
          (I(!0), S(Ae, null, we(i(d), (A) => (I(), _(Xe, {
            key: A.value,
            "is-button": "",
            suffix: "",
            large: "",
            icon: A.selected ? "selected" : "",
            onClick: (w) => y(A.value)
          }, {
            default: ye(() => [
              fe(Z(A.label), 1)
            ]),
            _: 2
          }, 1032, ["icon", "onClick"]))), 128))
        ], 2)
      ], 2);
    };
  }
}));
const ZM = {
  name: "SiderStructure"
}, WM = /* @__PURE__ */ $(ie(oe({}, ZM), {
  props: {
    visiable: { type: Boolean },
    title: null
  },
  emits: ["backClick"],
  setup(e, { emit: t }) {
    const n = e, { visiable: o } = le(n), { classPrefix: r, isMobile: a } = re(), c = `${r}__sider-structure`, s = V(() => [c, { [`${c}--mobile`]: i(a), visiable: i(o) }]), l = () => {
      t("backClick");
    };
    return (u, M) => (I(), S("div", {
      class: x(i(s))
    }, [
      C("div", {
        class: x(`${c}__header`)
      }, [
        ce(hn, {
          "show-back": !0,
          title: e.title,
          onBackClick: l
        }, null, 8, ["title"])
      ], 2),
      C("div", {
        class: x(`${c}__list`)
      }, [
        Ie(u.$slots, "content")
      ], 2)
    ], 2));
  }
}));
const JM = { class: "time" }, KM = /* @__PURE__ */ $({
  __name: "message-crad-mobile",
  props: {
    card: null
  },
  setup(e) {
    const t = e, { classPrefix: n } = re(), o = `${n}-message-card-mobile`, { card: r } = le(t), a = () => {
      const { card_uri: c } = i(r);
      c && window.open(c);
    };
    return (c, s) => (I(), S("div", {
      class: x([o]),
      onClick: a
    }, [
      i(r).cover ? (I(), S("div", {
        key: 0,
        class: x(`${o}__content-cover`)
      }, [
        ce(i(di), {
          src: i(r).cover,
          loading: "lazy",
          width: 686,
          height: 230
        }, null, 8, ["src"])
      ], 2)) : ee("", !0),
      ce(Nn, {
        texts: i(r).title_section,
        class: x(`${o}__top-title`)
      }, null, 8, ["texts", "class"]),
      ce(Nn, {
        texts: i(r).content_section,
        class: x(`${o}__content-text`)
      }, null, 8, ["texts", "class"]),
      C("div", JM, Z(i(r).pub_time), 1)
    ], 2));
  }
});
const qM = /* @__PURE__ */ $({
  __name: "message-content-mobile",
  props: {
    visiable: { type: Boolean }
  },
  setup(e) {
    const t = e, { getNextSystemNotify: n, messages: o, isMore: r, refresh: a, showLoading: c } = Ot(), { classPrefix: s } = re(), l = `${s}-message-content-mobile`, { visiable: u } = le(t);
    return mt(u, (M) => {
      M ? n() : setTimeout(() => {
        a();
      }, 300);
    }), (M, N) => i(o).length > 0 ? Ue((I(), S("div", {
      key: 0,
      class: x(l)
    }, [
      (I(!0), S(Ae, null, we(i(o), (d, g) => (I(), _(KM, { card: d }, null, 8, ["card"]))), 256))
    ])), [
      [i(pi), {
        callback: i(n),
        disabled: !i(r)
      }]
    ]) : (I(), S("div", {
      key: 1,
      class: x(`${l}-list-state`)
    }, [
      i(c) ? (I(), _(Cn, {
        key: 0,
        style: { "margin-top": "0" }
      })) : (I(), _(Ii, { key: 1 }))
    ], 2));
  }
});
const XM = ["href"], _M = ["href"], $M = ["href"], eg = {
  name: "SiderActions"
}, tg = /* @__PURE__ */ $(ie(oe({}, eg), {
  props: {
    user: null,
    visiable: { type: Boolean }
  },
  emits: ["close-sider"],
  setup(e, { emit: t }) {
    const n = e, { user: o, visiable: r } = le(n), {
      classPrefix: a,
      isMobile: c,
      isBstation: s,
      locale: l,
      lang: u,
      onLogout: M,
      onLogin: N
    } = re(), d = `${a}__sider-actions`, g = V(() => [d, { [`${d}--mobile`]: i(c), visiable: i(r) }]), { resolve: y } = Ke(), D = y("account/setting"), p = y("history"), j = "https://www.bilibili.tv/v/page/premium-benefits/index.html", A = y("fav"), w = V(() => {
      var b;
      return (b = ft.find((L) => L.value === i(l))) == null ? void 0 : b.label;
    }), h = te(!1), f = (b) => {
      h.value = b != null ? b : !i(h);
    }, E = te(!1), Y = (b) => {
      E.value = b != null ? b : !i(E);
    }, R = () => {
      De.clickHistory();
    }, U = () => {
      De.clickPremium();
    }, k = () => {
      De.clickFav();
    }, q = () => {
      Y(!0);
    }, se = () => {
      t("close-sider");
    };
    return (b, L) => {
      var O, G, v, F, z, J, ne, H;
      return I(), S("div", {
        class: x(i(g))
      }, [
        C("div", {
          class: x(`${d}__header`)
        }, [
          ce(hn, {
            "show-back": !0,
            "is-bstation": i(s),
            onBackClick: se
          }, null, 8, ["is-bstation"])
        ], 2),
        i(o) ? (I(), S("div", {
          key: 0,
          class: x(`${d}__list`)
        }, [
          C("a", {
            class: x(`${d}__btn fav`),
            href: i(A),
            onClick: k
          }, Z((O = i(u)) == null ? void 0 : O.fav), 11, XM),
          C("a", {
            class: x(`${d}__btn history`),
            href: i(p),
            onClick: R
          }, Z((G = i(u)) == null ? void 0 : G.history), 11, _M),
          C("a", {
            class: x(`${d}__btn premium`),
            href: j,
            target: "_blank",
            onClick: U
          }, Z((v = i(u)) == null ? void 0 : v.premium), 3),
          C("a", {
            class: x(`${d}__btn profile`),
            href: i(D)
          }, Z((F = i(u)) == null ? void 0 : F.myProfile), 11, $M),
          ce(Cr, {
            "is-mobile": "",
            visiable: i(r),
            onClick: f
          }, null, 8, ["visiable"])
        ], 2)) : ee("", !0),
        C("div", {
          class: x(`${d}__lang`)
        }, [
          C("button", {
            class: x(`${d}__btn lang`),
            onClick: q
          }, Z((z = i(u)) == null ? void 0 : z.language) + ": " + Z(i(w)), 3)
        ], 2),
        C("div", {
          class: x(`${d}__footer`)
        }, [
          i(o) ? (I(), S("button", {
            key: 0,
            class: x(`${d}__btn logout`),
            onClick: L[0] || (L[0] = //@ts-ignore
            (...P) => i(M) && i(M)(...P))
          }, [
            ce(Rt, {
              avatar: i(o).avatar,
              name: i(o).name,
              width: 24
            }, null, 8, ["avatar", "name"]),
            fe(" " + Z((J = i(u)) == null ? void 0 : J.logout), 1)
          ], 2)) : (I(), S("button", {
            key: 1,
            class: x(`${d}__login`),
            onClick: L[1] || (L[1] = //@ts-ignore
            (...P) => i(N) && i(N)(...P))
          }, Z((ne = i(u)) == null ? void 0 : ne.login), 3))
        ], 2),
        i(c) ? (I(), _(It, {
          key: 1,
          to: "body"
        }, [
          ce(VM, {
            visiable: E.value,
            onBackClick: L[2] || (L[2] = (P) => Y(!1))
          }, null, 8, ["visiable"])
        ])) : ee("", !0),
        (I(), _(It, { to: "body" }, [
          ce(WM, {
            title: (H = i(u)) == null ? void 0 : H.message,
            visiable: h.value,
            onBackClick: L[3] || (L[3] = (P) => f(!1))
          }, {
            content: ye(() => [
              ce(qM, { visiable: h.value }, null, 8, ["visiable"])
            ]),
            _: 1
          }, 8, ["title", "visiable"])
        ]))
      ], 2);
    };
  }
}));
const Eo = () => ({ remove: (n) => {
  const o = gt.getSearchHistory();
  if (!o.length)
    return [];
  const r = [...o.slice(0, n), ...o.slice(n + 1)];
  return gt.setSearchHistory(r), r;
}, save: (n) => {
  const o = gt.getSearchHistory();
  o.includes(n) || gt.setSearchHistory([...o, n].slice(-10));
}, read: gt.getSearchHistory }), ng = () => {
  const { env: e, locale: t } = re(), n = Jt(i(e), i(t)), o = te(null), r = te(null), a = te(!1), c = te(""), s = V(() => i(c).length > 0), l = (N) => Le(void 0, null, function* () {
    try {
      r.value = yield n.get("search_v2/suggest", { keyword: encodeURIComponent(N) });
    } catch (d) {
    }
  }), u = () => Le(void 0, null, function* () {
    a.value = !0;
    try {
      const d = (yield n.get("search/square")).find((g) => g.type === hi.hot);
      d && (o.value = d);
    } catch (N) {
    } finally {
      a.value = !1;
    }
  }), M = fn(300, l);
  return {
    top: o,
    suggests: r,
    keyword: c,
    showSuggest: s,
    isFetchingTop: a,
    searchInput: M,
    fetchSquare: u
  };
}, og = ["placeholder", "onKeydown"], rg = {
  name: "SearchBar"
}, ig = /* @__PURE__ */ $(ie(oe({}, rg), {
  props: {
    modelValue: null
  },
  emits: ["click", "input", "search", "update:modelValue"],
  setup(e, { emit: t }) {
    const { classPrefix: n, lang: o } = re(), { save: r } = Eo(), a = Pi.inBrowser ? null : Qi(), c = `${n}-search-bar`, s = te(""), l = te(!1), u = V(() => [c, { [`${c}--focus`]: i(l) }]), M = V(() => {
      var p;
      return (p = i(o)) == null ? void 0 : p.searchPlaceholder;
    }), N = () => {
      t("input", s.value), t("update:modelValue", s.value);
    }, d = () => {
      s.value.trim() !== "" && (r(s.value), t("search", s.value));
    }, g = () => {
      t("click");
    }, y = () => {
      l.value = !0;
    }, D = () => {
      l.value = !1;
    };
    return Ui(() => {
      var p, j;
      s.value = (j = (p = a == null ? void 0 : a.query) == null ? void 0 : p.q) != null ? j : "";
    }), Ve(() => {
      var p;
      if (typeof window != "undefined" && s.value === "") {
        const j = new URL(window.location.href);
        s.value = (p = j.searchParams.get("q")) != null ? p : "";
      }
    }), (p, j) => (I(), S("div", {
      class: x(i(u))
    }, [
      Ue(C("input", {
        "onUpdate:modelValue": j[0] || (j[0] = (A) => s.value = A),
        type: "text",
        class: x(`${c}__input`),
        placeholder: i(M),
        onInput: N,
        onKeydown: hr(d, ["enter"]),
        onClick: g,
        onFocus: y,
        onBlur: D
      }, null, 42, og), [
        [jr, s.value]
      ]),
      C("div", {
        class: x(`${c}__btn`)
      }, [
        C("button", { onClick: d })
      ], 2)
    ], 2));
  }
}));
const ag = {
  name: "SearchSuggestItem"
}, sg = /* @__PURE__ */ $(ie(oe({}, ag), {
  props: {
    item: null,
    isHistory: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const { classPrefix: n } = re(), o = `${n}-search-suggest__item`, r = () => {
      t("click");
    };
    return (a, c) => (I(), S("span", {
      class: x([o, { [`${o}--history`]: e.isHistory }]),
      onClick: r
    }, [
      (I(!0), S(Ae, null, we(e.item, (s, l) => (I(), S("em", {
        key: l,
        class: x({ [`${o}--keyword`]: s.match })
      }, Z(s.str), 3))), 128))
    ], 2));
  }
}));
const cg = {
  name: "Empty"
}, lg = /* @__PURE__ */ $(ie(oe({}, cg), {
  setup(e) {
    const { classPrefix: t, lang: n } = re();
    return (o, r) => {
      var a;
      return I(), S("div", {
        class: x(`${i(t)}__empty`)
      }, [
        C("p", null, Z((a = i(n)) == null ? void 0 : a.noResult), 1)
      ], 2);
    };
  }
}));
const ug = /* @__PURE__ */ wn(lg, [["__scopeId", "data-v-556e3e48"]]), Mg = {
  name: "SearchSuggest"
}, gg = /* @__PURE__ */ $(ie(oe({}, Mg), {
  props: {
    data: null
  },
  emits: ["search"],
  setup(e, { emit: t }) {
    const n = e, { data: o } = le(n), { save: r, read: a } = Eo(), { classPrefix: c } = re(), s = a(), l = V(() => {
      var N, d;
      return ((d = (N = i(o)) == null ? void 0 : N.items) != null ? d : []).map((g) => ie(oe({}, g), { isHistory: s.includes(g.keyword) }));
    }), u = V(() => i(l).length === 0), M = (N) => {
      var g, y;
      const d = i(l)[N];
      d && (De.clickSearchSug({
        pos: N,
        keyword: d.keyword,
        track_id: (y = (g = o.value) == null ? void 0 : g.track_id) != null ? y : ""
      }), d.keyword.trim() !== "" && (r(d.keyword), t("search", d.keyword)));
    };
    return (N, d) => i(u) ? (I(), _(ug, { key: 0 })) : (I(), S("ul", {
      key: 1,
      class: x(`${i(c)}-search-suggests`)
    }, [
      (I(!0), S(Ae, null, we(i(l), (g, y) => (I(), S("li", { key: y }, [
        ce(sg, {
          item: g.match,
          "is-history": g.isHistory,
          onClick: (D) => M(y)
        }, null, 8, ["item", "is-history", "onClick"])
      ]))), 128))
    ], 2));
  }
}));
const yg = ["onClick"], dg = ["onClick"], Ng = {
  name: "SearchHistory"
}, Ag = /* @__PURE__ */ $(ie(oe({}, Ng), {
  emits: ["click"],
  setup(e, { emit: t }) {
    const { classPrefix: n, lang: o } = re(), { read: r, remove: a } = Eo(), c = `${n}-search-history`, s = te([]), l = (M) => {
      const N = s.value[M];
      N && (De.clickSearchHistory({
        keyword: N,
        pos: M,
        track_id: ""
      }), t("click", N));
    }, u = (M) => {
      s.value = a(M);
    };
    return Ve(() => {
      s.value = r();
    }), (M, N) => {
      var d;
      return s.value.length > 0 ? (I(), S("div", {
        key: 0,
        class: x(c)
      }, [
        C("p", {
          class: x(`${c}__title`)
        }, Z((d = i(o)) == null ? void 0 : d.searchHistory), 3),
        C("ul", {
          class: x(`${c}__list`)
        }, [
          (I(!0), S(Ae, null, we(s.value, (g, y) => (I(), S("li", {
            key: y,
            class: x(`${c}__item`),
            onClick: (D) => l(y)
          }, [
            C("span", {
              class: x(`${c}__text`)
            }, Z(g), 3),
            C("button", {
              class: x(`${c}__btn`),
              onClick: ao((D) => u(y), ["stop"])
            }, null, 10, dg)
          ], 10, yg))), 128))
        ], 2)
      ])) : ee("", !0);
    };
  }
}));
const Dg = ["href"], pg = ["src", "alt"], Ig = ["href"], fg = {
  name: "SearchTopCard"
}, jg = /* @__PURE__ */ $(ie(oe({}, fg), {
  props: {
    item: null
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, { item: o } = le(n), { resolve: r } = Ke(), { classPrefix: a } = re(), c = `${a}-search-top-card`, s = V(() => r(`play/${o.value.season_id}`).value), l = V(() => Tr(i(o).image, 80, 104, !0)), u = () => {
      t("click", o.value);
    };
    return (M, N) => (I(), S("div", {
      class: x(c)
    }, [
      C("a", {
        class: x(`${c}__cover`),
        href: i(s),
        target: "_blank",
        onClick: u
      }, [
        C("img", {
          src: i(l),
          alt: i(o).title
        }, null, 8, pg)
      ], 10, Dg),
      C("div", {
        class: x(`${c}__text`)
      }, [
        C("a", {
          class: x(`${c}__title`),
          href: i(s),
          target: "_blank",
          onClick: u
        }, Z(i(o).title), 11, Ig),
        C("p", {
          class: x(`${c}__desc`)
        }, Z(i(o).desc), 3)
      ], 2)
    ]));
  }
}));
const hg = {
  name: "SearchTop"
}, wg = /* @__PURE__ */ $(ie(oe({}, hg), {
  props: {
    data: null
  },
  setup(e) {
    const t = e, { data: n } = le(t), { classPrefix: o } = re(), r = (a, c) => {
      De.clickSearchHotKeyword({
        pos: c,
        sid: parseInt(a.season_id),
        track_id: n.value.track_id
      });
    };
    return (a, c) => (I(), S("div", {
      class: x(`${i(o)}-search-top`)
    }, [
      (I(!0), S(Ae, null, we(i(n).data.list, (s, l) => (I(), _(jg, {
        key: s.season_id,
        item: s,
        onClick: (u) => r(u, l)
      }, null, 8, ["item", "onClick"]))), 128))
    ], 2));
  }
}));
const Eg = {
  name: "SearchRecommend"
}, Tg = /* @__PURE__ */ $(ie(oe({}, Eg), {
  props: {
    top: null,
    loading: { type: Boolean }
  },
  emits: ["search"],
  setup(e, { emit: t }) {
    const { classPrefix: n } = re(), o = (r) => {
      t("search", r);
    };
    return (r, a) => (I(), S("div", {
      class: x(`${i(n)}-search-recommend`)
    }, [
      ce(Ag, { onClick: o }),
      e.loading ? (I(), _(Cn, { key: 0 })) : e.top ? (I(), _(wg, {
        key: 1,
        data: e.top
      }, null, 8, ["data"])) : ee("", !0)
    ], 2));
  }
}));
const xg = {
  name: "Search"
}, mg = /* @__PURE__ */ $(ie(oe({}, xg), {
  setup(e) {
    const { classPrefix: t } = re(), { keyword: n, showSuggest: o, top: r, suggests: a, isFetchingTop: c, fetchSquare: s, searchInput: l } = ng(), { toUrl: u } = Ke(), M = `${t}-search`, N = te(null), d = te(!1), g = (j) => {
      if (!j) {
        d.value = !1;
        return;
      }
      d.value = !0, l(j);
    }, y = () => {
      i(d) || (d.value = !0, s());
    }, D = (j) => {
      N.value && (N.value === j.target || N.value.contains(j.target) || (d.value = !1));
    }, p = (j) => {
      u("search-result", `q=${encodeURIComponent(j)}`), De.clickSearch();
    };
    return Ve(() => {
      window.addEventListener("click", D);
    }), In(() => {
      window.removeEventListener("click", D);
    }), (j, A) => (I(), S("div", {
      ref_key: "container",
      ref: N,
      class: x(M)
    }, [
      ce(ig, {
        modelValue: i(n),
        "onUpdate:modelValue": A[0] || (A[0] = (w) => Bi(n) ? n.value = w : null),
        onInput: g,
        onClick: y,
        onSearch: p
      }, null, 8, ["modelValue"]),
      d.value ? (I(), S("div", {
        key: 0,
        class: x(`${M}__popup`)
      }, [
        i(o) ? (I(), _(gg, {
          key: 0,
          data: i(a),
          onSearch: p
        }, null, 8, ["data"])) : (I(), _(Tg, {
          key: 1,
          top: i(r),
          loading: i(c),
          onSearch: p
        }, null, 8, ["top", "loading"]))
      ], 2)) : ee("", !0)
    ], 512));
  }
}));
const Og = {
  name: "BHeader"
}, zg = /* @__PURE__ */ $(ie(oe({}, Og), {
  props: {
    env: { default: "prod" },
    locale: null,
    user: null,
    isMobile: { type: [Boolean, null] },
    isBstation: { type: Boolean, default: !1 },
    showMenu: { type: Boolean, default: !0 },
    showSearch: { type: Boolean, default: !0 },
    showCreator: { type: Boolean, default: !0 },
    showDownload: { type: Boolean, default: !0 },
    openappLink: null,
    showMore: { type: Boolean, default: !0 },
    showUser: { type: Boolean, default: !0 },
    showLoginPanel: { type: Boolean, default: !1 },
    showFeedback: { type: Boolean, default: !0 },
    manualExit: { type: Boolean, default: !1 }
  },
  emits: ["menuClick", "langChange", "logout", "feedback"],
  setup(e, { emit: t }) {
    const n = e, { env: o, locale: r, isMobile: a, isBstation: c, manualExit: s } = le(n), l = Jt(i(o), i(r), !0), u = "bstar-header", M = V(() => [u, { [`${u}--mobile`]: i(a) }]), N = () => {
      i(a) ? g(!0) : t("menuClick");
    }, d = te(!1), g = (A) => {
      d.value = A != null ? A : !i(d);
    };
    return Xi({
      classPrefix: u,
      env: o,
      locale: r,
      isMobile: a,
      isBstation: c,
      onLogout: () => Le(this, null, function* () {
        try {
          const A = Yi.get("bili_jct"), { go_url: w } = yield l.postForm("login/exit", { csrf: A }), h = new URL(w);
          h.searchParams.set("go_url", encodeURIComponent(location.href)), i(s) ? t("logout", w) : location.href = h.toString();
        } catch (A) {
        }
      }),
      onLogin: () => {
        typeof window != "undefined" && window.postMessage({ name: "bstar-header-login" }, "*");
      },
      onLangChange: (A) => {
        De.clickLangSetting(), t("langChange", A);
      },
      onSendFeedback: () => {
        t("feedback");
      }
    }), (A, w) => (I(), S("header", {
      class: x(i(M))
    }, [
      ce(hn, {
        "show-menu": e.showMenu,
        "is-bstation": i(c),
        onMenuClick: N
      }, null, 8, ["show-menu", "is-bstation"]),
      e.showSearch && !i(a) ? (I(), S("div", {
        key: 0,
        class: x(`${u}__center`)
      }, [
        ce(mg)
      ], 2)) : ee("", !0),
      ce(FM, {
        user: e.user,
        "show-search": e.showSearch,
        "show-creator": e.showCreator,
        "show-more": e.showMore,
        "show-user": e.showUser,
        "show-download": e.showDownload,
        "onelink-url": e.openappLink,
        "show-login-panel": e.showLoginPanel,
        "show-feedback": e.showFeedback
      }, null, 8, ["user", "show-search", "show-creator", "show-more", "show-user", "show-download", "onelink-url", "show-login-panel", "show-feedback"]),
      i(a) ? (I(), _(It, {
        key: 1,
        to: "body"
      }, [
        ce(tg, {
          user: e.user,
          visiable: d.value,
          onCloseSider: w[0] || (w[0] = (h) => g(!1))
        }, null, 8, ["user", "visiable"])
      ])) : ee("", !0)
    ], 2));
  }
}));
const Ug = (e, t) => {
  const n = te(t.user), o = te(!1), r = V(() => ie(oe({}, t), { user: i(n), showLoginPanel: i(o) })), a = (l) => {
    n.value = l, s();
  }, c = () => {
    o.value = !0, s();
  }, s = () => {
    const l = Er(zg, i(r)), u = document.getElementById(e);
    u && qn(l, u);
  };
  return { renderHeader: s, changeUser: a, showLoginPanel: c };
};
export {
  zg as BHeader,
  Ug as useRenderHeader
};
//# sourceMappingURL=b-header.es.js.map
